/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.BullBullGame = (function() {

    /**
     * Namespace BullBullGame.
     * @exports BullBullGame
     * @namespace
     */
    var BullBullGame = {};

    BullBullGame.Poker = (function() {

        /**
         * Properties of a Poker.
         * @memberof BullBullGame
         * @interface IPoker
         * @property {string} number Poker number
         * @property {string} colour Poker colour
         */

        /**
         * Constructs a new Poker.
         * @memberof BullBullGame
         * @classdesc Represents a Poker.
         * @implements IPoker
         * @constructor
         * @param {BullBullGame.IPoker=} [properties] Properties to set
         */
        function Poker(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Poker number.
         * @member {string} number
         * @memberof BullBullGame.Poker
         * @instance
         */
        Poker.prototype.number = "";

        /**
         * Poker colour.
         * @member {string} colour
         * @memberof BullBullGame.Poker
         * @instance
         */
        Poker.prototype.colour = "";

        /**
         * Creates a new Poker instance using the specified properties.
         * @function create
         * @memberof BullBullGame.Poker
         * @static
         * @param {BullBullGame.IPoker=} [properties] Properties to set
         * @returns {BullBullGame.Poker} Poker instance
         */
        Poker.create = function create(properties) {
            return new Poker(properties);
        };

        /**
         * Encodes the specified Poker message. Does not implicitly {@link BullBullGame.Poker.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.Poker
         * @static
         * @param {BullBullGame.IPoker} message Poker message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Poker.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.number);
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.colour);
            return writer;
        };

        /**
         * Encodes the specified Poker message, length delimited. Does not implicitly {@link BullBullGame.Poker.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.Poker
         * @static
         * @param {BullBullGame.IPoker} message Poker message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Poker.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Poker message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.Poker
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.Poker} Poker
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Poker.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.Poker();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.number = reader.string();
                    break;
                case 2:
                    message.colour = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("number"))
                throw $util.ProtocolError("missing required 'number'", { instance: message });
            if (!message.hasOwnProperty("colour"))
                throw $util.ProtocolError("missing required 'colour'", { instance: message });
            return message;
        };

        /**
         * Decodes a Poker message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.Poker
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.Poker} Poker
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Poker.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Poker message.
         * @function verify
         * @memberof BullBullGame.Poker
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Poker.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.number))
                return "number: string expected";
            if (!$util.isString(message.colour))
                return "colour: string expected";
            return null;
        };

        /**
         * Creates a Poker message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.Poker
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.Poker} Poker
         */
        Poker.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.Poker)
                return object;
            var message = new $root.BullBullGame.Poker();
            if (object.number != null)
                message.number = String(object.number);
            if (object.colour != null)
                message.colour = String(object.colour);
            return message;
        };

        /**
         * Creates a plain object from a Poker message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.Poker
         * @static
         * @param {BullBullGame.Poker} message Poker
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Poker.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.number = "";
                object.colour = "";
            }
            if (message.number != null && message.hasOwnProperty("number"))
                object.number = message.number;
            if (message.colour != null && message.hasOwnProperty("colour"))
                object.colour = message.colour;
            return object;
        };

        /**
         * Converts this Poker to JSON.
         * @function toJSON
         * @memberof BullBullGame.Poker
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Poker.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Poker;
    })();

    BullBullGame.DealPokerRsp = (function() {

        /**
         * Properties of a DealPokerRsp.
         * @memberof BullBullGame
         * @interface IDealPokerRsp
         * @property {number} type DealPokerRsp type
         * @property {Array.<BullBullGame.IPoker>|null} [pokers] DealPokerRsp pokers
         */

        /**
         * Constructs a new DealPokerRsp.
         * @memberof BullBullGame
         * @classdesc Represents a DealPokerRsp.
         * @implements IDealPokerRsp
         * @constructor
         * @param {BullBullGame.IDealPokerRsp=} [properties] Properties to set
         */
        function DealPokerRsp(properties) {
            this.pokers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DealPokerRsp type.
         * @member {number} type
         * @memberof BullBullGame.DealPokerRsp
         * @instance
         */
        DealPokerRsp.prototype.type = 0;

        /**
         * DealPokerRsp pokers.
         * @member {Array.<BullBullGame.IPoker>} pokers
         * @memberof BullBullGame.DealPokerRsp
         * @instance
         */
        DealPokerRsp.prototype.pokers = $util.emptyArray;

        /**
         * Creates a new DealPokerRsp instance using the specified properties.
         * @function create
         * @memberof BullBullGame.DealPokerRsp
         * @static
         * @param {BullBullGame.IDealPokerRsp=} [properties] Properties to set
         * @returns {BullBullGame.DealPokerRsp} DealPokerRsp instance
         */
        DealPokerRsp.create = function create(properties) {
            return new DealPokerRsp(properties);
        };

        /**
         * Encodes the specified DealPokerRsp message. Does not implicitly {@link BullBullGame.DealPokerRsp.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.DealPokerRsp
         * @static
         * @param {BullBullGame.IDealPokerRsp} message DealPokerRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DealPokerRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
            if (message.pokers != null && message.pokers.length)
                for (var i = 0; i < message.pokers.length; ++i)
                    $root.BullBullGame.Poker.encode(message.pokers[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified DealPokerRsp message, length delimited. Does not implicitly {@link BullBullGame.DealPokerRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.DealPokerRsp
         * @static
         * @param {BullBullGame.IDealPokerRsp} message DealPokerRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DealPokerRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DealPokerRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.DealPokerRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.DealPokerRsp} DealPokerRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DealPokerRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.DealPokerRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    if (!(message.pokers && message.pokers.length))
                        message.pokers = [];
                    message.pokers.push($root.BullBullGame.Poker.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            return message;
        };

        /**
         * Decodes a DealPokerRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.DealPokerRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.DealPokerRsp} DealPokerRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DealPokerRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DealPokerRsp message.
         * @function verify
         * @memberof BullBullGame.DealPokerRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DealPokerRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.type))
                return "type: integer expected";
            if (message.pokers != null && message.hasOwnProperty("pokers")) {
                if (!Array.isArray(message.pokers))
                    return "pokers: array expected";
                for (var i = 0; i < message.pokers.length; ++i) {
                    var error = $root.BullBullGame.Poker.verify(message.pokers[i]);
                    if (error)
                        return "pokers." + error;
                }
            }
            return null;
        };

        /**
         * Creates a DealPokerRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.DealPokerRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.DealPokerRsp} DealPokerRsp
         */
        DealPokerRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.DealPokerRsp)
                return object;
            var message = new $root.BullBullGame.DealPokerRsp();
            if (object.type != null)
                message.type = object.type | 0;
            if (object.pokers) {
                if (!Array.isArray(object.pokers))
                    throw TypeError(".BullBullGame.DealPokerRsp.pokers: array expected");
                message.pokers = [];
                for (var i = 0; i < object.pokers.length; ++i) {
                    if (typeof object.pokers[i] !== "object")
                        throw TypeError(".BullBullGame.DealPokerRsp.pokers: object expected");
                    message.pokers[i] = $root.BullBullGame.Poker.fromObject(object.pokers[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a DealPokerRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.DealPokerRsp
         * @static
         * @param {BullBullGame.DealPokerRsp} message DealPokerRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DealPokerRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.pokers = [];
            if (options.defaults)
                object.type = 0;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.pokers && message.pokers.length) {
                object.pokers = [];
                for (var j = 0; j < message.pokers.length; ++j)
                    object.pokers[j] = $root.BullBullGame.Poker.toObject(message.pokers[j], options);
            }
            return object;
        };

        /**
         * Converts this DealPokerRsp to JSON.
         * @function toJSON
         * @memberof BullBullGame.DealPokerRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DealPokerRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DealPokerRsp;
    })();

    BullBullGame.TimeoutNotify = (function() {

        /**
         * Properties of a TimeoutNotify.
         * @memberof BullBullGame
         * @interface ITimeoutNotify
         * @property {number|null} [timeout] TimeoutNotify timeout
         * @property {number|null} [event] TimeoutNotify event
         * @property {number|null} [playerId] TimeoutNotify playerId
         * @property {number|null} [totalTimeout] TimeoutNotify totalTimeout
         * @property {number|null} [ackId] TimeoutNotify ackId
         */

        /**
         * Constructs a new TimeoutNotify.
         * @memberof BullBullGame
         * @classdesc Represents a TimeoutNotify.
         * @implements ITimeoutNotify
         * @constructor
         * @param {BullBullGame.ITimeoutNotify=} [properties] Properties to set
         */
        function TimeoutNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TimeoutNotify timeout.
         * @member {number} timeout
         * @memberof BullBullGame.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.timeout = 0;

        /**
         * TimeoutNotify event.
         * @member {number} event
         * @memberof BullBullGame.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.event = 0;

        /**
         * TimeoutNotify playerId.
         * @member {number} playerId
         * @memberof BullBullGame.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.playerId = 0;

        /**
         * TimeoutNotify totalTimeout.
         * @member {number} totalTimeout
         * @memberof BullBullGame.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.totalTimeout = 0;

        /**
         * TimeoutNotify ackId.
         * @member {number} ackId
         * @memberof BullBullGame.TimeoutNotify
         * @instance
         */
        TimeoutNotify.prototype.ackId = 0;

        /**
         * Creates a new TimeoutNotify instance using the specified properties.
         * @function create
         * @memberof BullBullGame.TimeoutNotify
         * @static
         * @param {BullBullGame.ITimeoutNotify=} [properties] Properties to set
         * @returns {BullBullGame.TimeoutNotify} TimeoutNotify instance
         */
        TimeoutNotify.create = function create(properties) {
            return new TimeoutNotify(properties);
        };

        /**
         * Encodes the specified TimeoutNotify message. Does not implicitly {@link BullBullGame.TimeoutNotify.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.TimeoutNotify
         * @static
         * @param {BullBullGame.ITimeoutNotify} message TimeoutNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeoutNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.timeout != null && message.hasOwnProperty("timeout"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.timeout);
            if (message.event != null && message.hasOwnProperty("event"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.event);
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.playerId);
            if (message.totalTimeout != null && message.hasOwnProperty("totalTimeout"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.totalTimeout);
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ackId);
            return writer;
        };

        /**
         * Encodes the specified TimeoutNotify message, length delimited. Does not implicitly {@link BullBullGame.TimeoutNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.TimeoutNotify
         * @static
         * @param {BullBullGame.ITimeoutNotify} message TimeoutNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeoutNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TimeoutNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.TimeoutNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.TimeoutNotify} TimeoutNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeoutNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.TimeoutNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.timeout = reader.int32();
                    break;
                case 2:
                    message.event = reader.int32();
                    break;
                case 3:
                    message.playerId = reader.uint32();
                    break;
                case 5:
                    message.totalTimeout = reader.int32();
                    break;
                case 6:
                    message.ackId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TimeoutNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.TimeoutNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.TimeoutNotify} TimeoutNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeoutNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TimeoutNotify message.
         * @function verify
         * @memberof BullBullGame.TimeoutNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TimeoutNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.timeout != null && message.hasOwnProperty("timeout"))
                if (!$util.isInteger(message.timeout))
                    return "timeout: integer expected";
            if (message.event != null && message.hasOwnProperty("event"))
                if (!$util.isInteger(message.event))
                    return "event: integer expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.totalTimeout != null && message.hasOwnProperty("totalTimeout"))
                if (!$util.isInteger(message.totalTimeout))
                    return "totalTimeout: integer expected";
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                if (!$util.isInteger(message.ackId))
                    return "ackId: integer expected";
            return null;
        };

        /**
         * Creates a TimeoutNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.TimeoutNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.TimeoutNotify} TimeoutNotify
         */
        TimeoutNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.TimeoutNotify)
                return object;
            var message = new $root.BullBullGame.TimeoutNotify();
            if (object.timeout != null)
                message.timeout = object.timeout | 0;
            if (object.event != null)
                message.event = object.event | 0;
            if (object.playerId != null)
                message.playerId = object.playerId >>> 0;
            if (object.totalTimeout != null)
                message.totalTimeout = object.totalTimeout | 0;
            if (object.ackId != null)
                message.ackId = object.ackId | 0;
            return message;
        };

        /**
         * Creates a plain object from a TimeoutNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.TimeoutNotify
         * @static
         * @param {BullBullGame.TimeoutNotify} message TimeoutNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TimeoutNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.timeout = 0;
                object.event = 0;
                object.playerId = 0;
                object.totalTimeout = 0;
                object.ackId = 0;
            }
            if (message.timeout != null && message.hasOwnProperty("timeout"))
                object.timeout = message.timeout;
            if (message.event != null && message.hasOwnProperty("event"))
                object.event = message.event;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.totalTimeout != null && message.hasOwnProperty("totalTimeout"))
                object.totalTimeout = message.totalTimeout;
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                object.ackId = message.ackId;
            return object;
        };

        /**
         * Converts this TimeoutNotify to JSON.
         * @function toJSON
         * @memberof BullBullGame.TimeoutNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TimeoutNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TimeoutNotify;
    })();

    BullBullGame.ComputePokerReq = (function() {

        /**
         * Properties of a ComputePokerReq.
         * @memberof BullBullGame
         * @interface IComputePokerReq
         */

        /**
         * Constructs a new ComputePokerReq.
         * @memberof BullBullGame
         * @classdesc Represents a ComputePokerReq.
         * @implements IComputePokerReq
         * @constructor
         * @param {BullBullGame.IComputePokerReq=} [properties] Properties to set
         */
        function ComputePokerReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ComputePokerReq instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ComputePokerReq
         * @static
         * @param {BullBullGame.IComputePokerReq=} [properties] Properties to set
         * @returns {BullBullGame.ComputePokerReq} ComputePokerReq instance
         */
        ComputePokerReq.create = function create(properties) {
            return new ComputePokerReq(properties);
        };

        /**
         * Encodes the specified ComputePokerReq message. Does not implicitly {@link BullBullGame.ComputePokerReq.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ComputePokerReq
         * @static
         * @param {BullBullGame.IComputePokerReq} message ComputePokerReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComputePokerReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ComputePokerReq message, length delimited. Does not implicitly {@link BullBullGame.ComputePokerReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ComputePokerReq
         * @static
         * @param {BullBullGame.IComputePokerReq} message ComputePokerReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComputePokerReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ComputePokerReq message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ComputePokerReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ComputePokerReq} ComputePokerReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComputePokerReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ComputePokerReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ComputePokerReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ComputePokerReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ComputePokerReq} ComputePokerReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComputePokerReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ComputePokerReq message.
         * @function verify
         * @memberof BullBullGame.ComputePokerReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ComputePokerReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ComputePokerReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ComputePokerReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ComputePokerReq} ComputePokerReq
         */
        ComputePokerReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ComputePokerReq)
                return object;
            return new $root.BullBullGame.ComputePokerReq();
        };

        /**
         * Creates a plain object from a ComputePokerReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ComputePokerReq
         * @static
         * @param {BullBullGame.ComputePokerReq} message ComputePokerReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComputePokerReq.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ComputePokerReq to JSON.
         * @function toJSON
         * @memberof BullBullGame.ComputePokerReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComputePokerReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComputePokerReq;
    })();

    BullBullGame.ComputePokerRsp = (function() {

        /**
         * Properties of a ComputePokerRsp.
         * @memberof BullBullGame
         * @interface IComputePokerRsp
         * @property {string} comboType ComputePokerRsp comboType
         * @property {Array.<BullBullGame.IPoker>|null} [pokers] ComputePokerRsp pokers
         */

        /**
         * Constructs a new ComputePokerRsp.
         * @memberof BullBullGame
         * @classdesc Represents a ComputePokerRsp.
         * @implements IComputePokerRsp
         * @constructor
         * @param {BullBullGame.IComputePokerRsp=} [properties] Properties to set
         */
        function ComputePokerRsp(properties) {
            this.pokers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComputePokerRsp comboType.
         * @member {string} comboType
         * @memberof BullBullGame.ComputePokerRsp
         * @instance
         */
        ComputePokerRsp.prototype.comboType = "";

        /**
         * ComputePokerRsp pokers.
         * @member {Array.<BullBullGame.IPoker>} pokers
         * @memberof BullBullGame.ComputePokerRsp
         * @instance
         */
        ComputePokerRsp.prototype.pokers = $util.emptyArray;

        /**
         * Creates a new ComputePokerRsp instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ComputePokerRsp
         * @static
         * @param {BullBullGame.IComputePokerRsp=} [properties] Properties to set
         * @returns {BullBullGame.ComputePokerRsp} ComputePokerRsp instance
         */
        ComputePokerRsp.create = function create(properties) {
            return new ComputePokerRsp(properties);
        };

        /**
         * Encodes the specified ComputePokerRsp message. Does not implicitly {@link BullBullGame.ComputePokerRsp.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ComputePokerRsp
         * @static
         * @param {BullBullGame.IComputePokerRsp} message ComputePokerRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComputePokerRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.comboType);
            if (message.pokers != null && message.pokers.length)
                for (var i = 0; i < message.pokers.length; ++i)
                    $root.BullBullGame.Poker.encode(message.pokers[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ComputePokerRsp message, length delimited. Does not implicitly {@link BullBullGame.ComputePokerRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ComputePokerRsp
         * @static
         * @param {BullBullGame.IComputePokerRsp} message ComputePokerRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComputePokerRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ComputePokerRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ComputePokerRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ComputePokerRsp} ComputePokerRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComputePokerRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ComputePokerRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.comboType = reader.string();
                    break;
                case 2:
                    if (!(message.pokers && message.pokers.length))
                        message.pokers = [];
                    message.pokers.push($root.BullBullGame.Poker.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("comboType"))
                throw $util.ProtocolError("missing required 'comboType'", { instance: message });
            return message;
        };

        /**
         * Decodes a ComputePokerRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ComputePokerRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ComputePokerRsp} ComputePokerRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComputePokerRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ComputePokerRsp message.
         * @function verify
         * @memberof BullBullGame.ComputePokerRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ComputePokerRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.comboType))
                return "comboType: string expected";
            if (message.pokers != null && message.hasOwnProperty("pokers")) {
                if (!Array.isArray(message.pokers))
                    return "pokers: array expected";
                for (var i = 0; i < message.pokers.length; ++i) {
                    var error = $root.BullBullGame.Poker.verify(message.pokers[i]);
                    if (error)
                        return "pokers." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ComputePokerRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ComputePokerRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ComputePokerRsp} ComputePokerRsp
         */
        ComputePokerRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ComputePokerRsp)
                return object;
            var message = new $root.BullBullGame.ComputePokerRsp();
            if (object.comboType != null)
                message.comboType = String(object.comboType);
            if (object.pokers) {
                if (!Array.isArray(object.pokers))
                    throw TypeError(".BullBullGame.ComputePokerRsp.pokers: array expected");
                message.pokers = [];
                for (var i = 0; i < object.pokers.length; ++i) {
                    if (typeof object.pokers[i] !== "object")
                        throw TypeError(".BullBullGame.ComputePokerRsp.pokers: object expected");
                    message.pokers[i] = $root.BullBullGame.Poker.fromObject(object.pokers[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ComputePokerRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ComputePokerRsp
         * @static
         * @param {BullBullGame.ComputePokerRsp} message ComputePokerRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComputePokerRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.pokers = [];
            if (options.defaults)
                object.comboType = "";
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                object.comboType = message.comboType;
            if (message.pokers && message.pokers.length) {
                object.pokers = [];
                for (var j = 0; j < message.pokers.length; ++j)
                    object.pokers[j] = $root.BullBullGame.Poker.toObject(message.pokers[j], options);
            }
            return object;
        };

        /**
         * Converts this ComputePokerRsp to JSON.
         * @function toJSON
         * @memberof BullBullGame.ComputePokerRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComputePokerRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComputePokerRsp;
    })();

    BullBullGame.SettleAccounts = (function() {

        /**
         * Properties of a SettleAccounts.
         * @memberof BullBullGame
         * @interface ISettleAccounts
         * @property {number} playerId SettleAccounts playerId
         * @property {number} score SettleAccounts score
         * @property {string} comboType SettleAccounts comboType
         * @property {Array.<BullBullGame.IPoker>|null} [pokers] SettleAccounts pokers
         * @property {number|null} [hidescore] SettleAccounts hidescore
         * @property {number|null} [gameCnt] SettleAccounts gameCnt
         * @property {number|null} [coinBalance] SettleAccounts coinBalance
         * @property {number|Long|null} [outsourceCoinBalance] SettleAccounts outsourceCoinBalance
         * @property {number|Long|null} [outsourceScore] SettleAccounts outsourceScore
         * @property {string|null} [coinBalanceStr] SettleAccounts coinBalanceStr
         * @property {string|null} [actualWinLoss] SettleAccounts actualWinLoss
         */

        /**
         * Constructs a new SettleAccounts.
         * @memberof BullBullGame
         * @classdesc Represents a SettleAccounts.
         * @implements ISettleAccounts
         * @constructor
         * @param {BullBullGame.ISettleAccounts=} [properties] Properties to set
         */
        function SettleAccounts(properties) {
            this.pokers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SettleAccounts playerId.
         * @member {number} playerId
         * @memberof BullBullGame.SettleAccounts
         * @instance
         */
        SettleAccounts.prototype.playerId = 0;

        /**
         * SettleAccounts score.
         * @member {number} score
         * @memberof BullBullGame.SettleAccounts
         * @instance
         */
        SettleAccounts.prototype.score = 0;

        /**
         * SettleAccounts comboType.
         * @member {string} comboType
         * @memberof BullBullGame.SettleAccounts
         * @instance
         */
        SettleAccounts.prototype.comboType = "";

        /**
         * SettleAccounts pokers.
         * @member {Array.<BullBullGame.IPoker>} pokers
         * @memberof BullBullGame.SettleAccounts
         * @instance
         */
        SettleAccounts.prototype.pokers = $util.emptyArray;

        /**
         * SettleAccounts hidescore.
         * @member {number} hidescore
         * @memberof BullBullGame.SettleAccounts
         * @instance
         */
        SettleAccounts.prototype.hidescore = 0;

        /**
         * SettleAccounts gameCnt.
         * @member {number} gameCnt
         * @memberof BullBullGame.SettleAccounts
         * @instance
         */
        SettleAccounts.prototype.gameCnt = 0;

        /**
         * SettleAccounts coinBalance.
         * @member {number} coinBalance
         * @memberof BullBullGame.SettleAccounts
         * @instance
         */
        SettleAccounts.prototype.coinBalance = 0;

        /**
         * SettleAccounts outsourceCoinBalance.
         * @member {number|Long} outsourceCoinBalance
         * @memberof BullBullGame.SettleAccounts
         * @instance
         */
        SettleAccounts.prototype.outsourceCoinBalance = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SettleAccounts outsourceScore.
         * @member {number|Long} outsourceScore
         * @memberof BullBullGame.SettleAccounts
         * @instance
         */
        SettleAccounts.prototype.outsourceScore = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SettleAccounts coinBalanceStr.
         * @member {string} coinBalanceStr
         * @memberof BullBullGame.SettleAccounts
         * @instance
         */
        SettleAccounts.prototype.coinBalanceStr = "";

        /**
         * SettleAccounts actualWinLoss.
         * @member {string} actualWinLoss
         * @memberof BullBullGame.SettleAccounts
         * @instance
         */
        SettleAccounts.prototype.actualWinLoss = "";

        /**
         * Creates a new SettleAccounts instance using the specified properties.
         * @function create
         * @memberof BullBullGame.SettleAccounts
         * @static
         * @param {BullBullGame.ISettleAccounts=} [properties] Properties to set
         * @returns {BullBullGame.SettleAccounts} SettleAccounts instance
         */
        SettleAccounts.create = function create(properties) {
            return new SettleAccounts(properties);
        };

        /**
         * Encodes the specified SettleAccounts message. Does not implicitly {@link BullBullGame.SettleAccounts.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.SettleAccounts
         * @static
         * @param {BullBullGame.ISettleAccounts} message SettleAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SettleAccounts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.score);
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.comboType);
            if (message.pokers != null && message.pokers.length)
                for (var i = 0; i < message.pokers.length; ++i)
                    $root.BullBullGame.Poker.encode(message.pokers[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.hidescore != null && message.hasOwnProperty("hidescore"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.hidescore);
            if (message.gameCnt != null && message.hasOwnProperty("gameCnt"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.gameCnt);
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.coinBalance);
            if (message.outsourceCoinBalance != null && message.hasOwnProperty("outsourceCoinBalance"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.outsourceCoinBalance);
            if (message.outsourceScore != null && message.hasOwnProperty("outsourceScore"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.outsourceScore);
            if (message.coinBalanceStr != null && message.hasOwnProperty("coinBalanceStr"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.coinBalanceStr);
            if (message.actualWinLoss != null && message.hasOwnProperty("actualWinLoss"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.actualWinLoss);
            return writer;
        };

        /**
         * Encodes the specified SettleAccounts message, length delimited. Does not implicitly {@link BullBullGame.SettleAccounts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.SettleAccounts
         * @static
         * @param {BullBullGame.ISettleAccounts} message SettleAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SettleAccounts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SettleAccounts message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.SettleAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.SettleAccounts} SettleAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SettleAccounts.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.SettleAccounts();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.score = reader.int32();
                    break;
                case 3:
                    message.comboType = reader.string();
                    break;
                case 4:
                    if (!(message.pokers && message.pokers.length))
                        message.pokers = [];
                    message.pokers.push($root.BullBullGame.Poker.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.hidescore = reader.int32();
                    break;
                case 6:
                    message.gameCnt = reader.int32();
                    break;
                case 7:
                    message.coinBalance = reader.int32();
                    break;
                case 8:
                    message.outsourceCoinBalance = reader.int64();
                    break;
                case 9:
                    message.outsourceScore = reader.int64();
                    break;
                case 10:
                    message.coinBalanceStr = reader.string();
                    break;
                case 11:
                    message.actualWinLoss = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            if (!message.hasOwnProperty("score"))
                throw $util.ProtocolError("missing required 'score'", { instance: message });
            if (!message.hasOwnProperty("comboType"))
                throw $util.ProtocolError("missing required 'comboType'", { instance: message });
            return message;
        };

        /**
         * Decodes a SettleAccounts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.SettleAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.SettleAccounts} SettleAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SettleAccounts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SettleAccounts message.
         * @function verify
         * @memberof BullBullGame.SettleAccounts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SettleAccounts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (!$util.isInteger(message.score))
                return "score: integer expected";
            if (!$util.isString(message.comboType))
                return "comboType: string expected";
            if (message.pokers != null && message.hasOwnProperty("pokers")) {
                if (!Array.isArray(message.pokers))
                    return "pokers: array expected";
                for (var i = 0; i < message.pokers.length; ++i) {
                    var error = $root.BullBullGame.Poker.verify(message.pokers[i]);
                    if (error)
                        return "pokers." + error;
                }
            }
            if (message.hidescore != null && message.hasOwnProperty("hidescore"))
                if (!$util.isInteger(message.hidescore))
                    return "hidescore: integer expected";
            if (message.gameCnt != null && message.hasOwnProperty("gameCnt"))
                if (!$util.isInteger(message.gameCnt))
                    return "gameCnt: integer expected";
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                if (!$util.isInteger(message.coinBalance))
                    return "coinBalance: integer expected";
            if (message.outsourceCoinBalance != null && message.hasOwnProperty("outsourceCoinBalance"))
                if (!$util.isInteger(message.outsourceCoinBalance) && !(message.outsourceCoinBalance && $util.isInteger(message.outsourceCoinBalance.low) && $util.isInteger(message.outsourceCoinBalance.high)))
                    return "outsourceCoinBalance: integer|Long expected";
            if (message.outsourceScore != null && message.hasOwnProperty("outsourceScore"))
                if (!$util.isInteger(message.outsourceScore) && !(message.outsourceScore && $util.isInteger(message.outsourceScore.low) && $util.isInteger(message.outsourceScore.high)))
                    return "outsourceScore: integer|Long expected";
            if (message.coinBalanceStr != null && message.hasOwnProperty("coinBalanceStr"))
                if (!$util.isString(message.coinBalanceStr))
                    return "coinBalanceStr: string expected";
            if (message.actualWinLoss != null && message.hasOwnProperty("actualWinLoss"))
                if (!$util.isString(message.actualWinLoss))
                    return "actualWinLoss: string expected";
            return null;
        };

        /**
         * Creates a SettleAccounts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.SettleAccounts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.SettleAccounts} SettleAccounts
         */
        SettleAccounts.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.SettleAccounts)
                return object;
            var message = new $root.BullBullGame.SettleAccounts();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.score != null)
                message.score = object.score | 0;
            if (object.comboType != null)
                message.comboType = String(object.comboType);
            if (object.pokers) {
                if (!Array.isArray(object.pokers))
                    throw TypeError(".BullBullGame.SettleAccounts.pokers: array expected");
                message.pokers = [];
                for (var i = 0; i < object.pokers.length; ++i) {
                    if (typeof object.pokers[i] !== "object")
                        throw TypeError(".BullBullGame.SettleAccounts.pokers: object expected");
                    message.pokers[i] = $root.BullBullGame.Poker.fromObject(object.pokers[i]);
                }
            }
            if (object.hidescore != null)
                message.hidescore = object.hidescore | 0;
            if (object.gameCnt != null)
                message.gameCnt = object.gameCnt | 0;
            if (object.coinBalance != null)
                message.coinBalance = object.coinBalance | 0;
            if (object.outsourceCoinBalance != null)
                if ($util.Long)
                    (message.outsourceCoinBalance = $util.Long.fromValue(object.outsourceCoinBalance)).unsigned = false;
                else if (typeof object.outsourceCoinBalance === "string")
                    message.outsourceCoinBalance = parseInt(object.outsourceCoinBalance, 10);
                else if (typeof object.outsourceCoinBalance === "number")
                    message.outsourceCoinBalance = object.outsourceCoinBalance;
                else if (typeof object.outsourceCoinBalance === "object")
                    message.outsourceCoinBalance = new $util.LongBits(object.outsourceCoinBalance.low >>> 0, object.outsourceCoinBalance.high >>> 0).toNumber();
            if (object.outsourceScore != null)
                if ($util.Long)
                    (message.outsourceScore = $util.Long.fromValue(object.outsourceScore)).unsigned = false;
                else if (typeof object.outsourceScore === "string")
                    message.outsourceScore = parseInt(object.outsourceScore, 10);
                else if (typeof object.outsourceScore === "number")
                    message.outsourceScore = object.outsourceScore;
                else if (typeof object.outsourceScore === "object")
                    message.outsourceScore = new $util.LongBits(object.outsourceScore.low >>> 0, object.outsourceScore.high >>> 0).toNumber();
            if (object.coinBalanceStr != null)
                message.coinBalanceStr = String(object.coinBalanceStr);
            if (object.actualWinLoss != null)
                message.actualWinLoss = String(object.actualWinLoss);
            return message;
        };

        /**
         * Creates a plain object from a SettleAccounts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.SettleAccounts
         * @static
         * @param {BullBullGame.SettleAccounts} message SettleAccounts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SettleAccounts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.pokers = [];
            if (options.defaults) {
                object.playerId = 0;
                object.score = 0;
                object.comboType = "";
                object.hidescore = 0;
                object.gameCnt = 0;
                object.coinBalance = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.outsourceCoinBalance = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.outsourceCoinBalance = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.outsourceScore = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.outsourceScore = options.longs === String ? "0" : 0;
                object.coinBalanceStr = "";
                object.actualWinLoss = "";
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.score != null && message.hasOwnProperty("score"))
                object.score = message.score;
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                object.comboType = message.comboType;
            if (message.pokers && message.pokers.length) {
                object.pokers = [];
                for (var j = 0; j < message.pokers.length; ++j)
                    object.pokers[j] = $root.BullBullGame.Poker.toObject(message.pokers[j], options);
            }
            if (message.hidescore != null && message.hasOwnProperty("hidescore"))
                object.hidescore = message.hidescore;
            if (message.gameCnt != null && message.hasOwnProperty("gameCnt"))
                object.gameCnt = message.gameCnt;
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                object.coinBalance = message.coinBalance;
            if (message.outsourceCoinBalance != null && message.hasOwnProperty("outsourceCoinBalance"))
                if (typeof message.outsourceCoinBalance === "number")
                    object.outsourceCoinBalance = options.longs === String ? String(message.outsourceCoinBalance) : message.outsourceCoinBalance;
                else
                    object.outsourceCoinBalance = options.longs === String ? $util.Long.prototype.toString.call(message.outsourceCoinBalance) : options.longs === Number ? new $util.LongBits(message.outsourceCoinBalance.low >>> 0, message.outsourceCoinBalance.high >>> 0).toNumber() : message.outsourceCoinBalance;
            if (message.outsourceScore != null && message.hasOwnProperty("outsourceScore"))
                if (typeof message.outsourceScore === "number")
                    object.outsourceScore = options.longs === String ? String(message.outsourceScore) : message.outsourceScore;
                else
                    object.outsourceScore = options.longs === String ? $util.Long.prototype.toString.call(message.outsourceScore) : options.longs === Number ? new $util.LongBits(message.outsourceScore.low >>> 0, message.outsourceScore.high >>> 0).toNumber() : message.outsourceScore;
            if (message.coinBalanceStr != null && message.hasOwnProperty("coinBalanceStr"))
                object.coinBalanceStr = message.coinBalanceStr;
            if (message.actualWinLoss != null && message.hasOwnProperty("actualWinLoss"))
                object.actualWinLoss = message.actualWinLoss;
            return object;
        };

        /**
         * Converts this SettleAccounts to JSON.
         * @function toJSON
         * @memberof BullBullGame.SettleAccounts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SettleAccounts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SettleAccounts;
    })();

    BullBullGame.ZhaJinNiu_SettleAccounts = (function() {

        /**
         * Properties of a ZhaJinNiu_SettleAccounts.
         * @memberof BullBullGame
         * @interface IZhaJinNiu_SettleAccounts
         * @property {number} playerId ZhaJinNiu_SettleAccounts playerId
         * @property {number} zhaJinNiuState ZhaJinNiu_SettleAccounts zhaJinNiuState
         * @property {boolean} needShowPokers ZhaJinNiu_SettleAccounts needShowPokers
         * @property {Array.<BullBullGame.IPoker>|null} [pokers] ZhaJinNiu_SettleAccounts pokers
         * @property {string} comboType ZhaJinNiu_SettleAccounts comboType
         * @property {number} betScore ZhaJinNiu_SettleAccounts betScore
         * @property {boolean} isWinner ZhaJinNiu_SettleAccounts isWinner
         * @property {number|null} [winScore] ZhaJinNiu_SettleAccounts winScore
         * @property {number|null} [score] ZhaJinNiu_SettleAccounts score
         */

        /**
         * Constructs a new ZhaJinNiu_SettleAccounts.
         * @memberof BullBullGame
         * @classdesc Represents a ZhaJinNiu_SettleAccounts.
         * @implements IZhaJinNiu_SettleAccounts
         * @constructor
         * @param {BullBullGame.IZhaJinNiu_SettleAccounts=} [properties] Properties to set
         */
        function ZhaJinNiu_SettleAccounts(properties) {
            this.pokers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ZhaJinNiu_SettleAccounts playerId.
         * @member {number} playerId
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @instance
         */
        ZhaJinNiu_SettleAccounts.prototype.playerId = 0;

        /**
         * ZhaJinNiu_SettleAccounts zhaJinNiuState.
         * @member {number} zhaJinNiuState
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @instance
         */
        ZhaJinNiu_SettleAccounts.prototype.zhaJinNiuState = 0;

        /**
         * ZhaJinNiu_SettleAccounts needShowPokers.
         * @member {boolean} needShowPokers
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @instance
         */
        ZhaJinNiu_SettleAccounts.prototype.needShowPokers = false;

        /**
         * ZhaJinNiu_SettleAccounts pokers.
         * @member {Array.<BullBullGame.IPoker>} pokers
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @instance
         */
        ZhaJinNiu_SettleAccounts.prototype.pokers = $util.emptyArray;

        /**
         * ZhaJinNiu_SettleAccounts comboType.
         * @member {string} comboType
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @instance
         */
        ZhaJinNiu_SettleAccounts.prototype.comboType = "";

        /**
         * ZhaJinNiu_SettleAccounts betScore.
         * @member {number} betScore
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @instance
         */
        ZhaJinNiu_SettleAccounts.prototype.betScore = 0;

        /**
         * ZhaJinNiu_SettleAccounts isWinner.
         * @member {boolean} isWinner
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @instance
         */
        ZhaJinNiu_SettleAccounts.prototype.isWinner = false;

        /**
         * ZhaJinNiu_SettleAccounts winScore.
         * @member {number} winScore
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @instance
         */
        ZhaJinNiu_SettleAccounts.prototype.winScore = 0;

        /**
         * ZhaJinNiu_SettleAccounts score.
         * @member {number} score
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @instance
         */
        ZhaJinNiu_SettleAccounts.prototype.score = 0;

        /**
         * Creates a new ZhaJinNiu_SettleAccounts instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @static
         * @param {BullBullGame.IZhaJinNiu_SettleAccounts=} [properties] Properties to set
         * @returns {BullBullGame.ZhaJinNiu_SettleAccounts} ZhaJinNiu_SettleAccounts instance
         */
        ZhaJinNiu_SettleAccounts.create = function create(properties) {
            return new ZhaJinNiu_SettleAccounts(properties);
        };

        /**
         * Encodes the specified ZhaJinNiu_SettleAccounts message. Does not implicitly {@link BullBullGame.ZhaJinNiu_SettleAccounts.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @static
         * @param {BullBullGame.IZhaJinNiu_SettleAccounts} message ZhaJinNiu_SettleAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ZhaJinNiu_SettleAccounts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.zhaJinNiuState);
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.needShowPokers);
            if (message.pokers != null && message.pokers.length)
                for (var i = 0; i < message.pokers.length; ++i)
                    $root.BullBullGame.Poker.encode(message.pokers[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.comboType);
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.betScore);
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isWinner);
            if (message.winScore != null && message.hasOwnProperty("winScore"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.winScore);
            if (message.score != null && message.hasOwnProperty("score"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.score);
            return writer;
        };

        /**
         * Encodes the specified ZhaJinNiu_SettleAccounts message, length delimited. Does not implicitly {@link BullBullGame.ZhaJinNiu_SettleAccounts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @static
         * @param {BullBullGame.IZhaJinNiu_SettleAccounts} message ZhaJinNiu_SettleAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ZhaJinNiu_SettleAccounts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ZhaJinNiu_SettleAccounts message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ZhaJinNiu_SettleAccounts} ZhaJinNiu_SettleAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ZhaJinNiu_SettleAccounts.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ZhaJinNiu_SettleAccounts();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.zhaJinNiuState = reader.int32();
                    break;
                case 3:
                    message.needShowPokers = reader.bool();
                    break;
                case 4:
                    if (!(message.pokers && message.pokers.length))
                        message.pokers = [];
                    message.pokers.push($root.BullBullGame.Poker.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.comboType = reader.string();
                    break;
                case 6:
                    message.betScore = reader.int32();
                    break;
                case 7:
                    message.isWinner = reader.bool();
                    break;
                case 8:
                    message.winScore = reader.int32();
                    break;
                case 9:
                    message.score = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            if (!message.hasOwnProperty("zhaJinNiuState"))
                throw $util.ProtocolError("missing required 'zhaJinNiuState'", { instance: message });
            if (!message.hasOwnProperty("needShowPokers"))
                throw $util.ProtocolError("missing required 'needShowPokers'", { instance: message });
            if (!message.hasOwnProperty("comboType"))
                throw $util.ProtocolError("missing required 'comboType'", { instance: message });
            if (!message.hasOwnProperty("betScore"))
                throw $util.ProtocolError("missing required 'betScore'", { instance: message });
            if (!message.hasOwnProperty("isWinner"))
                throw $util.ProtocolError("missing required 'isWinner'", { instance: message });
            return message;
        };

        /**
         * Decodes a ZhaJinNiu_SettleAccounts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ZhaJinNiu_SettleAccounts} ZhaJinNiu_SettleAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ZhaJinNiu_SettleAccounts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ZhaJinNiu_SettleAccounts message.
         * @function verify
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ZhaJinNiu_SettleAccounts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (!$util.isInteger(message.zhaJinNiuState))
                return "zhaJinNiuState: integer expected";
            if (typeof message.needShowPokers !== "boolean")
                return "needShowPokers: boolean expected";
            if (message.pokers != null && message.hasOwnProperty("pokers")) {
                if (!Array.isArray(message.pokers))
                    return "pokers: array expected";
                for (var i = 0; i < message.pokers.length; ++i) {
                    var error = $root.BullBullGame.Poker.verify(message.pokers[i]);
                    if (error)
                        return "pokers." + error;
                }
            }
            if (!$util.isString(message.comboType))
                return "comboType: string expected";
            if (!$util.isInteger(message.betScore))
                return "betScore: integer expected";
            if (typeof message.isWinner !== "boolean")
                return "isWinner: boolean expected";
            if (message.winScore != null && message.hasOwnProperty("winScore"))
                if (!$util.isInteger(message.winScore))
                    return "winScore: integer expected";
            if (message.score != null && message.hasOwnProperty("score"))
                if (!$util.isInteger(message.score))
                    return "score: integer expected";
            return null;
        };

        /**
         * Creates a ZhaJinNiu_SettleAccounts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ZhaJinNiu_SettleAccounts} ZhaJinNiu_SettleAccounts
         */
        ZhaJinNiu_SettleAccounts.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ZhaJinNiu_SettleAccounts)
                return object;
            var message = new $root.BullBullGame.ZhaJinNiu_SettleAccounts();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.zhaJinNiuState != null)
                message.zhaJinNiuState = object.zhaJinNiuState | 0;
            if (object.needShowPokers != null)
                message.needShowPokers = Boolean(object.needShowPokers);
            if (object.pokers) {
                if (!Array.isArray(object.pokers))
                    throw TypeError(".BullBullGame.ZhaJinNiu_SettleAccounts.pokers: array expected");
                message.pokers = [];
                for (var i = 0; i < object.pokers.length; ++i) {
                    if (typeof object.pokers[i] !== "object")
                        throw TypeError(".BullBullGame.ZhaJinNiu_SettleAccounts.pokers: object expected");
                    message.pokers[i] = $root.BullBullGame.Poker.fromObject(object.pokers[i]);
                }
            }
            if (object.comboType != null)
                message.comboType = String(object.comboType);
            if (object.betScore != null)
                message.betScore = object.betScore | 0;
            if (object.isWinner != null)
                message.isWinner = Boolean(object.isWinner);
            if (object.winScore != null)
                message.winScore = object.winScore | 0;
            if (object.score != null)
                message.score = object.score | 0;
            return message;
        };

        /**
         * Creates a plain object from a ZhaJinNiu_SettleAccounts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @static
         * @param {BullBullGame.ZhaJinNiu_SettleAccounts} message ZhaJinNiu_SettleAccounts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ZhaJinNiu_SettleAccounts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.pokers = [];
            if (options.defaults) {
                object.playerId = 0;
                object.zhaJinNiuState = 0;
                object.needShowPokers = false;
                object.comboType = "";
                object.betScore = 0;
                object.isWinner = false;
                object.winScore = 0;
                object.score = 0;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.zhaJinNiuState != null && message.hasOwnProperty("zhaJinNiuState"))
                object.zhaJinNiuState = message.zhaJinNiuState;
            if (message.needShowPokers != null && message.hasOwnProperty("needShowPokers"))
                object.needShowPokers = message.needShowPokers;
            if (message.pokers && message.pokers.length) {
                object.pokers = [];
                for (var j = 0; j < message.pokers.length; ++j)
                    object.pokers[j] = $root.BullBullGame.Poker.toObject(message.pokers[j], options);
            }
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                object.comboType = message.comboType;
            if (message.betScore != null && message.hasOwnProperty("betScore"))
                object.betScore = message.betScore;
            if (message.isWinner != null && message.hasOwnProperty("isWinner"))
                object.isWinner = message.isWinner;
            if (message.winScore != null && message.hasOwnProperty("winScore"))
                object.winScore = message.winScore;
            if (message.score != null && message.hasOwnProperty("score"))
                object.score = message.score;
            return object;
        };

        /**
         * Converts this ZhaJinNiu_SettleAccounts to JSON.
         * @function toJSON
         * @memberof BullBullGame.ZhaJinNiu_SettleAccounts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ZhaJinNiu_SettleAccounts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ZhaJinNiu_SettleAccounts;
    })();

    BullBullGame.LastSettleAccounts = (function() {

        /**
         * Properties of a LastSettleAccounts.
         * @memberof BullBullGame
         * @interface ILastSettleAccounts
         * @property {number} playerId LastSettleAccounts playerId
         * @property {number} score LastSettleAccounts score
         * @property {number} winCount LastSettleAccounts winCount
         * @property {number} lostCount LastSettleAccounts lostCount
         * @property {number} cowCount LastSettleAccounts cowCount
         * @property {number} notCowCount LastSettleAccounts notCowCount
         * @property {number|Long|null} [seatid] LastSettleAccounts seatid
         * @property {number|null} [coin] LastSettleAccounts coin
         * @property {number|null} [restcoin] LastSettleAccounts restcoin
         * @property {number|null} [coinbalance] LastSettleAccounts coinbalance
         */

        /**
         * Constructs a new LastSettleAccounts.
         * @memberof BullBullGame
         * @classdesc Represents a LastSettleAccounts.
         * @implements ILastSettleAccounts
         * @constructor
         * @param {BullBullGame.ILastSettleAccounts=} [properties] Properties to set
         */
        function LastSettleAccounts(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LastSettleAccounts playerId.
         * @member {number} playerId
         * @memberof BullBullGame.LastSettleAccounts
         * @instance
         */
        LastSettleAccounts.prototype.playerId = 0;

        /**
         * LastSettleAccounts score.
         * @member {number} score
         * @memberof BullBullGame.LastSettleAccounts
         * @instance
         */
        LastSettleAccounts.prototype.score = 0;

        /**
         * LastSettleAccounts winCount.
         * @member {number} winCount
         * @memberof BullBullGame.LastSettleAccounts
         * @instance
         */
        LastSettleAccounts.prototype.winCount = 0;

        /**
         * LastSettleAccounts lostCount.
         * @member {number} lostCount
         * @memberof BullBullGame.LastSettleAccounts
         * @instance
         */
        LastSettleAccounts.prototype.lostCount = 0;

        /**
         * LastSettleAccounts cowCount.
         * @member {number} cowCount
         * @memberof BullBullGame.LastSettleAccounts
         * @instance
         */
        LastSettleAccounts.prototype.cowCount = 0;

        /**
         * LastSettleAccounts notCowCount.
         * @member {number} notCowCount
         * @memberof BullBullGame.LastSettleAccounts
         * @instance
         */
        LastSettleAccounts.prototype.notCowCount = 0;

        /**
         * LastSettleAccounts seatid.
         * @member {number|Long} seatid
         * @memberof BullBullGame.LastSettleAccounts
         * @instance
         */
        LastSettleAccounts.prototype.seatid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * LastSettleAccounts coin.
         * @member {number} coin
         * @memberof BullBullGame.LastSettleAccounts
         * @instance
         */
        LastSettleAccounts.prototype.coin = 0;

        /**
         * LastSettleAccounts restcoin.
         * @member {number} restcoin
         * @memberof BullBullGame.LastSettleAccounts
         * @instance
         */
        LastSettleAccounts.prototype.restcoin = 0;

        /**
         * LastSettleAccounts coinbalance.
         * @member {number} coinbalance
         * @memberof BullBullGame.LastSettleAccounts
         * @instance
         */
        LastSettleAccounts.prototype.coinbalance = 0;

        /**
         * Creates a new LastSettleAccounts instance using the specified properties.
         * @function create
         * @memberof BullBullGame.LastSettleAccounts
         * @static
         * @param {BullBullGame.ILastSettleAccounts=} [properties] Properties to set
         * @returns {BullBullGame.LastSettleAccounts} LastSettleAccounts instance
         */
        LastSettleAccounts.create = function create(properties) {
            return new LastSettleAccounts(properties);
        };

        /**
         * Encodes the specified LastSettleAccounts message. Does not implicitly {@link BullBullGame.LastSettleAccounts.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.LastSettleAccounts
         * @static
         * @param {BullBullGame.ILastSettleAccounts} message LastSettleAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LastSettleAccounts.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.score);
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.winCount);
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.lostCount);
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.cowCount);
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.notCowCount);
            if (message.seatid != null && message.hasOwnProperty("seatid"))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.seatid);
            if (message.coin != null && message.hasOwnProperty("coin"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.coin);
            if (message.restcoin != null && message.hasOwnProperty("restcoin"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.restcoin);
            if (message.coinbalance != null && message.hasOwnProperty("coinbalance"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.coinbalance);
            return writer;
        };

        /**
         * Encodes the specified LastSettleAccounts message, length delimited. Does not implicitly {@link BullBullGame.LastSettleAccounts.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.LastSettleAccounts
         * @static
         * @param {BullBullGame.ILastSettleAccounts} message LastSettleAccounts message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LastSettleAccounts.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LastSettleAccounts message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.LastSettleAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.LastSettleAccounts} LastSettleAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LastSettleAccounts.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.LastSettleAccounts();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.score = reader.int32();
                    break;
                case 3:
                    message.winCount = reader.int32();
                    break;
                case 4:
                    message.lostCount = reader.int32();
                    break;
                case 5:
                    message.cowCount = reader.int32();
                    break;
                case 6:
                    message.notCowCount = reader.int32();
                    break;
                case 7:
                    message.seatid = reader.int64();
                    break;
                case 8:
                    message.coin = reader.int32();
                    break;
                case 9:
                    message.restcoin = reader.int32();
                    break;
                case 10:
                    message.coinbalance = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            if (!message.hasOwnProperty("score"))
                throw $util.ProtocolError("missing required 'score'", { instance: message });
            if (!message.hasOwnProperty("winCount"))
                throw $util.ProtocolError("missing required 'winCount'", { instance: message });
            if (!message.hasOwnProperty("lostCount"))
                throw $util.ProtocolError("missing required 'lostCount'", { instance: message });
            if (!message.hasOwnProperty("cowCount"))
                throw $util.ProtocolError("missing required 'cowCount'", { instance: message });
            if (!message.hasOwnProperty("notCowCount"))
                throw $util.ProtocolError("missing required 'notCowCount'", { instance: message });
            return message;
        };

        /**
         * Decodes a LastSettleAccounts message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.LastSettleAccounts
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.LastSettleAccounts} LastSettleAccounts
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LastSettleAccounts.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LastSettleAccounts message.
         * @function verify
         * @memberof BullBullGame.LastSettleAccounts
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LastSettleAccounts.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (!$util.isInteger(message.score))
                return "score: integer expected";
            if (!$util.isInteger(message.winCount))
                return "winCount: integer expected";
            if (!$util.isInteger(message.lostCount))
                return "lostCount: integer expected";
            if (!$util.isInteger(message.cowCount))
                return "cowCount: integer expected";
            if (!$util.isInteger(message.notCowCount))
                return "notCowCount: integer expected";
            if (message.seatid != null && message.hasOwnProperty("seatid"))
                if (!$util.isInteger(message.seatid) && !(message.seatid && $util.isInteger(message.seatid.low) && $util.isInteger(message.seatid.high)))
                    return "seatid: integer|Long expected";
            if (message.coin != null && message.hasOwnProperty("coin"))
                if (!$util.isInteger(message.coin))
                    return "coin: integer expected";
            if (message.restcoin != null && message.hasOwnProperty("restcoin"))
                if (!$util.isInteger(message.restcoin))
                    return "restcoin: integer expected";
            if (message.coinbalance != null && message.hasOwnProperty("coinbalance"))
                if (!$util.isInteger(message.coinbalance))
                    return "coinbalance: integer expected";
            return null;
        };

        /**
         * Creates a LastSettleAccounts message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.LastSettleAccounts
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.LastSettleAccounts} LastSettleAccounts
         */
        LastSettleAccounts.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.LastSettleAccounts)
                return object;
            var message = new $root.BullBullGame.LastSettleAccounts();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.score != null)
                message.score = object.score | 0;
            if (object.winCount != null)
                message.winCount = object.winCount | 0;
            if (object.lostCount != null)
                message.lostCount = object.lostCount | 0;
            if (object.cowCount != null)
                message.cowCount = object.cowCount | 0;
            if (object.notCowCount != null)
                message.notCowCount = object.notCowCount | 0;
            if (object.seatid != null)
                if ($util.Long)
                    (message.seatid = $util.Long.fromValue(object.seatid)).unsigned = false;
                else if (typeof object.seatid === "string")
                    message.seatid = parseInt(object.seatid, 10);
                else if (typeof object.seatid === "number")
                    message.seatid = object.seatid;
                else if (typeof object.seatid === "object")
                    message.seatid = new $util.LongBits(object.seatid.low >>> 0, object.seatid.high >>> 0).toNumber();
            if (object.coin != null)
                message.coin = object.coin | 0;
            if (object.restcoin != null)
                message.restcoin = object.restcoin | 0;
            if (object.coinbalance != null)
                message.coinbalance = object.coinbalance | 0;
            return message;
        };

        /**
         * Creates a plain object from a LastSettleAccounts message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.LastSettleAccounts
         * @static
         * @param {BullBullGame.LastSettleAccounts} message LastSettleAccounts
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LastSettleAccounts.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.score = 0;
                object.winCount = 0;
                object.lostCount = 0;
                object.cowCount = 0;
                object.notCowCount = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.seatid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.seatid = options.longs === String ? "0" : 0;
                object.coin = 0;
                object.restcoin = 0;
                object.coinbalance = 0;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.score != null && message.hasOwnProperty("score"))
                object.score = message.score;
            if (message.winCount != null && message.hasOwnProperty("winCount"))
                object.winCount = message.winCount;
            if (message.lostCount != null && message.hasOwnProperty("lostCount"))
                object.lostCount = message.lostCount;
            if (message.cowCount != null && message.hasOwnProperty("cowCount"))
                object.cowCount = message.cowCount;
            if (message.notCowCount != null && message.hasOwnProperty("notCowCount"))
                object.notCowCount = message.notCowCount;
            if (message.seatid != null && message.hasOwnProperty("seatid"))
                if (typeof message.seatid === "number")
                    object.seatid = options.longs === String ? String(message.seatid) : message.seatid;
                else
                    object.seatid = options.longs === String ? $util.Long.prototype.toString.call(message.seatid) : options.longs === Number ? new $util.LongBits(message.seatid.low >>> 0, message.seatid.high >>> 0).toNumber() : message.seatid;
            if (message.coin != null && message.hasOwnProperty("coin"))
                object.coin = message.coin;
            if (message.restcoin != null && message.hasOwnProperty("restcoin"))
                object.restcoin = message.restcoin;
            if (message.coinbalance != null && message.hasOwnProperty("coinbalance"))
                object.coinbalance = message.coinbalance;
            return object;
        };

        /**
         * Converts this LastSettleAccounts to JSON.
         * @function toJSON
         * @memberof BullBullGame.LastSettleAccounts
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LastSettleAccounts.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LastSettleAccounts;
    })();

    BullBullGame.ComboTypeInfo = (function() {

        /**
         * Properties of a ComboTypeInfo.
         * @memberof BullBullGame
         * @interface IComboTypeInfo
         * @property {number} playerId ComboTypeInfo playerId
         */

        /**
         * Constructs a new ComboTypeInfo.
         * @memberof BullBullGame
         * @classdesc Represents a ComboTypeInfo.
         * @implements IComboTypeInfo
         * @constructor
         * @param {BullBullGame.IComboTypeInfo=} [properties] Properties to set
         */
        function ComboTypeInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComboTypeInfo playerId.
         * @member {number} playerId
         * @memberof BullBullGame.ComboTypeInfo
         * @instance
         */
        ComboTypeInfo.prototype.playerId = 0;

        /**
         * Creates a new ComboTypeInfo instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ComboTypeInfo
         * @static
         * @param {BullBullGame.IComboTypeInfo=} [properties] Properties to set
         * @returns {BullBullGame.ComboTypeInfo} ComboTypeInfo instance
         */
        ComboTypeInfo.create = function create(properties) {
            return new ComboTypeInfo(properties);
        };

        /**
         * Encodes the specified ComboTypeInfo message. Does not implicitly {@link BullBullGame.ComboTypeInfo.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ComboTypeInfo
         * @static
         * @param {BullBullGame.IComboTypeInfo} message ComboTypeInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComboTypeInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            return writer;
        };

        /**
         * Encodes the specified ComboTypeInfo message, length delimited. Does not implicitly {@link BullBullGame.ComboTypeInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ComboTypeInfo
         * @static
         * @param {BullBullGame.IComboTypeInfo} message ComboTypeInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComboTypeInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ComboTypeInfo message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ComboTypeInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ComboTypeInfo} ComboTypeInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComboTypeInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ComboTypeInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            return message;
        };

        /**
         * Decodes a ComboTypeInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ComboTypeInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ComboTypeInfo} ComboTypeInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComboTypeInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ComboTypeInfo message.
         * @function verify
         * @memberof BullBullGame.ComboTypeInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ComboTypeInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            return null;
        };

        /**
         * Creates a ComboTypeInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ComboTypeInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ComboTypeInfo} ComboTypeInfo
         */
        ComboTypeInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ComboTypeInfo)
                return object;
            var message = new $root.BullBullGame.ComboTypeInfo();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            return message;
        };

        /**
         * Creates a plain object from a ComboTypeInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ComboTypeInfo
         * @static
         * @param {BullBullGame.ComboTypeInfo} message ComboTypeInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComboTypeInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.playerId = 0;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            return object;
        };

        /**
         * Converts this ComboTypeInfo to JSON.
         * @function toJSON
         * @memberof BullBullGame.ComboTypeInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComboTypeInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComboTypeInfo;
    })();

    BullBullGame.BetTypeBroadcast = (function() {

        /**
         * Properties of a BetTypeBroadcast.
         * @memberof BullBullGame
         * @interface IBetTypeBroadcast
         * @property {Array.<number|Long>|null} [betType] BetTypeBroadcast betType
         */

        /**
         * Constructs a new BetTypeBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a BetTypeBroadcast.
         * @implements IBetTypeBroadcast
         * @constructor
         * @param {BullBullGame.IBetTypeBroadcast=} [properties] Properties to set
         */
        function BetTypeBroadcast(properties) {
            this.betType = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetTypeBroadcast betType.
         * @member {Array.<number|Long>} betType
         * @memberof BullBullGame.BetTypeBroadcast
         * @instance
         */
        BetTypeBroadcast.prototype.betType = $util.emptyArray;

        /**
         * Creates a new BetTypeBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.BetTypeBroadcast
         * @static
         * @param {BullBullGame.IBetTypeBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.BetTypeBroadcast} BetTypeBroadcast instance
         */
        BetTypeBroadcast.create = function create(properties) {
            return new BetTypeBroadcast(properties);
        };

        /**
         * Encodes the specified BetTypeBroadcast message. Does not implicitly {@link BullBullGame.BetTypeBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.BetTypeBroadcast
         * @static
         * @param {BullBullGame.IBetTypeBroadcast} message BetTypeBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetTypeBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.betType != null && message.betType.length)
                for (var i = 0; i < message.betType.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.betType[i]);
            return writer;
        };

        /**
         * Encodes the specified BetTypeBroadcast message, length delimited. Does not implicitly {@link BullBullGame.BetTypeBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.BetTypeBroadcast
         * @static
         * @param {BullBullGame.IBetTypeBroadcast} message BetTypeBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetTypeBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetTypeBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.BetTypeBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.BetTypeBroadcast} BetTypeBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetTypeBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.BetTypeBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.betType && message.betType.length))
                        message.betType = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.betType.push(reader.int64());
                    } else
                        message.betType.push(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BetTypeBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.BetTypeBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.BetTypeBroadcast} BetTypeBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetTypeBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetTypeBroadcast message.
         * @function verify
         * @memberof BullBullGame.BetTypeBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetTypeBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.betType != null && message.hasOwnProperty("betType")) {
                if (!Array.isArray(message.betType))
                    return "betType: array expected";
                for (var i = 0; i < message.betType.length; ++i)
                    if (!$util.isInteger(message.betType[i]) && !(message.betType[i] && $util.isInteger(message.betType[i].low) && $util.isInteger(message.betType[i].high)))
                        return "betType: integer|Long[] expected";
            }
            return null;
        };

        /**
         * Creates a BetTypeBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.BetTypeBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.BetTypeBroadcast} BetTypeBroadcast
         */
        BetTypeBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.BetTypeBroadcast)
                return object;
            var message = new $root.BullBullGame.BetTypeBroadcast();
            if (object.betType) {
                if (!Array.isArray(object.betType))
                    throw TypeError(".BullBullGame.BetTypeBroadcast.betType: array expected");
                message.betType = [];
                for (var i = 0; i < object.betType.length; ++i)
                    if ($util.Long)
                        (message.betType[i] = $util.Long.fromValue(object.betType[i])).unsigned = false;
                    else if (typeof object.betType[i] === "string")
                        message.betType[i] = parseInt(object.betType[i], 10);
                    else if (typeof object.betType[i] === "number")
                        message.betType[i] = object.betType[i];
                    else if (typeof object.betType[i] === "object")
                        message.betType[i] = new $util.LongBits(object.betType[i].low >>> 0, object.betType[i].high >>> 0).toNumber();
            }
            return message;
        };

        /**
         * Creates a plain object from a BetTypeBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.BetTypeBroadcast
         * @static
         * @param {BullBullGame.BetTypeBroadcast} message BetTypeBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetTypeBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.betType = [];
            if (message.betType && message.betType.length) {
                object.betType = [];
                for (var j = 0; j < message.betType.length; ++j)
                    if (typeof message.betType[j] === "number")
                        object.betType[j] = options.longs === String ? String(message.betType[j]) : message.betType[j];
                    else
                        object.betType[j] = options.longs === String ? $util.Long.prototype.toString.call(message.betType[j]) : options.longs === Number ? new $util.LongBits(message.betType[j].low >>> 0, message.betType[j].high >>> 0).toNumber() : message.betType[j];
            }
            return object;
        };

        /**
         * Converts this BetTypeBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.BetTypeBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetTypeBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetTypeBroadcast;
    })();

    BullBullGame.BetReq = (function() {

        /**
         * Properties of a BetReq.
         * @memberof BullBullGame
         * @interface IBetReq
         * @property {number} betType BetReq betType
         * @property {number|Long|null} [outsourceBetType] BetReq outsourceBetType
         */

        /**
         * Constructs a new BetReq.
         * @memberof BullBullGame
         * @classdesc Represents a BetReq.
         * @implements IBetReq
         * @constructor
         * @param {BullBullGame.IBetReq=} [properties] Properties to set
         */
        function BetReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetReq betType.
         * @member {number} betType
         * @memberof BullBullGame.BetReq
         * @instance
         */
        BetReq.prototype.betType = 0;

        /**
         * BetReq outsourceBetType.
         * @member {number|Long} outsourceBetType
         * @memberof BullBullGame.BetReq
         * @instance
         */
        BetReq.prototype.outsourceBetType = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new BetReq instance using the specified properties.
         * @function create
         * @memberof BullBullGame.BetReq
         * @static
         * @param {BullBullGame.IBetReq=} [properties] Properties to set
         * @returns {BullBullGame.BetReq} BetReq instance
         */
        BetReq.create = function create(properties) {
            return new BetReq(properties);
        };

        /**
         * Encodes the specified BetReq message. Does not implicitly {@link BullBullGame.BetReq.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.BetReq
         * @static
         * @param {BullBullGame.IBetReq} message BetReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.betType);
            if (message.outsourceBetType != null && message.hasOwnProperty("outsourceBetType"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.outsourceBetType);
            return writer;
        };

        /**
         * Encodes the specified BetReq message, length delimited. Does not implicitly {@link BullBullGame.BetReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.BetReq
         * @static
         * @param {BullBullGame.IBetReq} message BetReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetReq message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.BetReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.BetReq} BetReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.BetReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.betType = reader.int32();
                    break;
                case 2:
                    message.outsourceBetType = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("betType"))
                throw $util.ProtocolError("missing required 'betType'", { instance: message });
            return message;
        };

        /**
         * Decodes a BetReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.BetReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.BetReq} BetReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetReq message.
         * @function verify
         * @memberof BullBullGame.BetReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.betType))
                return "betType: integer expected";
            if (message.outsourceBetType != null && message.hasOwnProperty("outsourceBetType"))
                if (!$util.isInteger(message.outsourceBetType) && !(message.outsourceBetType && $util.isInteger(message.outsourceBetType.low) && $util.isInteger(message.outsourceBetType.high)))
                    return "outsourceBetType: integer|Long expected";
            return null;
        };

        /**
         * Creates a BetReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.BetReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.BetReq} BetReq
         */
        BetReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.BetReq)
                return object;
            var message = new $root.BullBullGame.BetReq();
            if (object.betType != null)
                message.betType = object.betType | 0;
            if (object.outsourceBetType != null)
                if ($util.Long)
                    (message.outsourceBetType = $util.Long.fromValue(object.outsourceBetType)).unsigned = false;
                else if (typeof object.outsourceBetType === "string")
                    message.outsourceBetType = parseInt(object.outsourceBetType, 10);
                else if (typeof object.outsourceBetType === "number")
                    message.outsourceBetType = object.outsourceBetType;
                else if (typeof object.outsourceBetType === "object")
                    message.outsourceBetType = new $util.LongBits(object.outsourceBetType.low >>> 0, object.outsourceBetType.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a BetReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.BetReq
         * @static
         * @param {BullBullGame.BetReq} message BetReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.betType = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.outsourceBetType = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.outsourceBetType = options.longs === String ? "0" : 0;
            }
            if (message.betType != null && message.hasOwnProperty("betType"))
                object.betType = message.betType;
            if (message.outsourceBetType != null && message.hasOwnProperty("outsourceBetType"))
                if (typeof message.outsourceBetType === "number")
                    object.outsourceBetType = options.longs === String ? String(message.outsourceBetType) : message.outsourceBetType;
                else
                    object.outsourceBetType = options.longs === String ? $util.Long.prototype.toString.call(message.outsourceBetType) : options.longs === Number ? new $util.LongBits(message.outsourceBetType.low >>> 0, message.outsourceBetType.high >>> 0).toNumber() : message.outsourceBetType;
            return object;
        };

        /**
         * Converts this BetReq to JSON.
         * @function toJSON
         * @memberof BullBullGame.BetReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetReq;
    })();

    BullBullGame.BetRsp = (function() {

        /**
         * Properties of a BetRsp.
         * @memberof BullBullGame
         * @interface IBetRsp
         * @property {string} errNo BetRsp errNo
         * @property {number|null} [bet] BetRsp bet
         */

        /**
         * Constructs a new BetRsp.
         * @memberof BullBullGame
         * @classdesc Represents a BetRsp.
         * @implements IBetRsp
         * @constructor
         * @param {BullBullGame.IBetRsp=} [properties] Properties to set
         */
        function BetRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetRsp errNo.
         * @member {string} errNo
         * @memberof BullBullGame.BetRsp
         * @instance
         */
        BetRsp.prototype.errNo = "";

        /**
         * BetRsp bet.
         * @member {number} bet
         * @memberof BullBullGame.BetRsp
         * @instance
         */
        BetRsp.prototype.bet = 0;

        /**
         * Creates a new BetRsp instance using the specified properties.
         * @function create
         * @memberof BullBullGame.BetRsp
         * @static
         * @param {BullBullGame.IBetRsp=} [properties] Properties to set
         * @returns {BullBullGame.BetRsp} BetRsp instance
         */
        BetRsp.create = function create(properties) {
            return new BetRsp(properties);
        };

        /**
         * Encodes the specified BetRsp message. Does not implicitly {@link BullBullGame.BetRsp.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.BetRsp
         * @static
         * @param {BullBullGame.IBetRsp} message BetRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            if (message.bet != null && message.hasOwnProperty("bet"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.bet);
            return writer;
        };

        /**
         * Encodes the specified BetRsp message, length delimited. Does not implicitly {@link BullBullGame.BetRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.BetRsp
         * @static
         * @param {BullBullGame.IBetRsp} message BetRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.BetRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.BetRsp} BetRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.BetRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                case 2:
                    message.bet = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("errNo"))
                throw $util.ProtocolError("missing required 'errNo'", { instance: message });
            return message;
        };

        /**
         * Decodes a BetRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.BetRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.BetRsp} BetRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetRsp message.
         * @function verify
         * @memberof BullBullGame.BetRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.errNo))
                return "errNo: string expected";
            if (message.bet != null && message.hasOwnProperty("bet"))
                if (!$util.isInteger(message.bet))
                    return "bet: integer expected";
            return null;
        };

        /**
         * Creates a BetRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.BetRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.BetRsp} BetRsp
         */
        BetRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.BetRsp)
                return object;
            var message = new $root.BullBullGame.BetRsp();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            if (object.bet != null)
                message.bet = object.bet | 0;
            return message;
        };

        /**
         * Creates a plain object from a BetRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.BetRsp
         * @static
         * @param {BullBullGame.BetRsp} message BetRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errNo = "";
                object.bet = 0;
            }
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            if (message.bet != null && message.hasOwnProperty("bet"))
                object.bet = message.bet;
            return object;
        };

        /**
         * Converts this BetRsp to JSON.
         * @function toJSON
         * @memberof BullBullGame.BetRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetRsp;
    })();

    BullBullGame.TemporaryLeaveReq = (function() {

        /**
         * Properties of a TemporaryLeaveReq.
         * @memberof BullBullGame
         * @interface ITemporaryLeaveReq
         * @property {boolean} isTemporaryLeave TemporaryLeaveReq isTemporaryLeave
         */

        /**
         * Constructs a new TemporaryLeaveReq.
         * @memberof BullBullGame
         * @classdesc Represents a TemporaryLeaveReq.
         * @implements ITemporaryLeaveReq
         * @constructor
         * @param {BullBullGame.ITemporaryLeaveReq=} [properties] Properties to set
         */
        function TemporaryLeaveReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TemporaryLeaveReq isTemporaryLeave.
         * @member {boolean} isTemporaryLeave
         * @memberof BullBullGame.TemporaryLeaveReq
         * @instance
         */
        TemporaryLeaveReq.prototype.isTemporaryLeave = false;

        /**
         * Creates a new TemporaryLeaveReq instance using the specified properties.
         * @function create
         * @memberof BullBullGame.TemporaryLeaveReq
         * @static
         * @param {BullBullGame.ITemporaryLeaveReq=} [properties] Properties to set
         * @returns {BullBullGame.TemporaryLeaveReq} TemporaryLeaveReq instance
         */
        TemporaryLeaveReq.create = function create(properties) {
            return new TemporaryLeaveReq(properties);
        };

        /**
         * Encodes the specified TemporaryLeaveReq message. Does not implicitly {@link BullBullGame.TemporaryLeaveReq.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.TemporaryLeaveReq
         * @static
         * @param {BullBullGame.ITemporaryLeaveReq} message TemporaryLeaveReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TemporaryLeaveReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isTemporaryLeave);
            return writer;
        };

        /**
         * Encodes the specified TemporaryLeaveReq message, length delimited. Does not implicitly {@link BullBullGame.TemporaryLeaveReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.TemporaryLeaveReq
         * @static
         * @param {BullBullGame.ITemporaryLeaveReq} message TemporaryLeaveReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TemporaryLeaveReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TemporaryLeaveReq message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.TemporaryLeaveReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.TemporaryLeaveReq} TemporaryLeaveReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TemporaryLeaveReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.TemporaryLeaveReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.isTemporaryLeave = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("isTemporaryLeave"))
                throw $util.ProtocolError("missing required 'isTemporaryLeave'", { instance: message });
            return message;
        };

        /**
         * Decodes a TemporaryLeaveReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.TemporaryLeaveReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.TemporaryLeaveReq} TemporaryLeaveReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TemporaryLeaveReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TemporaryLeaveReq message.
         * @function verify
         * @memberof BullBullGame.TemporaryLeaveReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TemporaryLeaveReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (typeof message.isTemporaryLeave !== "boolean")
                return "isTemporaryLeave: boolean expected";
            return null;
        };

        /**
         * Creates a TemporaryLeaveReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.TemporaryLeaveReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.TemporaryLeaveReq} TemporaryLeaveReq
         */
        TemporaryLeaveReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.TemporaryLeaveReq)
                return object;
            var message = new $root.BullBullGame.TemporaryLeaveReq();
            if (object.isTemporaryLeave != null)
                message.isTemporaryLeave = Boolean(object.isTemporaryLeave);
            return message;
        };

        /**
         * Creates a plain object from a TemporaryLeaveReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.TemporaryLeaveReq
         * @static
         * @param {BullBullGame.TemporaryLeaveReq} message TemporaryLeaveReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TemporaryLeaveReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.isTemporaryLeave = false;
            if (message.isTemporaryLeave != null && message.hasOwnProperty("isTemporaryLeave"))
                object.isTemporaryLeave = message.isTemporaryLeave;
            return object;
        };

        /**
         * Converts this TemporaryLeaveReq to JSON.
         * @function toJSON
         * @memberof BullBullGame.TemporaryLeaveReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TemporaryLeaveReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TemporaryLeaveReq;
    })();

    BullBullGame.TemporaryLeaveRsp = (function() {

        /**
         * Properties of a TemporaryLeaveRsp.
         * @memberof BullBullGame
         * @interface ITemporaryLeaveRsp
         * @property {string} errNo TemporaryLeaveRsp errNo
         */

        /**
         * Constructs a new TemporaryLeaveRsp.
         * @memberof BullBullGame
         * @classdesc Represents a TemporaryLeaveRsp.
         * @implements ITemporaryLeaveRsp
         * @constructor
         * @param {BullBullGame.ITemporaryLeaveRsp=} [properties] Properties to set
         */
        function TemporaryLeaveRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TemporaryLeaveRsp errNo.
         * @member {string} errNo
         * @memberof BullBullGame.TemporaryLeaveRsp
         * @instance
         */
        TemporaryLeaveRsp.prototype.errNo = "";

        /**
         * Creates a new TemporaryLeaveRsp instance using the specified properties.
         * @function create
         * @memberof BullBullGame.TemporaryLeaveRsp
         * @static
         * @param {BullBullGame.ITemporaryLeaveRsp=} [properties] Properties to set
         * @returns {BullBullGame.TemporaryLeaveRsp} TemporaryLeaveRsp instance
         */
        TemporaryLeaveRsp.create = function create(properties) {
            return new TemporaryLeaveRsp(properties);
        };

        /**
         * Encodes the specified TemporaryLeaveRsp message. Does not implicitly {@link BullBullGame.TemporaryLeaveRsp.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.TemporaryLeaveRsp
         * @static
         * @param {BullBullGame.ITemporaryLeaveRsp} message TemporaryLeaveRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TemporaryLeaveRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified TemporaryLeaveRsp message, length delimited. Does not implicitly {@link BullBullGame.TemporaryLeaveRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.TemporaryLeaveRsp
         * @static
         * @param {BullBullGame.ITemporaryLeaveRsp} message TemporaryLeaveRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TemporaryLeaveRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TemporaryLeaveRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.TemporaryLeaveRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.TemporaryLeaveRsp} TemporaryLeaveRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TemporaryLeaveRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.TemporaryLeaveRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("errNo"))
                throw $util.ProtocolError("missing required 'errNo'", { instance: message });
            return message;
        };

        /**
         * Decodes a TemporaryLeaveRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.TemporaryLeaveRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.TemporaryLeaveRsp} TemporaryLeaveRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TemporaryLeaveRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TemporaryLeaveRsp message.
         * @function verify
         * @memberof BullBullGame.TemporaryLeaveRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TemporaryLeaveRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.errNo))
                return "errNo: string expected";
            return null;
        };

        /**
         * Creates a TemporaryLeaveRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.TemporaryLeaveRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.TemporaryLeaveRsp} TemporaryLeaveRsp
         */
        TemporaryLeaveRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.TemporaryLeaveRsp)
                return object;
            var message = new $root.BullBullGame.TemporaryLeaveRsp();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            return message;
        };

        /**
         * Creates a plain object from a TemporaryLeaveRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.TemporaryLeaveRsp
         * @static
         * @param {BullBullGame.TemporaryLeaveRsp} message TemporaryLeaveRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TemporaryLeaveRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = "";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this TemporaryLeaveRsp to JSON.
         * @function toJSON
         * @memberof BullBullGame.TemporaryLeaveRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TemporaryLeaveRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TemporaryLeaveRsp;
    })();

    BullBullGame.SetBankerBroadcast = (function() {

        /**
         * Properties of a SetBankerBroadcast.
         * @memberof BullBullGame
         * @interface ISetBankerBroadcast
         * @property {number} playerId SetBankerBroadcast playerId
         * @property {Array.<number>|null} [scrambleBankerList] SetBankerBroadcast scrambleBankerList
         * @property {Array.<number>|null} [randomBankerList] SetBankerBroadcast randomBankerList
         */

        /**
         * Constructs a new SetBankerBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a SetBankerBroadcast.
         * @implements ISetBankerBroadcast
         * @constructor
         * @param {BullBullGame.ISetBankerBroadcast=} [properties] Properties to set
         */
        function SetBankerBroadcast(properties) {
            this.scrambleBankerList = [];
            this.randomBankerList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetBankerBroadcast playerId.
         * @member {number} playerId
         * @memberof BullBullGame.SetBankerBroadcast
         * @instance
         */
        SetBankerBroadcast.prototype.playerId = 0;

        /**
         * SetBankerBroadcast scrambleBankerList.
         * @member {Array.<number>} scrambleBankerList
         * @memberof BullBullGame.SetBankerBroadcast
         * @instance
         */
        SetBankerBroadcast.prototype.scrambleBankerList = $util.emptyArray;

        /**
         * SetBankerBroadcast randomBankerList.
         * @member {Array.<number>} randomBankerList
         * @memberof BullBullGame.SetBankerBroadcast
         * @instance
         */
        SetBankerBroadcast.prototype.randomBankerList = $util.emptyArray;

        /**
         * Creates a new SetBankerBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.SetBankerBroadcast
         * @static
         * @param {BullBullGame.ISetBankerBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.SetBankerBroadcast} SetBankerBroadcast instance
         */
        SetBankerBroadcast.create = function create(properties) {
            return new SetBankerBroadcast(properties);
        };

        /**
         * Encodes the specified SetBankerBroadcast message. Does not implicitly {@link BullBullGame.SetBankerBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.SetBankerBroadcast
         * @static
         * @param {BullBullGame.ISetBankerBroadcast} message SetBankerBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetBankerBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            if (message.scrambleBankerList != null && message.scrambleBankerList.length)
                for (var i = 0; i < message.scrambleBankerList.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.scrambleBankerList[i]);
            if (message.randomBankerList != null && message.randomBankerList.length)
                for (var i = 0; i < message.randomBankerList.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.randomBankerList[i]);
            return writer;
        };

        /**
         * Encodes the specified SetBankerBroadcast message, length delimited. Does not implicitly {@link BullBullGame.SetBankerBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.SetBankerBroadcast
         * @static
         * @param {BullBullGame.ISetBankerBroadcast} message SetBankerBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetBankerBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SetBankerBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.SetBankerBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.SetBankerBroadcast} SetBankerBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetBankerBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.SetBankerBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    if (!(message.scrambleBankerList && message.scrambleBankerList.length))
                        message.scrambleBankerList = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.scrambleBankerList.push(reader.int32());
                    } else
                        message.scrambleBankerList.push(reader.int32());
                    break;
                case 3:
                    if (!(message.randomBankerList && message.randomBankerList.length))
                        message.randomBankerList = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.randomBankerList.push(reader.int32());
                    } else
                        message.randomBankerList.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            return message;
        };

        /**
         * Decodes a SetBankerBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.SetBankerBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.SetBankerBroadcast} SetBankerBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetBankerBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SetBankerBroadcast message.
         * @function verify
         * @memberof BullBullGame.SetBankerBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SetBankerBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (message.scrambleBankerList != null && message.hasOwnProperty("scrambleBankerList")) {
                if (!Array.isArray(message.scrambleBankerList))
                    return "scrambleBankerList: array expected";
                for (var i = 0; i < message.scrambleBankerList.length; ++i)
                    if (!$util.isInteger(message.scrambleBankerList[i]))
                        return "scrambleBankerList: integer[] expected";
            }
            if (message.randomBankerList != null && message.hasOwnProperty("randomBankerList")) {
                if (!Array.isArray(message.randomBankerList))
                    return "randomBankerList: array expected";
                for (var i = 0; i < message.randomBankerList.length; ++i)
                    if (!$util.isInteger(message.randomBankerList[i]))
                        return "randomBankerList: integer[] expected";
            }
            return null;
        };

        /**
         * Creates a SetBankerBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.SetBankerBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.SetBankerBroadcast} SetBankerBroadcast
         */
        SetBankerBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.SetBankerBroadcast)
                return object;
            var message = new $root.BullBullGame.SetBankerBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.scrambleBankerList) {
                if (!Array.isArray(object.scrambleBankerList))
                    throw TypeError(".BullBullGame.SetBankerBroadcast.scrambleBankerList: array expected");
                message.scrambleBankerList = [];
                for (var i = 0; i < object.scrambleBankerList.length; ++i)
                    message.scrambleBankerList[i] = object.scrambleBankerList[i] | 0;
            }
            if (object.randomBankerList) {
                if (!Array.isArray(object.randomBankerList))
                    throw TypeError(".BullBullGame.SetBankerBroadcast.randomBankerList: array expected");
                message.randomBankerList = [];
                for (var i = 0; i < object.randomBankerList.length; ++i)
                    message.randomBankerList[i] = object.randomBankerList[i] | 0;
            }
            return message;
        };

        /**
         * Creates a plain object from a SetBankerBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.SetBankerBroadcast
         * @static
         * @param {BullBullGame.SetBankerBroadcast} message SetBankerBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SetBankerBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.scrambleBankerList = [];
                object.randomBankerList = [];
            }
            if (options.defaults)
                object.playerId = 0;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.scrambleBankerList && message.scrambleBankerList.length) {
                object.scrambleBankerList = [];
                for (var j = 0; j < message.scrambleBankerList.length; ++j)
                    object.scrambleBankerList[j] = message.scrambleBankerList[j];
            }
            if (message.randomBankerList && message.randomBankerList.length) {
                object.randomBankerList = [];
                for (var j = 0; j < message.randomBankerList.length; ++j)
                    object.randomBankerList[j] = message.randomBankerList[j];
            }
            return object;
        };

        /**
         * Converts this SetBankerBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.SetBankerBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SetBankerBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SetBankerBroadcast;
    })();

    BullBullGame.BetBroadcast = (function() {

        /**
         * Properties of a BetBroadcast.
         * @memberof BullBullGame
         * @interface IBetBroadcast
         * @property {number} playerId BetBroadcast playerId
         * @property {number} bet BetBroadcast bet
         * @property {number|Long|null} [outsourceBet] BetBroadcast outsourceBet
         */

        /**
         * Constructs a new BetBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a BetBroadcast.
         * @implements IBetBroadcast
         * @constructor
         * @param {BullBullGame.IBetBroadcast=} [properties] Properties to set
         */
        function BetBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BetBroadcast playerId.
         * @member {number} playerId
         * @memberof BullBullGame.BetBroadcast
         * @instance
         */
        BetBroadcast.prototype.playerId = 0;

        /**
         * BetBroadcast bet.
         * @member {number} bet
         * @memberof BullBullGame.BetBroadcast
         * @instance
         */
        BetBroadcast.prototype.bet = 0;

        /**
         * BetBroadcast outsourceBet.
         * @member {number|Long} outsourceBet
         * @memberof BullBullGame.BetBroadcast
         * @instance
         */
        BetBroadcast.prototype.outsourceBet = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new BetBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.BetBroadcast
         * @static
         * @param {BullBullGame.IBetBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.BetBroadcast} BetBroadcast instance
         */
        BetBroadcast.create = function create(properties) {
            return new BetBroadcast(properties);
        };

        /**
         * Encodes the specified BetBroadcast message. Does not implicitly {@link BullBullGame.BetBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.BetBroadcast
         * @static
         * @param {BullBullGame.IBetBroadcast} message BetBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.bet);
            if (message.outsourceBet != null && message.hasOwnProperty("outsourceBet"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.outsourceBet);
            return writer;
        };

        /**
         * Encodes the specified BetBroadcast message, length delimited. Does not implicitly {@link BullBullGame.BetBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.BetBroadcast
         * @static
         * @param {BullBullGame.IBetBroadcast} message BetBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BetBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BetBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.BetBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.BetBroadcast} BetBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.BetBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.bet = reader.int32();
                    break;
                case 3:
                    message.outsourceBet = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            if (!message.hasOwnProperty("bet"))
                throw $util.ProtocolError("missing required 'bet'", { instance: message });
            return message;
        };

        /**
         * Decodes a BetBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.BetBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.BetBroadcast} BetBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BetBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BetBroadcast message.
         * @function verify
         * @memberof BullBullGame.BetBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BetBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (!$util.isInteger(message.bet))
                return "bet: integer expected";
            if (message.outsourceBet != null && message.hasOwnProperty("outsourceBet"))
                if (!$util.isInteger(message.outsourceBet) && !(message.outsourceBet && $util.isInteger(message.outsourceBet.low) && $util.isInteger(message.outsourceBet.high)))
                    return "outsourceBet: integer|Long expected";
            return null;
        };

        /**
         * Creates a BetBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.BetBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.BetBroadcast} BetBroadcast
         */
        BetBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.BetBroadcast)
                return object;
            var message = new $root.BullBullGame.BetBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.bet != null)
                message.bet = object.bet | 0;
            if (object.outsourceBet != null)
                if ($util.Long)
                    (message.outsourceBet = $util.Long.fromValue(object.outsourceBet)).unsigned = false;
                else if (typeof object.outsourceBet === "string")
                    message.outsourceBet = parseInt(object.outsourceBet, 10);
                else if (typeof object.outsourceBet === "number")
                    message.outsourceBet = object.outsourceBet;
                else if (typeof object.outsourceBet === "object")
                    message.outsourceBet = new $util.LongBits(object.outsourceBet.low >>> 0, object.outsourceBet.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a BetBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.BetBroadcast
         * @static
         * @param {BullBullGame.BetBroadcast} message BetBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BetBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.bet = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.outsourceBet = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.outsourceBet = options.longs === String ? "0" : 0;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.bet != null && message.hasOwnProperty("bet"))
                object.bet = message.bet;
            if (message.outsourceBet != null && message.hasOwnProperty("outsourceBet"))
                if (typeof message.outsourceBet === "number")
                    object.outsourceBet = options.longs === String ? String(message.outsourceBet) : message.outsourceBet;
                else
                    object.outsourceBet = options.longs === String ? $util.Long.prototype.toString.call(message.outsourceBet) : options.longs === Number ? new $util.LongBits(message.outsourceBet.low >>> 0, message.outsourceBet.high >>> 0).toNumber() : message.outsourceBet;
            return object;
        };

        /**
         * Converts this BetBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.BetBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BetBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BetBroadcast;
    })();

    BullBullGame.DealPokerBroadcast = (function() {

        /**
         * Properties of a DealPokerBroadcast.
         * @memberof BullBullGame
         * @interface IDealPokerBroadcast
         * @property {number} type DealPokerBroadcast type
         * @property {Array.<BullBullGame.IPoker>|null} [pokers] DealPokerBroadcast pokers
         * @property {string|null} [comboType] DealPokerBroadcast comboType
         */

        /**
         * Constructs a new DealPokerBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a DealPokerBroadcast.
         * @implements IDealPokerBroadcast
         * @constructor
         * @param {BullBullGame.IDealPokerBroadcast=} [properties] Properties to set
         */
        function DealPokerBroadcast(properties) {
            this.pokers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DealPokerBroadcast type.
         * @member {number} type
         * @memberof BullBullGame.DealPokerBroadcast
         * @instance
         */
        DealPokerBroadcast.prototype.type = 0;

        /**
         * DealPokerBroadcast pokers.
         * @member {Array.<BullBullGame.IPoker>} pokers
         * @memberof BullBullGame.DealPokerBroadcast
         * @instance
         */
        DealPokerBroadcast.prototype.pokers = $util.emptyArray;

        /**
         * DealPokerBroadcast comboType.
         * @member {string} comboType
         * @memberof BullBullGame.DealPokerBroadcast
         * @instance
         */
        DealPokerBroadcast.prototype.comboType = "";

        /**
         * Creates a new DealPokerBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.DealPokerBroadcast
         * @static
         * @param {BullBullGame.IDealPokerBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.DealPokerBroadcast} DealPokerBroadcast instance
         */
        DealPokerBroadcast.create = function create(properties) {
            return new DealPokerBroadcast(properties);
        };

        /**
         * Encodes the specified DealPokerBroadcast message. Does not implicitly {@link BullBullGame.DealPokerBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.DealPokerBroadcast
         * @static
         * @param {BullBullGame.IDealPokerBroadcast} message DealPokerBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DealPokerBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
            if (message.pokers != null && message.pokers.length)
                for (var i = 0; i < message.pokers.length; ++i)
                    $root.BullBullGame.Poker.encode(message.pokers[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.comboType);
            return writer;
        };

        /**
         * Encodes the specified DealPokerBroadcast message, length delimited. Does not implicitly {@link BullBullGame.DealPokerBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.DealPokerBroadcast
         * @static
         * @param {BullBullGame.IDealPokerBroadcast} message DealPokerBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DealPokerBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DealPokerBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.DealPokerBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.DealPokerBroadcast} DealPokerBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DealPokerBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.DealPokerBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    if (!(message.pokers && message.pokers.length))
                        message.pokers = [];
                    message.pokers.push($root.BullBullGame.Poker.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.comboType = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            return message;
        };

        /**
         * Decodes a DealPokerBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.DealPokerBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.DealPokerBroadcast} DealPokerBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DealPokerBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DealPokerBroadcast message.
         * @function verify
         * @memberof BullBullGame.DealPokerBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DealPokerBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.type))
                return "type: integer expected";
            if (message.pokers != null && message.hasOwnProperty("pokers")) {
                if (!Array.isArray(message.pokers))
                    return "pokers: array expected";
                for (var i = 0; i < message.pokers.length; ++i) {
                    var error = $root.BullBullGame.Poker.verify(message.pokers[i]);
                    if (error)
                        return "pokers." + error;
                }
            }
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                if (!$util.isString(message.comboType))
                    return "comboType: string expected";
            return null;
        };

        /**
         * Creates a DealPokerBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.DealPokerBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.DealPokerBroadcast} DealPokerBroadcast
         */
        DealPokerBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.DealPokerBroadcast)
                return object;
            var message = new $root.BullBullGame.DealPokerBroadcast();
            if (object.type != null)
                message.type = object.type | 0;
            if (object.pokers) {
                if (!Array.isArray(object.pokers))
                    throw TypeError(".BullBullGame.DealPokerBroadcast.pokers: array expected");
                message.pokers = [];
                for (var i = 0; i < object.pokers.length; ++i) {
                    if (typeof object.pokers[i] !== "object")
                        throw TypeError(".BullBullGame.DealPokerBroadcast.pokers: object expected");
                    message.pokers[i] = $root.BullBullGame.Poker.fromObject(object.pokers[i]);
                }
            }
            if (object.comboType != null)
                message.comboType = String(object.comboType);
            return message;
        };

        /**
         * Creates a plain object from a DealPokerBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.DealPokerBroadcast
         * @static
         * @param {BullBullGame.DealPokerBroadcast} message DealPokerBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DealPokerBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.pokers = [];
            if (options.defaults) {
                object.type = 0;
                object.comboType = "";
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.pokers && message.pokers.length) {
                object.pokers = [];
                for (var j = 0; j < message.pokers.length; ++j)
                    object.pokers[j] = $root.BullBullGame.Poker.toObject(message.pokers[j], options);
            }
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                object.comboType = message.comboType;
            return object;
        };

        /**
         * Converts this DealPokerBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.DealPokerBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DealPokerBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DealPokerBroadcast;
    })();

    BullBullGame.ComputePokerBroadcast = (function() {

        /**
         * Properties of a ComputePokerBroadcast.
         * @memberof BullBullGame
         * @interface IComputePokerBroadcast
         * @property {number} playerId ComputePokerBroadcast playerId
         * @property {Array.<BullBullGame.IPoker>|null} [pokers] ComputePokerBroadcast pokers
         * @property {string|null} [comboType] ComputePokerBroadcast comboType
         */

        /**
         * Constructs a new ComputePokerBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a ComputePokerBroadcast.
         * @implements IComputePokerBroadcast
         * @constructor
         * @param {BullBullGame.IComputePokerBroadcast=} [properties] Properties to set
         */
        function ComputePokerBroadcast(properties) {
            this.pokers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComputePokerBroadcast playerId.
         * @member {number} playerId
         * @memberof BullBullGame.ComputePokerBroadcast
         * @instance
         */
        ComputePokerBroadcast.prototype.playerId = 0;

        /**
         * ComputePokerBroadcast pokers.
         * @member {Array.<BullBullGame.IPoker>} pokers
         * @memberof BullBullGame.ComputePokerBroadcast
         * @instance
         */
        ComputePokerBroadcast.prototype.pokers = $util.emptyArray;

        /**
         * ComputePokerBroadcast comboType.
         * @member {string} comboType
         * @memberof BullBullGame.ComputePokerBroadcast
         * @instance
         */
        ComputePokerBroadcast.prototype.comboType = "";

        /**
         * Creates a new ComputePokerBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ComputePokerBroadcast
         * @static
         * @param {BullBullGame.IComputePokerBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.ComputePokerBroadcast} ComputePokerBroadcast instance
         */
        ComputePokerBroadcast.create = function create(properties) {
            return new ComputePokerBroadcast(properties);
        };

        /**
         * Encodes the specified ComputePokerBroadcast message. Does not implicitly {@link BullBullGame.ComputePokerBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ComputePokerBroadcast
         * @static
         * @param {BullBullGame.IComputePokerBroadcast} message ComputePokerBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComputePokerBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            if (message.pokers != null && message.pokers.length)
                for (var i = 0; i < message.pokers.length; ++i)
                    $root.BullBullGame.Poker.encode(message.pokers[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.comboType);
            return writer;
        };

        /**
         * Encodes the specified ComputePokerBroadcast message, length delimited. Does not implicitly {@link BullBullGame.ComputePokerBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ComputePokerBroadcast
         * @static
         * @param {BullBullGame.IComputePokerBroadcast} message ComputePokerBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComputePokerBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ComputePokerBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ComputePokerBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ComputePokerBroadcast} ComputePokerBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComputePokerBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ComputePokerBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    if (!(message.pokers && message.pokers.length))
                        message.pokers = [];
                    message.pokers.push($root.BullBullGame.Poker.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.comboType = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            return message;
        };

        /**
         * Decodes a ComputePokerBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ComputePokerBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ComputePokerBroadcast} ComputePokerBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComputePokerBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ComputePokerBroadcast message.
         * @function verify
         * @memberof BullBullGame.ComputePokerBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ComputePokerBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (message.pokers != null && message.hasOwnProperty("pokers")) {
                if (!Array.isArray(message.pokers))
                    return "pokers: array expected";
                for (var i = 0; i < message.pokers.length; ++i) {
                    var error = $root.BullBullGame.Poker.verify(message.pokers[i]);
                    if (error)
                        return "pokers." + error;
                }
            }
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                if (!$util.isString(message.comboType))
                    return "comboType: string expected";
            return null;
        };

        /**
         * Creates a ComputePokerBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ComputePokerBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ComputePokerBroadcast} ComputePokerBroadcast
         */
        ComputePokerBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ComputePokerBroadcast)
                return object;
            var message = new $root.BullBullGame.ComputePokerBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.pokers) {
                if (!Array.isArray(object.pokers))
                    throw TypeError(".BullBullGame.ComputePokerBroadcast.pokers: array expected");
                message.pokers = [];
                for (var i = 0; i < object.pokers.length; ++i) {
                    if (typeof object.pokers[i] !== "object")
                        throw TypeError(".BullBullGame.ComputePokerBroadcast.pokers: object expected");
                    message.pokers[i] = $root.BullBullGame.Poker.fromObject(object.pokers[i]);
                }
            }
            if (object.comboType != null)
                message.comboType = String(object.comboType);
            return message;
        };

        /**
         * Creates a plain object from a ComputePokerBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ComputePokerBroadcast
         * @static
         * @param {BullBullGame.ComputePokerBroadcast} message ComputePokerBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComputePokerBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.pokers = [];
            if (options.defaults) {
                object.playerId = 0;
                object.comboType = "";
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.pokers && message.pokers.length) {
                object.pokers = [];
                for (var j = 0; j < message.pokers.length; ++j)
                    object.pokers[j] = $root.BullBullGame.Poker.toObject(message.pokers[j], options);
            }
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                object.comboType = message.comboType;
            return object;
        };

        /**
         * Converts this ComputePokerBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.ComputePokerBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComputePokerBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComputePokerBroadcast;
    })();

    BullBullGame.SettleAccountsBroadcast = (function() {

        /**
         * Properties of a SettleAccountsBroadcast.
         * @memberof BullBullGame
         * @interface ISettleAccountsBroadcast
         * @property {Array.<BullBullGame.ISettleAccounts>|null} [settleAccounts] SettleAccountsBroadcast settleAccounts
         * @property {string|null} [testStr] SettleAccountsBroadcast testStr
         */

        /**
         * Constructs a new SettleAccountsBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a SettleAccountsBroadcast.
         * @implements ISettleAccountsBroadcast
         * @constructor
         * @param {BullBullGame.ISettleAccountsBroadcast=} [properties] Properties to set
         */
        function SettleAccountsBroadcast(properties) {
            this.settleAccounts = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SettleAccountsBroadcast settleAccounts.
         * @member {Array.<BullBullGame.ISettleAccounts>} settleAccounts
         * @memberof BullBullGame.SettleAccountsBroadcast
         * @instance
         */
        SettleAccountsBroadcast.prototype.settleAccounts = $util.emptyArray;

        /**
         * SettleAccountsBroadcast testStr.
         * @member {string} testStr
         * @memberof BullBullGame.SettleAccountsBroadcast
         * @instance
         */
        SettleAccountsBroadcast.prototype.testStr = "";

        /**
         * Creates a new SettleAccountsBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.SettleAccountsBroadcast
         * @static
         * @param {BullBullGame.ISettleAccountsBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.SettleAccountsBroadcast} SettleAccountsBroadcast instance
         */
        SettleAccountsBroadcast.create = function create(properties) {
            return new SettleAccountsBroadcast(properties);
        };

        /**
         * Encodes the specified SettleAccountsBroadcast message. Does not implicitly {@link BullBullGame.SettleAccountsBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.SettleAccountsBroadcast
         * @static
         * @param {BullBullGame.ISettleAccountsBroadcast} message SettleAccountsBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SettleAccountsBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.settleAccounts != null && message.settleAccounts.length)
                for (var i = 0; i < message.settleAccounts.length; ++i)
                    $root.BullBullGame.SettleAccounts.encode(message.settleAccounts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.testStr != null && message.hasOwnProperty("testStr"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.testStr);
            return writer;
        };

        /**
         * Encodes the specified SettleAccountsBroadcast message, length delimited. Does not implicitly {@link BullBullGame.SettleAccountsBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.SettleAccountsBroadcast
         * @static
         * @param {BullBullGame.ISettleAccountsBroadcast} message SettleAccountsBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SettleAccountsBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SettleAccountsBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.SettleAccountsBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.SettleAccountsBroadcast} SettleAccountsBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SettleAccountsBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.SettleAccountsBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.settleAccounts && message.settleAccounts.length))
                        message.settleAccounts = [];
                    message.settleAccounts.push($root.BullBullGame.SettleAccounts.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.testStr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SettleAccountsBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.SettleAccountsBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.SettleAccountsBroadcast} SettleAccountsBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SettleAccountsBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SettleAccountsBroadcast message.
         * @function verify
         * @memberof BullBullGame.SettleAccountsBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SettleAccountsBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.settleAccounts != null && message.hasOwnProperty("settleAccounts")) {
                if (!Array.isArray(message.settleAccounts))
                    return "settleAccounts: array expected";
                for (var i = 0; i < message.settleAccounts.length; ++i) {
                    var error = $root.BullBullGame.SettleAccounts.verify(message.settleAccounts[i]);
                    if (error)
                        return "settleAccounts." + error;
                }
            }
            if (message.testStr != null && message.hasOwnProperty("testStr"))
                if (!$util.isString(message.testStr))
                    return "testStr: string expected";
            return null;
        };

        /**
         * Creates a SettleAccountsBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.SettleAccountsBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.SettleAccountsBroadcast} SettleAccountsBroadcast
         */
        SettleAccountsBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.SettleAccountsBroadcast)
                return object;
            var message = new $root.BullBullGame.SettleAccountsBroadcast();
            if (object.settleAccounts) {
                if (!Array.isArray(object.settleAccounts))
                    throw TypeError(".BullBullGame.SettleAccountsBroadcast.settleAccounts: array expected");
                message.settleAccounts = [];
                for (var i = 0; i < object.settleAccounts.length; ++i) {
                    if (typeof object.settleAccounts[i] !== "object")
                        throw TypeError(".BullBullGame.SettleAccountsBroadcast.settleAccounts: object expected");
                    message.settleAccounts[i] = $root.BullBullGame.SettleAccounts.fromObject(object.settleAccounts[i]);
                }
            }
            if (object.testStr != null)
                message.testStr = String(object.testStr);
            return message;
        };

        /**
         * Creates a plain object from a SettleAccountsBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.SettleAccountsBroadcast
         * @static
         * @param {BullBullGame.SettleAccountsBroadcast} message SettleAccountsBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SettleAccountsBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.settleAccounts = [];
            if (options.defaults)
                object.testStr = "";
            if (message.settleAccounts && message.settleAccounts.length) {
                object.settleAccounts = [];
                for (var j = 0; j < message.settleAccounts.length; ++j)
                    object.settleAccounts[j] = $root.BullBullGame.SettleAccounts.toObject(message.settleAccounts[j], options);
            }
            if (message.testStr != null && message.hasOwnProperty("testStr"))
                object.testStr = message.testStr;
            return object;
        };

        /**
         * Converts this SettleAccountsBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.SettleAccountsBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SettleAccountsBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SettleAccountsBroadcast;
    })();

    BullBullGame.AgoSettleAccountsBroadcast = (function() {

        /**
         * Properties of an AgoSettleAccountsBroadcast.
         * @memberof BullBullGame
         * @interface IAgoSettleAccountsBroadcast
         * @property {Array.<BullBullGame.ISettleAccounts>|null} [settleAccounts] AgoSettleAccountsBroadcast settleAccounts
         */

        /**
         * Constructs a new AgoSettleAccountsBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents an AgoSettleAccountsBroadcast.
         * @implements IAgoSettleAccountsBroadcast
         * @constructor
         * @param {BullBullGame.IAgoSettleAccountsBroadcast=} [properties] Properties to set
         */
        function AgoSettleAccountsBroadcast(properties) {
            this.settleAccounts = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AgoSettleAccountsBroadcast settleAccounts.
         * @member {Array.<BullBullGame.ISettleAccounts>} settleAccounts
         * @memberof BullBullGame.AgoSettleAccountsBroadcast
         * @instance
         */
        AgoSettleAccountsBroadcast.prototype.settleAccounts = $util.emptyArray;

        /**
         * Creates a new AgoSettleAccountsBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.AgoSettleAccountsBroadcast
         * @static
         * @param {BullBullGame.IAgoSettleAccountsBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.AgoSettleAccountsBroadcast} AgoSettleAccountsBroadcast instance
         */
        AgoSettleAccountsBroadcast.create = function create(properties) {
            return new AgoSettleAccountsBroadcast(properties);
        };

        /**
         * Encodes the specified AgoSettleAccountsBroadcast message. Does not implicitly {@link BullBullGame.AgoSettleAccountsBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.AgoSettleAccountsBroadcast
         * @static
         * @param {BullBullGame.IAgoSettleAccountsBroadcast} message AgoSettleAccountsBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AgoSettleAccountsBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.settleAccounts != null && message.settleAccounts.length)
                for (var i = 0; i < message.settleAccounts.length; ++i)
                    $root.BullBullGame.SettleAccounts.encode(message.settleAccounts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified AgoSettleAccountsBroadcast message, length delimited. Does not implicitly {@link BullBullGame.AgoSettleAccountsBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.AgoSettleAccountsBroadcast
         * @static
         * @param {BullBullGame.IAgoSettleAccountsBroadcast} message AgoSettleAccountsBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AgoSettleAccountsBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AgoSettleAccountsBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.AgoSettleAccountsBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.AgoSettleAccountsBroadcast} AgoSettleAccountsBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AgoSettleAccountsBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.AgoSettleAccountsBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.settleAccounts && message.settleAccounts.length))
                        message.settleAccounts = [];
                    message.settleAccounts.push($root.BullBullGame.SettleAccounts.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AgoSettleAccountsBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.AgoSettleAccountsBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.AgoSettleAccountsBroadcast} AgoSettleAccountsBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AgoSettleAccountsBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AgoSettleAccountsBroadcast message.
         * @function verify
         * @memberof BullBullGame.AgoSettleAccountsBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AgoSettleAccountsBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.settleAccounts != null && message.hasOwnProperty("settleAccounts")) {
                if (!Array.isArray(message.settleAccounts))
                    return "settleAccounts: array expected";
                for (var i = 0; i < message.settleAccounts.length; ++i) {
                    var error = $root.BullBullGame.SettleAccounts.verify(message.settleAccounts[i]);
                    if (error)
                        return "settleAccounts." + error;
                }
            }
            return null;
        };

        /**
         * Creates an AgoSettleAccountsBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.AgoSettleAccountsBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.AgoSettleAccountsBroadcast} AgoSettleAccountsBroadcast
         */
        AgoSettleAccountsBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.AgoSettleAccountsBroadcast)
                return object;
            var message = new $root.BullBullGame.AgoSettleAccountsBroadcast();
            if (object.settleAccounts) {
                if (!Array.isArray(object.settleAccounts))
                    throw TypeError(".BullBullGame.AgoSettleAccountsBroadcast.settleAccounts: array expected");
                message.settleAccounts = [];
                for (var i = 0; i < object.settleAccounts.length; ++i) {
                    if (typeof object.settleAccounts[i] !== "object")
                        throw TypeError(".BullBullGame.AgoSettleAccountsBroadcast.settleAccounts: object expected");
                    message.settleAccounts[i] = $root.BullBullGame.SettleAccounts.fromObject(object.settleAccounts[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an AgoSettleAccountsBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.AgoSettleAccountsBroadcast
         * @static
         * @param {BullBullGame.AgoSettleAccountsBroadcast} message AgoSettleAccountsBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AgoSettleAccountsBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.settleAccounts = [];
            if (message.settleAccounts && message.settleAccounts.length) {
                object.settleAccounts = [];
                for (var j = 0; j < message.settleAccounts.length; ++j)
                    object.settleAccounts[j] = $root.BullBullGame.SettleAccounts.toObject(message.settleAccounts[j], options);
            }
            return object;
        };

        /**
         * Converts this AgoSettleAccountsBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.AgoSettleAccountsBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AgoSettleAccountsBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AgoSettleAccountsBroadcast;
    })();

    BullBullGame.LastSettleAccountsBroadcast = (function() {

        /**
         * Properties of a LastSettleAccountsBroadcast.
         * @memberof BullBullGame
         * @interface ILastSettleAccountsBroadcast
         * @property {Array.<BullBullGame.ILastSettleAccounts>|null} [LastSettleAccounts] LastSettleAccountsBroadcast LastSettleAccounts
         * @property {number|null} [freeSponsor] LastSettleAccountsBroadcast freeSponsor
         */

        /**
         * Constructs a new LastSettleAccountsBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a LastSettleAccountsBroadcast.
         * @implements ILastSettleAccountsBroadcast
         * @constructor
         * @param {BullBullGame.ILastSettleAccountsBroadcast=} [properties] Properties to set
         */
        function LastSettleAccountsBroadcast(properties) {
            this.LastSettleAccounts = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LastSettleAccountsBroadcast LastSettleAccounts.
         * @member {Array.<BullBullGame.ILastSettleAccounts>} LastSettleAccounts
         * @memberof BullBullGame.LastSettleAccountsBroadcast
         * @instance
         */
        LastSettleAccountsBroadcast.prototype.LastSettleAccounts = $util.emptyArray;

        /**
         * LastSettleAccountsBroadcast freeSponsor.
         * @member {number} freeSponsor
         * @memberof BullBullGame.LastSettleAccountsBroadcast
         * @instance
         */
        LastSettleAccountsBroadcast.prototype.freeSponsor = 0;

        /**
         * Creates a new LastSettleAccountsBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.LastSettleAccountsBroadcast
         * @static
         * @param {BullBullGame.ILastSettleAccountsBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.LastSettleAccountsBroadcast} LastSettleAccountsBroadcast instance
         */
        LastSettleAccountsBroadcast.create = function create(properties) {
            return new LastSettleAccountsBroadcast(properties);
        };

        /**
         * Encodes the specified LastSettleAccountsBroadcast message. Does not implicitly {@link BullBullGame.LastSettleAccountsBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.LastSettleAccountsBroadcast
         * @static
         * @param {BullBullGame.ILastSettleAccountsBroadcast} message LastSettleAccountsBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LastSettleAccountsBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.LastSettleAccounts != null && message.LastSettleAccounts.length)
                for (var i = 0; i < message.LastSettleAccounts.length; ++i)
                    $root.BullBullGame.LastSettleAccounts.encode(message.LastSettleAccounts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.freeSponsor != null && message.hasOwnProperty("freeSponsor"))
                writer.uint32(/* id 20, wireType 0 =*/160).int32(message.freeSponsor);
            return writer;
        };

        /**
         * Encodes the specified LastSettleAccountsBroadcast message, length delimited. Does not implicitly {@link BullBullGame.LastSettleAccountsBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.LastSettleAccountsBroadcast
         * @static
         * @param {BullBullGame.ILastSettleAccountsBroadcast} message LastSettleAccountsBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LastSettleAccountsBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LastSettleAccountsBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.LastSettleAccountsBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.LastSettleAccountsBroadcast} LastSettleAccountsBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LastSettleAccountsBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.LastSettleAccountsBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.LastSettleAccounts && message.LastSettleAccounts.length))
                        message.LastSettleAccounts = [];
                    message.LastSettleAccounts.push($root.BullBullGame.LastSettleAccounts.decode(reader, reader.uint32()));
                    break;
                case 20:
                    message.freeSponsor = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LastSettleAccountsBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.LastSettleAccountsBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.LastSettleAccountsBroadcast} LastSettleAccountsBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LastSettleAccountsBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LastSettleAccountsBroadcast message.
         * @function verify
         * @memberof BullBullGame.LastSettleAccountsBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LastSettleAccountsBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.LastSettleAccounts != null && message.hasOwnProperty("LastSettleAccounts")) {
                if (!Array.isArray(message.LastSettleAccounts))
                    return "LastSettleAccounts: array expected";
                for (var i = 0; i < message.LastSettleAccounts.length; ++i) {
                    var error = $root.BullBullGame.LastSettleAccounts.verify(message.LastSettleAccounts[i]);
                    if (error)
                        return "LastSettleAccounts." + error;
                }
            }
            if (message.freeSponsor != null && message.hasOwnProperty("freeSponsor"))
                if (!$util.isInteger(message.freeSponsor))
                    return "freeSponsor: integer expected";
            return null;
        };

        /**
         * Creates a LastSettleAccountsBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.LastSettleAccountsBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.LastSettleAccountsBroadcast} LastSettleAccountsBroadcast
         */
        LastSettleAccountsBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.LastSettleAccountsBroadcast)
                return object;
            var message = new $root.BullBullGame.LastSettleAccountsBroadcast();
            if (object.LastSettleAccounts) {
                if (!Array.isArray(object.LastSettleAccounts))
                    throw TypeError(".BullBullGame.LastSettleAccountsBroadcast.LastSettleAccounts: array expected");
                message.LastSettleAccounts = [];
                for (var i = 0; i < object.LastSettleAccounts.length; ++i) {
                    if (typeof object.LastSettleAccounts[i] !== "object")
                        throw TypeError(".BullBullGame.LastSettleAccountsBroadcast.LastSettleAccounts: object expected");
                    message.LastSettleAccounts[i] = $root.BullBullGame.LastSettleAccounts.fromObject(object.LastSettleAccounts[i]);
                }
            }
            if (object.freeSponsor != null)
                message.freeSponsor = object.freeSponsor | 0;
            return message;
        };

        /**
         * Creates a plain object from a LastSettleAccountsBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.LastSettleAccountsBroadcast
         * @static
         * @param {BullBullGame.LastSettleAccountsBroadcast} message LastSettleAccountsBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LastSettleAccountsBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.LastSettleAccounts = [];
            if (options.defaults)
                object.freeSponsor = 0;
            if (message.LastSettleAccounts && message.LastSettleAccounts.length) {
                object.LastSettleAccounts = [];
                for (var j = 0; j < message.LastSettleAccounts.length; ++j)
                    object.LastSettleAccounts[j] = $root.BullBullGame.LastSettleAccounts.toObject(message.LastSettleAccounts[j], options);
            }
            if (message.freeSponsor != null && message.hasOwnProperty("freeSponsor"))
                object.freeSponsor = message.freeSponsor;
            return object;
        };

        /**
         * Converts this LastSettleAccountsBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.LastSettleAccountsBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LastSettleAccountsBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LastSettleAccountsBroadcast;
    })();

    BullBullGame.ScrmbleBankerNotify = (function() {

        /**
         * Properties of a ScrmbleBankerNotify.
         * @memberof BullBullGame
         * @interface IScrmbleBankerNotify
         * @property {number|null} [maxMultiple] ScrmbleBankerNotify maxMultiple
         */

        /**
         * Constructs a new ScrmbleBankerNotify.
         * @memberof BullBullGame
         * @classdesc Represents a ScrmbleBankerNotify.
         * @implements IScrmbleBankerNotify
         * @constructor
         * @param {BullBullGame.IScrmbleBankerNotify=} [properties] Properties to set
         */
        function ScrmbleBankerNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ScrmbleBankerNotify maxMultiple.
         * @member {number} maxMultiple
         * @memberof BullBullGame.ScrmbleBankerNotify
         * @instance
         */
        ScrmbleBankerNotify.prototype.maxMultiple = 0;

        /**
         * Creates a new ScrmbleBankerNotify instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ScrmbleBankerNotify
         * @static
         * @param {BullBullGame.IScrmbleBankerNotify=} [properties] Properties to set
         * @returns {BullBullGame.ScrmbleBankerNotify} ScrmbleBankerNotify instance
         */
        ScrmbleBankerNotify.create = function create(properties) {
            return new ScrmbleBankerNotify(properties);
        };

        /**
         * Encodes the specified ScrmbleBankerNotify message. Does not implicitly {@link BullBullGame.ScrmbleBankerNotify.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ScrmbleBankerNotify
         * @static
         * @param {BullBullGame.IScrmbleBankerNotify} message ScrmbleBankerNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScrmbleBankerNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.maxMultiple != null && message.hasOwnProperty("maxMultiple"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.maxMultiple);
            return writer;
        };

        /**
         * Encodes the specified ScrmbleBankerNotify message, length delimited. Does not implicitly {@link BullBullGame.ScrmbleBankerNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ScrmbleBankerNotify
         * @static
         * @param {BullBullGame.IScrmbleBankerNotify} message ScrmbleBankerNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScrmbleBankerNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ScrmbleBankerNotify message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ScrmbleBankerNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ScrmbleBankerNotify} ScrmbleBankerNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScrmbleBankerNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ScrmbleBankerNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.maxMultiple = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ScrmbleBankerNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ScrmbleBankerNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ScrmbleBankerNotify} ScrmbleBankerNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScrmbleBankerNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ScrmbleBankerNotify message.
         * @function verify
         * @memberof BullBullGame.ScrmbleBankerNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ScrmbleBankerNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.maxMultiple != null && message.hasOwnProperty("maxMultiple"))
                if (!$util.isInteger(message.maxMultiple))
                    return "maxMultiple: integer expected";
            return null;
        };

        /**
         * Creates a ScrmbleBankerNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ScrmbleBankerNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ScrmbleBankerNotify} ScrmbleBankerNotify
         */
        ScrmbleBankerNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ScrmbleBankerNotify)
                return object;
            var message = new $root.BullBullGame.ScrmbleBankerNotify();
            if (object.maxMultiple != null)
                message.maxMultiple = object.maxMultiple | 0;
            return message;
        };

        /**
         * Creates a plain object from a ScrmbleBankerNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ScrmbleBankerNotify
         * @static
         * @param {BullBullGame.ScrmbleBankerNotify} message ScrmbleBankerNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ScrmbleBankerNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.maxMultiple = 0;
            if (message.maxMultiple != null && message.hasOwnProperty("maxMultiple"))
                object.maxMultiple = message.maxMultiple;
            return object;
        };

        /**
         * Converts this ScrmbleBankerNotify to JSON.
         * @function toJSON
         * @memberof BullBullGame.ScrmbleBankerNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ScrmbleBankerNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ScrmbleBankerNotify;
    })();

    BullBullGame.ScrambleBankerReq = (function() {

        /**
         * Properties of a ScrambleBankerReq.
         * @memberof BullBullGame
         * @interface IScrambleBankerReq
         * @property {boolean} isScramble ScrambleBankerReq isScramble
         * @property {number|null} [multiple] ScrambleBankerReq multiple
         */

        /**
         * Constructs a new ScrambleBankerReq.
         * @memberof BullBullGame
         * @classdesc Represents a ScrambleBankerReq.
         * @implements IScrambleBankerReq
         * @constructor
         * @param {BullBullGame.IScrambleBankerReq=} [properties] Properties to set
         */
        function ScrambleBankerReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ScrambleBankerReq isScramble.
         * @member {boolean} isScramble
         * @memberof BullBullGame.ScrambleBankerReq
         * @instance
         */
        ScrambleBankerReq.prototype.isScramble = false;

        /**
         * ScrambleBankerReq multiple.
         * @member {number} multiple
         * @memberof BullBullGame.ScrambleBankerReq
         * @instance
         */
        ScrambleBankerReq.prototype.multiple = 0;

        /**
         * Creates a new ScrambleBankerReq instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ScrambleBankerReq
         * @static
         * @param {BullBullGame.IScrambleBankerReq=} [properties] Properties to set
         * @returns {BullBullGame.ScrambleBankerReq} ScrambleBankerReq instance
         */
        ScrambleBankerReq.create = function create(properties) {
            return new ScrambleBankerReq(properties);
        };

        /**
         * Encodes the specified ScrambleBankerReq message. Does not implicitly {@link BullBullGame.ScrambleBankerReq.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ScrambleBankerReq
         * @static
         * @param {BullBullGame.IScrambleBankerReq} message ScrambleBankerReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScrambleBankerReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isScramble);
            if (message.multiple != null && message.hasOwnProperty("multiple"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.multiple);
            return writer;
        };

        /**
         * Encodes the specified ScrambleBankerReq message, length delimited. Does not implicitly {@link BullBullGame.ScrambleBankerReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ScrambleBankerReq
         * @static
         * @param {BullBullGame.IScrambleBankerReq} message ScrambleBankerReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScrambleBankerReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ScrambleBankerReq message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ScrambleBankerReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ScrambleBankerReq} ScrambleBankerReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScrambleBankerReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ScrambleBankerReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.isScramble = reader.bool();
                    break;
                case 2:
                    message.multiple = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("isScramble"))
                throw $util.ProtocolError("missing required 'isScramble'", { instance: message });
            return message;
        };

        /**
         * Decodes a ScrambleBankerReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ScrambleBankerReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ScrambleBankerReq} ScrambleBankerReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScrambleBankerReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ScrambleBankerReq message.
         * @function verify
         * @memberof BullBullGame.ScrambleBankerReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ScrambleBankerReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (typeof message.isScramble !== "boolean")
                return "isScramble: boolean expected";
            if (message.multiple != null && message.hasOwnProperty("multiple"))
                if (!$util.isInteger(message.multiple))
                    return "multiple: integer expected";
            return null;
        };

        /**
         * Creates a ScrambleBankerReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ScrambleBankerReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ScrambleBankerReq} ScrambleBankerReq
         */
        ScrambleBankerReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ScrambleBankerReq)
                return object;
            var message = new $root.BullBullGame.ScrambleBankerReq();
            if (object.isScramble != null)
                message.isScramble = Boolean(object.isScramble);
            if (object.multiple != null)
                message.multiple = object.multiple | 0;
            return message;
        };

        /**
         * Creates a plain object from a ScrambleBankerReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ScrambleBankerReq
         * @static
         * @param {BullBullGame.ScrambleBankerReq} message ScrambleBankerReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ScrambleBankerReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.isScramble = false;
                object.multiple = 0;
            }
            if (message.isScramble != null && message.hasOwnProperty("isScramble"))
                object.isScramble = message.isScramble;
            if (message.multiple != null && message.hasOwnProperty("multiple"))
                object.multiple = message.multiple;
            return object;
        };

        /**
         * Converts this ScrambleBankerReq to JSON.
         * @function toJSON
         * @memberof BullBullGame.ScrambleBankerReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ScrambleBankerReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ScrambleBankerReq;
    })();

    BullBullGame.ScrambleBankerRsp = (function() {

        /**
         * Properties of a ScrambleBankerRsp.
         * @memberof BullBullGame
         * @interface IScrambleBankerRsp
         * @property {string} errNo ScrambleBankerRsp errNo
         * @property {boolean} isScramble ScrambleBankerRsp isScramble
         * @property {number|null} [multiple] ScrambleBankerRsp multiple
         */

        /**
         * Constructs a new ScrambleBankerRsp.
         * @memberof BullBullGame
         * @classdesc Represents a ScrambleBankerRsp.
         * @implements IScrambleBankerRsp
         * @constructor
         * @param {BullBullGame.IScrambleBankerRsp=} [properties] Properties to set
         */
        function ScrambleBankerRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ScrambleBankerRsp errNo.
         * @member {string} errNo
         * @memberof BullBullGame.ScrambleBankerRsp
         * @instance
         */
        ScrambleBankerRsp.prototype.errNo = "";

        /**
         * ScrambleBankerRsp isScramble.
         * @member {boolean} isScramble
         * @memberof BullBullGame.ScrambleBankerRsp
         * @instance
         */
        ScrambleBankerRsp.prototype.isScramble = false;

        /**
         * ScrambleBankerRsp multiple.
         * @member {number} multiple
         * @memberof BullBullGame.ScrambleBankerRsp
         * @instance
         */
        ScrambleBankerRsp.prototype.multiple = 0;

        /**
         * Creates a new ScrambleBankerRsp instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ScrambleBankerRsp
         * @static
         * @param {BullBullGame.IScrambleBankerRsp=} [properties] Properties to set
         * @returns {BullBullGame.ScrambleBankerRsp} ScrambleBankerRsp instance
         */
        ScrambleBankerRsp.create = function create(properties) {
            return new ScrambleBankerRsp(properties);
        };

        /**
         * Encodes the specified ScrambleBankerRsp message. Does not implicitly {@link BullBullGame.ScrambleBankerRsp.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ScrambleBankerRsp
         * @static
         * @param {BullBullGame.IScrambleBankerRsp} message ScrambleBankerRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScrambleBankerRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isScramble);
            if (message.multiple != null && message.hasOwnProperty("multiple"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.multiple);
            return writer;
        };

        /**
         * Encodes the specified ScrambleBankerRsp message, length delimited. Does not implicitly {@link BullBullGame.ScrambleBankerRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ScrambleBankerRsp
         * @static
         * @param {BullBullGame.IScrambleBankerRsp} message ScrambleBankerRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScrambleBankerRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ScrambleBankerRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ScrambleBankerRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ScrambleBankerRsp} ScrambleBankerRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScrambleBankerRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ScrambleBankerRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                case 2:
                    message.isScramble = reader.bool();
                    break;
                case 3:
                    message.multiple = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("errNo"))
                throw $util.ProtocolError("missing required 'errNo'", { instance: message });
            if (!message.hasOwnProperty("isScramble"))
                throw $util.ProtocolError("missing required 'isScramble'", { instance: message });
            return message;
        };

        /**
         * Decodes a ScrambleBankerRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ScrambleBankerRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ScrambleBankerRsp} ScrambleBankerRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScrambleBankerRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ScrambleBankerRsp message.
         * @function verify
         * @memberof BullBullGame.ScrambleBankerRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ScrambleBankerRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.errNo))
                return "errNo: string expected";
            if (typeof message.isScramble !== "boolean")
                return "isScramble: boolean expected";
            if (message.multiple != null && message.hasOwnProperty("multiple"))
                if (!$util.isInteger(message.multiple))
                    return "multiple: integer expected";
            return null;
        };

        /**
         * Creates a ScrambleBankerRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ScrambleBankerRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ScrambleBankerRsp} ScrambleBankerRsp
         */
        ScrambleBankerRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ScrambleBankerRsp)
                return object;
            var message = new $root.BullBullGame.ScrambleBankerRsp();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            if (object.isScramble != null)
                message.isScramble = Boolean(object.isScramble);
            if (object.multiple != null)
                message.multiple = object.multiple | 0;
            return message;
        };

        /**
         * Creates a plain object from a ScrambleBankerRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ScrambleBankerRsp
         * @static
         * @param {BullBullGame.ScrambleBankerRsp} message ScrambleBankerRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ScrambleBankerRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errNo = "";
                object.isScramble = false;
                object.multiple = 0;
            }
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            if (message.isScramble != null && message.hasOwnProperty("isScramble"))
                object.isScramble = message.isScramble;
            if (message.multiple != null && message.hasOwnProperty("multiple"))
                object.multiple = message.multiple;
            return object;
        };

        /**
         * Converts this ScrambleBankerRsp to JSON.
         * @function toJSON
         * @memberof BullBullGame.ScrambleBankerRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ScrambleBankerRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ScrambleBankerRsp;
    })();

    BullBullGame.ScrambleBankerBroadcast = (function() {

        /**
         * Properties of a ScrambleBankerBroadcast.
         * @memberof BullBullGame
         * @interface IScrambleBankerBroadcast
         * @property {number} playerId ScrambleBankerBroadcast playerId
         * @property {boolean} isScramble ScrambleBankerBroadcast isScramble
         * @property {number|null} [multiple] ScrambleBankerBroadcast multiple
         */

        /**
         * Constructs a new ScrambleBankerBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a ScrambleBankerBroadcast.
         * @implements IScrambleBankerBroadcast
         * @constructor
         * @param {BullBullGame.IScrambleBankerBroadcast=} [properties] Properties to set
         */
        function ScrambleBankerBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ScrambleBankerBroadcast playerId.
         * @member {number} playerId
         * @memberof BullBullGame.ScrambleBankerBroadcast
         * @instance
         */
        ScrambleBankerBroadcast.prototype.playerId = 0;

        /**
         * ScrambleBankerBroadcast isScramble.
         * @member {boolean} isScramble
         * @memberof BullBullGame.ScrambleBankerBroadcast
         * @instance
         */
        ScrambleBankerBroadcast.prototype.isScramble = false;

        /**
         * ScrambleBankerBroadcast multiple.
         * @member {number} multiple
         * @memberof BullBullGame.ScrambleBankerBroadcast
         * @instance
         */
        ScrambleBankerBroadcast.prototype.multiple = 0;

        /**
         * Creates a new ScrambleBankerBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ScrambleBankerBroadcast
         * @static
         * @param {BullBullGame.IScrambleBankerBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.ScrambleBankerBroadcast} ScrambleBankerBroadcast instance
         */
        ScrambleBankerBroadcast.create = function create(properties) {
            return new ScrambleBankerBroadcast(properties);
        };

        /**
         * Encodes the specified ScrambleBankerBroadcast message. Does not implicitly {@link BullBullGame.ScrambleBankerBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ScrambleBankerBroadcast
         * @static
         * @param {BullBullGame.IScrambleBankerBroadcast} message ScrambleBankerBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScrambleBankerBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isScramble);
            if (message.multiple != null && message.hasOwnProperty("multiple"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.multiple);
            return writer;
        };

        /**
         * Encodes the specified ScrambleBankerBroadcast message, length delimited. Does not implicitly {@link BullBullGame.ScrambleBankerBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ScrambleBankerBroadcast
         * @static
         * @param {BullBullGame.IScrambleBankerBroadcast} message ScrambleBankerBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ScrambleBankerBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ScrambleBankerBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ScrambleBankerBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ScrambleBankerBroadcast} ScrambleBankerBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScrambleBankerBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ScrambleBankerBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.isScramble = reader.bool();
                    break;
                case 3:
                    message.multiple = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            if (!message.hasOwnProperty("isScramble"))
                throw $util.ProtocolError("missing required 'isScramble'", { instance: message });
            return message;
        };

        /**
         * Decodes a ScrambleBankerBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ScrambleBankerBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ScrambleBankerBroadcast} ScrambleBankerBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ScrambleBankerBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ScrambleBankerBroadcast message.
         * @function verify
         * @memberof BullBullGame.ScrambleBankerBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ScrambleBankerBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (typeof message.isScramble !== "boolean")
                return "isScramble: boolean expected";
            if (message.multiple != null && message.hasOwnProperty("multiple"))
                if (!$util.isInteger(message.multiple))
                    return "multiple: integer expected";
            return null;
        };

        /**
         * Creates a ScrambleBankerBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ScrambleBankerBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ScrambleBankerBroadcast} ScrambleBankerBroadcast
         */
        ScrambleBankerBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ScrambleBankerBroadcast)
                return object;
            var message = new $root.BullBullGame.ScrambleBankerBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.isScramble != null)
                message.isScramble = Boolean(object.isScramble);
            if (object.multiple != null)
                message.multiple = object.multiple | 0;
            return message;
        };

        /**
         * Creates a plain object from a ScrambleBankerBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ScrambleBankerBroadcast
         * @static
         * @param {BullBullGame.ScrambleBankerBroadcast} message ScrambleBankerBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ScrambleBankerBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.isScramble = false;
                object.multiple = 0;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.isScramble != null && message.hasOwnProperty("isScramble"))
                object.isScramble = message.isScramble;
            if (message.multiple != null && message.hasOwnProperty("multiple"))
                object.multiple = message.multiple;
            return object;
        };

        /**
         * Converts this ScrambleBankerBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.ScrambleBankerBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ScrambleBankerBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ScrambleBankerBroadcast;
    })();

    BullBullGame.TemporaryLeaveBroadcast = (function() {

        /**
         * Properties of a TemporaryLeaveBroadcast.
         * @memberof BullBullGame
         * @interface ITemporaryLeaveBroadcast
         * @property {number} playerId TemporaryLeaveBroadcast playerId
         * @property {boolean} isTemporaryLeave TemporaryLeaveBroadcast isTemporaryLeave
         */

        /**
         * Constructs a new TemporaryLeaveBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a TemporaryLeaveBroadcast.
         * @implements ITemporaryLeaveBroadcast
         * @constructor
         * @param {BullBullGame.ITemporaryLeaveBroadcast=} [properties] Properties to set
         */
        function TemporaryLeaveBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TemporaryLeaveBroadcast playerId.
         * @member {number} playerId
         * @memberof BullBullGame.TemporaryLeaveBroadcast
         * @instance
         */
        TemporaryLeaveBroadcast.prototype.playerId = 0;

        /**
         * TemporaryLeaveBroadcast isTemporaryLeave.
         * @member {boolean} isTemporaryLeave
         * @memberof BullBullGame.TemporaryLeaveBroadcast
         * @instance
         */
        TemporaryLeaveBroadcast.prototype.isTemporaryLeave = false;

        /**
         * Creates a new TemporaryLeaveBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.TemporaryLeaveBroadcast
         * @static
         * @param {BullBullGame.ITemporaryLeaveBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.TemporaryLeaveBroadcast} TemporaryLeaveBroadcast instance
         */
        TemporaryLeaveBroadcast.create = function create(properties) {
            return new TemporaryLeaveBroadcast(properties);
        };

        /**
         * Encodes the specified TemporaryLeaveBroadcast message. Does not implicitly {@link BullBullGame.TemporaryLeaveBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.TemporaryLeaveBroadcast
         * @static
         * @param {BullBullGame.ITemporaryLeaveBroadcast} message TemporaryLeaveBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TemporaryLeaveBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isTemporaryLeave);
            return writer;
        };

        /**
         * Encodes the specified TemporaryLeaveBroadcast message, length delimited. Does not implicitly {@link BullBullGame.TemporaryLeaveBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.TemporaryLeaveBroadcast
         * @static
         * @param {BullBullGame.ITemporaryLeaveBroadcast} message TemporaryLeaveBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TemporaryLeaveBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TemporaryLeaveBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.TemporaryLeaveBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.TemporaryLeaveBroadcast} TemporaryLeaveBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TemporaryLeaveBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.TemporaryLeaveBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.isTemporaryLeave = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            if (!message.hasOwnProperty("isTemporaryLeave"))
                throw $util.ProtocolError("missing required 'isTemporaryLeave'", { instance: message });
            return message;
        };

        /**
         * Decodes a TemporaryLeaveBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.TemporaryLeaveBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.TemporaryLeaveBroadcast} TemporaryLeaveBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TemporaryLeaveBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TemporaryLeaveBroadcast message.
         * @function verify
         * @memberof BullBullGame.TemporaryLeaveBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TemporaryLeaveBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (typeof message.isTemporaryLeave !== "boolean")
                return "isTemporaryLeave: boolean expected";
            return null;
        };

        /**
         * Creates a TemporaryLeaveBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.TemporaryLeaveBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.TemporaryLeaveBroadcast} TemporaryLeaveBroadcast
         */
        TemporaryLeaveBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.TemporaryLeaveBroadcast)
                return object;
            var message = new $root.BullBullGame.TemporaryLeaveBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.isTemporaryLeave != null)
                message.isTemporaryLeave = Boolean(object.isTemporaryLeave);
            return message;
        };

        /**
         * Creates a plain object from a TemporaryLeaveBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.TemporaryLeaveBroadcast
         * @static
         * @param {BullBullGame.TemporaryLeaveBroadcast} message TemporaryLeaveBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TemporaryLeaveBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.isTemporaryLeave = false;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.isTemporaryLeave != null && message.hasOwnProperty("isTemporaryLeave"))
                object.isTemporaryLeave = message.isTemporaryLeave;
            return object;
        };

        /**
         * Converts this TemporaryLeaveBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.TemporaryLeaveBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TemporaryLeaveBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TemporaryLeaveBroadcast;
    })();

    BullBullGame.WaitSpeakBroadcast = (function() {

        /**
         * Properties of a WaitSpeakBroadcast.
         * @memberof BullBullGame
         * @interface IWaitSpeakBroadcast
         * @property {number} playerId WaitSpeakBroadcast playerId
         * @property {boolean|null} [canCompare] WaitSpeakBroadcast canCompare
         * @property {Array.<number>|null} [canBetScoreList] WaitSpeakBroadcast canBetScoreList
         * @property {number} curBetRoundNum WaitSpeakBroadcast curBetRoundNum
         */

        /**
         * Constructs a new WaitSpeakBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a WaitSpeakBroadcast.
         * @implements IWaitSpeakBroadcast
         * @constructor
         * @param {BullBullGame.IWaitSpeakBroadcast=} [properties] Properties to set
         */
        function WaitSpeakBroadcast(properties) {
            this.canBetScoreList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * WaitSpeakBroadcast playerId.
         * @member {number} playerId
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @instance
         */
        WaitSpeakBroadcast.prototype.playerId = 0;

        /**
         * WaitSpeakBroadcast canCompare.
         * @member {boolean} canCompare
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @instance
         */
        WaitSpeakBroadcast.prototype.canCompare = true;

        /**
         * WaitSpeakBroadcast canBetScoreList.
         * @member {Array.<number>} canBetScoreList
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @instance
         */
        WaitSpeakBroadcast.prototype.canBetScoreList = $util.emptyArray;

        /**
         * WaitSpeakBroadcast curBetRoundNum.
         * @member {number} curBetRoundNum
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @instance
         */
        WaitSpeakBroadcast.prototype.curBetRoundNum = 0;

        /**
         * Creates a new WaitSpeakBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @static
         * @param {BullBullGame.IWaitSpeakBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.WaitSpeakBroadcast} WaitSpeakBroadcast instance
         */
        WaitSpeakBroadcast.create = function create(properties) {
            return new WaitSpeakBroadcast(properties);
        };

        /**
         * Encodes the specified WaitSpeakBroadcast message. Does not implicitly {@link BullBullGame.WaitSpeakBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @static
         * @param {BullBullGame.IWaitSpeakBroadcast} message WaitSpeakBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WaitSpeakBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            if (message.canCompare != null && message.hasOwnProperty("canCompare"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.canCompare);
            if (message.canBetScoreList != null && message.canBetScoreList.length)
                for (var i = 0; i < message.canBetScoreList.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.canBetScoreList[i]);
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.curBetRoundNum);
            return writer;
        };

        /**
         * Encodes the specified WaitSpeakBroadcast message, length delimited. Does not implicitly {@link BullBullGame.WaitSpeakBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @static
         * @param {BullBullGame.IWaitSpeakBroadcast} message WaitSpeakBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        WaitSpeakBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a WaitSpeakBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.WaitSpeakBroadcast} WaitSpeakBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WaitSpeakBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.WaitSpeakBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.canCompare = reader.bool();
                    break;
                case 3:
                    if (!(message.canBetScoreList && message.canBetScoreList.length))
                        message.canBetScoreList = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.canBetScoreList.push(reader.int32());
                    } else
                        message.canBetScoreList.push(reader.int32());
                    break;
                case 4:
                    message.curBetRoundNum = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            if (!message.hasOwnProperty("curBetRoundNum"))
                throw $util.ProtocolError("missing required 'curBetRoundNum'", { instance: message });
            return message;
        };

        /**
         * Decodes a WaitSpeakBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.WaitSpeakBroadcast} WaitSpeakBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        WaitSpeakBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a WaitSpeakBroadcast message.
         * @function verify
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        WaitSpeakBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (message.canCompare != null && message.hasOwnProperty("canCompare"))
                if (typeof message.canCompare !== "boolean")
                    return "canCompare: boolean expected";
            if (message.canBetScoreList != null && message.hasOwnProperty("canBetScoreList")) {
                if (!Array.isArray(message.canBetScoreList))
                    return "canBetScoreList: array expected";
                for (var i = 0; i < message.canBetScoreList.length; ++i)
                    if (!$util.isInteger(message.canBetScoreList[i]))
                        return "canBetScoreList: integer[] expected";
            }
            if (!$util.isInteger(message.curBetRoundNum))
                return "curBetRoundNum: integer expected";
            return null;
        };

        /**
         * Creates a WaitSpeakBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.WaitSpeakBroadcast} WaitSpeakBroadcast
         */
        WaitSpeakBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.WaitSpeakBroadcast)
                return object;
            var message = new $root.BullBullGame.WaitSpeakBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.canCompare != null)
                message.canCompare = Boolean(object.canCompare);
            if (object.canBetScoreList) {
                if (!Array.isArray(object.canBetScoreList))
                    throw TypeError(".BullBullGame.WaitSpeakBroadcast.canBetScoreList: array expected");
                message.canBetScoreList = [];
                for (var i = 0; i < object.canBetScoreList.length; ++i)
                    message.canBetScoreList[i] = object.canBetScoreList[i] | 0;
            }
            if (object.curBetRoundNum != null)
                message.curBetRoundNum = object.curBetRoundNum | 0;
            return message;
        };

        /**
         * Creates a plain object from a WaitSpeakBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @static
         * @param {BullBullGame.WaitSpeakBroadcast} message WaitSpeakBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        WaitSpeakBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.canBetScoreList = [];
            if (options.defaults) {
                object.playerId = 0;
                object.canCompare = true;
                object.curBetRoundNum = 0;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.canCompare != null && message.hasOwnProperty("canCompare"))
                object.canCompare = message.canCompare;
            if (message.canBetScoreList && message.canBetScoreList.length) {
                object.canBetScoreList = [];
                for (var j = 0; j < message.canBetScoreList.length; ++j)
                    object.canBetScoreList[j] = message.canBetScoreList[j];
            }
            if (message.curBetRoundNum != null && message.hasOwnProperty("curBetRoundNum"))
                object.curBetRoundNum = message.curBetRoundNum;
            return object;
        };

        /**
         * Converts this WaitSpeakBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.WaitSpeakBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        WaitSpeakBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return WaitSpeakBroadcast;
    })();

    BullBullGame.DropPokersReq = (function() {

        /**
         * Properties of a DropPokersReq.
         * @memberof BullBullGame
         * @interface IDropPokersReq
         */

        /**
         * Constructs a new DropPokersReq.
         * @memberof BullBullGame
         * @classdesc Represents a DropPokersReq.
         * @implements IDropPokersReq
         * @constructor
         * @param {BullBullGame.IDropPokersReq=} [properties] Properties to set
         */
        function DropPokersReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new DropPokersReq instance using the specified properties.
         * @function create
         * @memberof BullBullGame.DropPokersReq
         * @static
         * @param {BullBullGame.IDropPokersReq=} [properties] Properties to set
         * @returns {BullBullGame.DropPokersReq} DropPokersReq instance
         */
        DropPokersReq.create = function create(properties) {
            return new DropPokersReq(properties);
        };

        /**
         * Encodes the specified DropPokersReq message. Does not implicitly {@link BullBullGame.DropPokersReq.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.DropPokersReq
         * @static
         * @param {BullBullGame.IDropPokersReq} message DropPokersReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DropPokersReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified DropPokersReq message, length delimited. Does not implicitly {@link BullBullGame.DropPokersReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.DropPokersReq
         * @static
         * @param {BullBullGame.IDropPokersReq} message DropPokersReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DropPokersReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DropPokersReq message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.DropPokersReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.DropPokersReq} DropPokersReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DropPokersReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.DropPokersReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DropPokersReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.DropPokersReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.DropPokersReq} DropPokersReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DropPokersReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DropPokersReq message.
         * @function verify
         * @memberof BullBullGame.DropPokersReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DropPokersReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a DropPokersReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.DropPokersReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.DropPokersReq} DropPokersReq
         */
        DropPokersReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.DropPokersReq)
                return object;
            return new $root.BullBullGame.DropPokersReq();
        };

        /**
         * Creates a plain object from a DropPokersReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.DropPokersReq
         * @static
         * @param {BullBullGame.DropPokersReq} message DropPokersReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DropPokersReq.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this DropPokersReq to JSON.
         * @function toJSON
         * @memberof BullBullGame.DropPokersReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DropPokersReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DropPokersReq;
    })();

    BullBullGame.DropPokersRsp = (function() {

        /**
         * Properties of a DropPokersRsp.
         * @memberof BullBullGame
         * @interface IDropPokersRsp
         * @property {number} errCode DropPokersRsp errCode
         * @property {string|null} [errMsg] DropPokersRsp errMsg
         * @property {string|null} [comboType] DropPokersRsp comboType
         * @property {Array.<BullBullGame.IPoker>|null} [pokers] DropPokersRsp pokers
         */

        /**
         * Constructs a new DropPokersRsp.
         * @memberof BullBullGame
         * @classdesc Represents a DropPokersRsp.
         * @implements IDropPokersRsp
         * @constructor
         * @param {BullBullGame.IDropPokersRsp=} [properties] Properties to set
         */
        function DropPokersRsp(properties) {
            this.pokers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DropPokersRsp errCode.
         * @member {number} errCode
         * @memberof BullBullGame.DropPokersRsp
         * @instance
         */
        DropPokersRsp.prototype.errCode = 0;

        /**
         * DropPokersRsp errMsg.
         * @member {string} errMsg
         * @memberof BullBullGame.DropPokersRsp
         * @instance
         */
        DropPokersRsp.prototype.errMsg = "";

        /**
         * DropPokersRsp comboType.
         * @member {string} comboType
         * @memberof BullBullGame.DropPokersRsp
         * @instance
         */
        DropPokersRsp.prototype.comboType = "";

        /**
         * DropPokersRsp pokers.
         * @member {Array.<BullBullGame.IPoker>} pokers
         * @memberof BullBullGame.DropPokersRsp
         * @instance
         */
        DropPokersRsp.prototype.pokers = $util.emptyArray;

        /**
         * Creates a new DropPokersRsp instance using the specified properties.
         * @function create
         * @memberof BullBullGame.DropPokersRsp
         * @static
         * @param {BullBullGame.IDropPokersRsp=} [properties] Properties to set
         * @returns {BullBullGame.DropPokersRsp} DropPokersRsp instance
         */
        DropPokersRsp.create = function create(properties) {
            return new DropPokersRsp(properties);
        };

        /**
         * Encodes the specified DropPokersRsp message. Does not implicitly {@link BullBullGame.DropPokersRsp.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.DropPokersRsp
         * @static
         * @param {BullBullGame.IDropPokersRsp} message DropPokersRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DropPokersRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errCode);
            if (message.errMsg != null && message.hasOwnProperty("errMsg"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.errMsg);
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.comboType);
            if (message.pokers != null && message.pokers.length)
                for (var i = 0; i < message.pokers.length; ++i)
                    $root.BullBullGame.Poker.encode(message.pokers[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified DropPokersRsp message, length delimited. Does not implicitly {@link BullBullGame.DropPokersRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.DropPokersRsp
         * @static
         * @param {BullBullGame.IDropPokersRsp} message DropPokersRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DropPokersRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DropPokersRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.DropPokersRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.DropPokersRsp} DropPokersRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DropPokersRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.DropPokersRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errCode = reader.int32();
                    break;
                case 2:
                    message.errMsg = reader.string();
                    break;
                case 3:
                    message.comboType = reader.string();
                    break;
                case 4:
                    if (!(message.pokers && message.pokers.length))
                        message.pokers = [];
                    message.pokers.push($root.BullBullGame.Poker.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("errCode"))
                throw $util.ProtocolError("missing required 'errCode'", { instance: message });
            return message;
        };

        /**
         * Decodes a DropPokersRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.DropPokersRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.DropPokersRsp} DropPokersRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DropPokersRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DropPokersRsp message.
         * @function verify
         * @memberof BullBullGame.DropPokersRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DropPokersRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.errCode))
                return "errCode: integer expected";
            if (message.errMsg != null && message.hasOwnProperty("errMsg"))
                if (!$util.isString(message.errMsg))
                    return "errMsg: string expected";
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                if (!$util.isString(message.comboType))
                    return "comboType: string expected";
            if (message.pokers != null && message.hasOwnProperty("pokers")) {
                if (!Array.isArray(message.pokers))
                    return "pokers: array expected";
                for (var i = 0; i < message.pokers.length; ++i) {
                    var error = $root.BullBullGame.Poker.verify(message.pokers[i]);
                    if (error)
                        return "pokers." + error;
                }
            }
            return null;
        };

        /**
         * Creates a DropPokersRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.DropPokersRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.DropPokersRsp} DropPokersRsp
         */
        DropPokersRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.DropPokersRsp)
                return object;
            var message = new $root.BullBullGame.DropPokersRsp();
            if (object.errCode != null)
                message.errCode = object.errCode | 0;
            if (object.errMsg != null)
                message.errMsg = String(object.errMsg);
            if (object.comboType != null)
                message.comboType = String(object.comboType);
            if (object.pokers) {
                if (!Array.isArray(object.pokers))
                    throw TypeError(".BullBullGame.DropPokersRsp.pokers: array expected");
                message.pokers = [];
                for (var i = 0; i < object.pokers.length; ++i) {
                    if (typeof object.pokers[i] !== "object")
                        throw TypeError(".BullBullGame.DropPokersRsp.pokers: object expected");
                    message.pokers[i] = $root.BullBullGame.Poker.fromObject(object.pokers[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a DropPokersRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.DropPokersRsp
         * @static
         * @param {BullBullGame.DropPokersRsp} message DropPokersRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DropPokersRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.pokers = [];
            if (options.defaults) {
                object.errCode = 0;
                object.errMsg = "";
                object.comboType = "";
            }
            if (message.errCode != null && message.hasOwnProperty("errCode"))
                object.errCode = message.errCode;
            if (message.errMsg != null && message.hasOwnProperty("errMsg"))
                object.errMsg = message.errMsg;
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                object.comboType = message.comboType;
            if (message.pokers && message.pokers.length) {
                object.pokers = [];
                for (var j = 0; j < message.pokers.length; ++j)
                    object.pokers[j] = $root.BullBullGame.Poker.toObject(message.pokers[j], options);
            }
            return object;
        };

        /**
         * Converts this DropPokersRsp to JSON.
         * @function toJSON
         * @memberof BullBullGame.DropPokersRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DropPokersRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DropPokersRsp;
    })();

    BullBullGame.DropPokersBroadcast = (function() {

        /**
         * Properties of a DropPokersBroadcast.
         * @memberof BullBullGame
         * @interface IDropPokersBroadcast
         * @property {number} playerId DropPokersBroadcast playerId
         */

        /**
         * Constructs a new DropPokersBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a DropPokersBroadcast.
         * @implements IDropPokersBroadcast
         * @constructor
         * @param {BullBullGame.IDropPokersBroadcast=} [properties] Properties to set
         */
        function DropPokersBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DropPokersBroadcast playerId.
         * @member {number} playerId
         * @memberof BullBullGame.DropPokersBroadcast
         * @instance
         */
        DropPokersBroadcast.prototype.playerId = 0;

        /**
         * Creates a new DropPokersBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.DropPokersBroadcast
         * @static
         * @param {BullBullGame.IDropPokersBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.DropPokersBroadcast} DropPokersBroadcast instance
         */
        DropPokersBroadcast.create = function create(properties) {
            return new DropPokersBroadcast(properties);
        };

        /**
         * Encodes the specified DropPokersBroadcast message. Does not implicitly {@link BullBullGame.DropPokersBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.DropPokersBroadcast
         * @static
         * @param {BullBullGame.IDropPokersBroadcast} message DropPokersBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DropPokersBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            return writer;
        };

        /**
         * Encodes the specified DropPokersBroadcast message, length delimited. Does not implicitly {@link BullBullGame.DropPokersBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.DropPokersBroadcast
         * @static
         * @param {BullBullGame.IDropPokersBroadcast} message DropPokersBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DropPokersBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DropPokersBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.DropPokersBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.DropPokersBroadcast} DropPokersBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DropPokersBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.DropPokersBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            return message;
        };

        /**
         * Decodes a DropPokersBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.DropPokersBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.DropPokersBroadcast} DropPokersBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DropPokersBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DropPokersBroadcast message.
         * @function verify
         * @memberof BullBullGame.DropPokersBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DropPokersBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            return null;
        };

        /**
         * Creates a DropPokersBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.DropPokersBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.DropPokersBroadcast} DropPokersBroadcast
         */
        DropPokersBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.DropPokersBroadcast)
                return object;
            var message = new $root.BullBullGame.DropPokersBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            return message;
        };

        /**
         * Creates a plain object from a DropPokersBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.DropPokersBroadcast
         * @static
         * @param {BullBullGame.DropPokersBroadcast} message DropPokersBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DropPokersBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.playerId = 0;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            return object;
        };

        /**
         * Converts this DropPokersBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.DropPokersBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DropPokersBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DropPokersBroadcast;
    })();

    BullBullGame.CheckPokersReq = (function() {

        /**
         * Properties of a CheckPokersReq.
         * @memberof BullBullGame
         * @interface ICheckPokersReq
         */

        /**
         * Constructs a new CheckPokersReq.
         * @memberof BullBullGame
         * @classdesc Represents a CheckPokersReq.
         * @implements ICheckPokersReq
         * @constructor
         * @param {BullBullGame.ICheckPokersReq=} [properties] Properties to set
         */
        function CheckPokersReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new CheckPokersReq instance using the specified properties.
         * @function create
         * @memberof BullBullGame.CheckPokersReq
         * @static
         * @param {BullBullGame.ICheckPokersReq=} [properties] Properties to set
         * @returns {BullBullGame.CheckPokersReq} CheckPokersReq instance
         */
        CheckPokersReq.create = function create(properties) {
            return new CheckPokersReq(properties);
        };

        /**
         * Encodes the specified CheckPokersReq message. Does not implicitly {@link BullBullGame.CheckPokersReq.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.CheckPokersReq
         * @static
         * @param {BullBullGame.ICheckPokersReq} message CheckPokersReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CheckPokersReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified CheckPokersReq message, length delimited. Does not implicitly {@link BullBullGame.CheckPokersReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.CheckPokersReq
         * @static
         * @param {BullBullGame.ICheckPokersReq} message CheckPokersReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CheckPokersReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CheckPokersReq message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.CheckPokersReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.CheckPokersReq} CheckPokersReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CheckPokersReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.CheckPokersReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CheckPokersReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.CheckPokersReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.CheckPokersReq} CheckPokersReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CheckPokersReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CheckPokersReq message.
         * @function verify
         * @memberof BullBullGame.CheckPokersReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CheckPokersReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a CheckPokersReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.CheckPokersReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.CheckPokersReq} CheckPokersReq
         */
        CheckPokersReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.CheckPokersReq)
                return object;
            return new $root.BullBullGame.CheckPokersReq();
        };

        /**
         * Creates a plain object from a CheckPokersReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.CheckPokersReq
         * @static
         * @param {BullBullGame.CheckPokersReq} message CheckPokersReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CheckPokersReq.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this CheckPokersReq to JSON.
         * @function toJSON
         * @memberof BullBullGame.CheckPokersReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CheckPokersReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CheckPokersReq;
    })();

    BullBullGame.CheckPokersRsp = (function() {

        /**
         * Properties of a CheckPokersRsp.
         * @memberof BullBullGame
         * @interface ICheckPokersRsp
         * @property {number} errCode CheckPokersRsp errCode
         * @property {string|null} [errMsg] CheckPokersRsp errMsg
         * @property {string|null} [comboType] CheckPokersRsp comboType
         * @property {Array.<BullBullGame.IPoker>|null} [pokers] CheckPokersRsp pokers
         */

        /**
         * Constructs a new CheckPokersRsp.
         * @memberof BullBullGame
         * @classdesc Represents a CheckPokersRsp.
         * @implements ICheckPokersRsp
         * @constructor
         * @param {BullBullGame.ICheckPokersRsp=} [properties] Properties to set
         */
        function CheckPokersRsp(properties) {
            this.pokers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CheckPokersRsp errCode.
         * @member {number} errCode
         * @memberof BullBullGame.CheckPokersRsp
         * @instance
         */
        CheckPokersRsp.prototype.errCode = 0;

        /**
         * CheckPokersRsp errMsg.
         * @member {string} errMsg
         * @memberof BullBullGame.CheckPokersRsp
         * @instance
         */
        CheckPokersRsp.prototype.errMsg = "";

        /**
         * CheckPokersRsp comboType.
         * @member {string} comboType
         * @memberof BullBullGame.CheckPokersRsp
         * @instance
         */
        CheckPokersRsp.prototype.comboType = "";

        /**
         * CheckPokersRsp pokers.
         * @member {Array.<BullBullGame.IPoker>} pokers
         * @memberof BullBullGame.CheckPokersRsp
         * @instance
         */
        CheckPokersRsp.prototype.pokers = $util.emptyArray;

        /**
         * Creates a new CheckPokersRsp instance using the specified properties.
         * @function create
         * @memberof BullBullGame.CheckPokersRsp
         * @static
         * @param {BullBullGame.ICheckPokersRsp=} [properties] Properties to set
         * @returns {BullBullGame.CheckPokersRsp} CheckPokersRsp instance
         */
        CheckPokersRsp.create = function create(properties) {
            return new CheckPokersRsp(properties);
        };

        /**
         * Encodes the specified CheckPokersRsp message. Does not implicitly {@link BullBullGame.CheckPokersRsp.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.CheckPokersRsp
         * @static
         * @param {BullBullGame.ICheckPokersRsp} message CheckPokersRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CheckPokersRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errCode);
            if (message.errMsg != null && message.hasOwnProperty("errMsg"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.errMsg);
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.comboType);
            if (message.pokers != null && message.pokers.length)
                for (var i = 0; i < message.pokers.length; ++i)
                    $root.BullBullGame.Poker.encode(message.pokers[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CheckPokersRsp message, length delimited. Does not implicitly {@link BullBullGame.CheckPokersRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.CheckPokersRsp
         * @static
         * @param {BullBullGame.ICheckPokersRsp} message CheckPokersRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CheckPokersRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CheckPokersRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.CheckPokersRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.CheckPokersRsp} CheckPokersRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CheckPokersRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.CheckPokersRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errCode = reader.int32();
                    break;
                case 2:
                    message.errMsg = reader.string();
                    break;
                case 3:
                    message.comboType = reader.string();
                    break;
                case 4:
                    if (!(message.pokers && message.pokers.length))
                        message.pokers = [];
                    message.pokers.push($root.BullBullGame.Poker.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("errCode"))
                throw $util.ProtocolError("missing required 'errCode'", { instance: message });
            return message;
        };

        /**
         * Decodes a CheckPokersRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.CheckPokersRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.CheckPokersRsp} CheckPokersRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CheckPokersRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CheckPokersRsp message.
         * @function verify
         * @memberof BullBullGame.CheckPokersRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CheckPokersRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.errCode))
                return "errCode: integer expected";
            if (message.errMsg != null && message.hasOwnProperty("errMsg"))
                if (!$util.isString(message.errMsg))
                    return "errMsg: string expected";
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                if (!$util.isString(message.comboType))
                    return "comboType: string expected";
            if (message.pokers != null && message.hasOwnProperty("pokers")) {
                if (!Array.isArray(message.pokers))
                    return "pokers: array expected";
                for (var i = 0; i < message.pokers.length; ++i) {
                    var error = $root.BullBullGame.Poker.verify(message.pokers[i]);
                    if (error)
                        return "pokers." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CheckPokersRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.CheckPokersRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.CheckPokersRsp} CheckPokersRsp
         */
        CheckPokersRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.CheckPokersRsp)
                return object;
            var message = new $root.BullBullGame.CheckPokersRsp();
            if (object.errCode != null)
                message.errCode = object.errCode | 0;
            if (object.errMsg != null)
                message.errMsg = String(object.errMsg);
            if (object.comboType != null)
                message.comboType = String(object.comboType);
            if (object.pokers) {
                if (!Array.isArray(object.pokers))
                    throw TypeError(".BullBullGame.CheckPokersRsp.pokers: array expected");
                message.pokers = [];
                for (var i = 0; i < object.pokers.length; ++i) {
                    if (typeof object.pokers[i] !== "object")
                        throw TypeError(".BullBullGame.CheckPokersRsp.pokers: object expected");
                    message.pokers[i] = $root.BullBullGame.Poker.fromObject(object.pokers[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CheckPokersRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.CheckPokersRsp
         * @static
         * @param {BullBullGame.CheckPokersRsp} message CheckPokersRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CheckPokersRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.pokers = [];
            if (options.defaults) {
                object.errCode = 0;
                object.errMsg = "";
                object.comboType = "";
            }
            if (message.errCode != null && message.hasOwnProperty("errCode"))
                object.errCode = message.errCode;
            if (message.errMsg != null && message.hasOwnProperty("errMsg"))
                object.errMsg = message.errMsg;
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                object.comboType = message.comboType;
            if (message.pokers && message.pokers.length) {
                object.pokers = [];
                for (var j = 0; j < message.pokers.length; ++j)
                    object.pokers[j] = $root.BullBullGame.Poker.toObject(message.pokers[j], options);
            }
            return object;
        };

        /**
         * Converts this CheckPokersRsp to JSON.
         * @function toJSON
         * @memberof BullBullGame.CheckPokersRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CheckPokersRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CheckPokersRsp;
    })();

    BullBullGame.CheckPokersBroadcast = (function() {

        /**
         * Properties of a CheckPokersBroadcast.
         * @memberof BullBullGame
         * @interface ICheckPokersBroadcast
         * @property {number} playerId CheckPokersBroadcast playerId
         */

        /**
         * Constructs a new CheckPokersBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a CheckPokersBroadcast.
         * @implements ICheckPokersBroadcast
         * @constructor
         * @param {BullBullGame.ICheckPokersBroadcast=} [properties] Properties to set
         */
        function CheckPokersBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CheckPokersBroadcast playerId.
         * @member {number} playerId
         * @memberof BullBullGame.CheckPokersBroadcast
         * @instance
         */
        CheckPokersBroadcast.prototype.playerId = 0;

        /**
         * Creates a new CheckPokersBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.CheckPokersBroadcast
         * @static
         * @param {BullBullGame.ICheckPokersBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.CheckPokersBroadcast} CheckPokersBroadcast instance
         */
        CheckPokersBroadcast.create = function create(properties) {
            return new CheckPokersBroadcast(properties);
        };

        /**
         * Encodes the specified CheckPokersBroadcast message. Does not implicitly {@link BullBullGame.CheckPokersBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.CheckPokersBroadcast
         * @static
         * @param {BullBullGame.ICheckPokersBroadcast} message CheckPokersBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CheckPokersBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            return writer;
        };

        /**
         * Encodes the specified CheckPokersBroadcast message, length delimited. Does not implicitly {@link BullBullGame.CheckPokersBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.CheckPokersBroadcast
         * @static
         * @param {BullBullGame.ICheckPokersBroadcast} message CheckPokersBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CheckPokersBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CheckPokersBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.CheckPokersBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.CheckPokersBroadcast} CheckPokersBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CheckPokersBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.CheckPokersBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            return message;
        };

        /**
         * Decodes a CheckPokersBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.CheckPokersBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.CheckPokersBroadcast} CheckPokersBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CheckPokersBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CheckPokersBroadcast message.
         * @function verify
         * @memberof BullBullGame.CheckPokersBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CheckPokersBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            return null;
        };

        /**
         * Creates a CheckPokersBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.CheckPokersBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.CheckPokersBroadcast} CheckPokersBroadcast
         */
        CheckPokersBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.CheckPokersBroadcast)
                return object;
            var message = new $root.BullBullGame.CheckPokersBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            return message;
        };

        /**
         * Creates a plain object from a CheckPokersBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.CheckPokersBroadcast
         * @static
         * @param {BullBullGame.CheckPokersBroadcast} message CheckPokersBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CheckPokersBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.playerId = 0;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            return object;
        };

        /**
         * Converts this CheckPokersBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.CheckPokersBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CheckPokersBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CheckPokersBroadcast;
    })();

    BullBullGame.ComparePokersReq = (function() {

        /**
         * Properties of a ComparePokersReq.
         * @memberof BullBullGame
         * @interface IComparePokersReq
         * @property {number} targetPlayerId ComparePokersReq targetPlayerId
         */

        /**
         * Constructs a new ComparePokersReq.
         * @memberof BullBullGame
         * @classdesc Represents a ComparePokersReq.
         * @implements IComparePokersReq
         * @constructor
         * @param {BullBullGame.IComparePokersReq=} [properties] Properties to set
         */
        function ComparePokersReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComparePokersReq targetPlayerId.
         * @member {number} targetPlayerId
         * @memberof BullBullGame.ComparePokersReq
         * @instance
         */
        ComparePokersReq.prototype.targetPlayerId = 0;

        /**
         * Creates a new ComparePokersReq instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ComparePokersReq
         * @static
         * @param {BullBullGame.IComparePokersReq=} [properties] Properties to set
         * @returns {BullBullGame.ComparePokersReq} ComparePokersReq instance
         */
        ComparePokersReq.create = function create(properties) {
            return new ComparePokersReq(properties);
        };

        /**
         * Encodes the specified ComparePokersReq message. Does not implicitly {@link BullBullGame.ComparePokersReq.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ComparePokersReq
         * @static
         * @param {BullBullGame.IComparePokersReq} message ComparePokersReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComparePokersReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.targetPlayerId);
            return writer;
        };

        /**
         * Encodes the specified ComparePokersReq message, length delimited. Does not implicitly {@link BullBullGame.ComparePokersReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ComparePokersReq
         * @static
         * @param {BullBullGame.IComparePokersReq} message ComparePokersReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComparePokersReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ComparePokersReq message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ComparePokersReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ComparePokersReq} ComparePokersReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComparePokersReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ComparePokersReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.targetPlayerId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("targetPlayerId"))
                throw $util.ProtocolError("missing required 'targetPlayerId'", { instance: message });
            return message;
        };

        /**
         * Decodes a ComparePokersReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ComparePokersReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ComparePokersReq} ComparePokersReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComparePokersReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ComparePokersReq message.
         * @function verify
         * @memberof BullBullGame.ComparePokersReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ComparePokersReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.targetPlayerId))
                return "targetPlayerId: integer expected";
            return null;
        };

        /**
         * Creates a ComparePokersReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ComparePokersReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ComparePokersReq} ComparePokersReq
         */
        ComparePokersReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ComparePokersReq)
                return object;
            var message = new $root.BullBullGame.ComparePokersReq();
            if (object.targetPlayerId != null)
                message.targetPlayerId = object.targetPlayerId | 0;
            return message;
        };

        /**
         * Creates a plain object from a ComparePokersReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ComparePokersReq
         * @static
         * @param {BullBullGame.ComparePokersReq} message ComparePokersReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComparePokersReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.targetPlayerId = 0;
            if (message.targetPlayerId != null && message.hasOwnProperty("targetPlayerId"))
                object.targetPlayerId = message.targetPlayerId;
            return object;
        };

        /**
         * Converts this ComparePokersReq to JSON.
         * @function toJSON
         * @memberof BullBullGame.ComparePokersReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComparePokersReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComparePokersReq;
    })();

    BullBullGame.ComparePokersRsp = (function() {

        /**
         * Properties of a ComparePokersRsp.
         * @memberof BullBullGame
         * @interface IComparePokersRsp
         * @property {number} errCode ComparePokersRsp errCode
         * @property {string|null} [errMsg] ComparePokersRsp errMsg
         * @property {number|null} [winnerPlayerId] ComparePokersRsp winnerPlayerId
         * @property {number|null} [betScore] ComparePokersRsp betScore
         */

        /**
         * Constructs a new ComparePokersRsp.
         * @memberof BullBullGame
         * @classdesc Represents a ComparePokersRsp.
         * @implements IComparePokersRsp
         * @constructor
         * @param {BullBullGame.IComparePokersRsp=} [properties] Properties to set
         */
        function ComparePokersRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComparePokersRsp errCode.
         * @member {number} errCode
         * @memberof BullBullGame.ComparePokersRsp
         * @instance
         */
        ComparePokersRsp.prototype.errCode = 0;

        /**
         * ComparePokersRsp errMsg.
         * @member {string} errMsg
         * @memberof BullBullGame.ComparePokersRsp
         * @instance
         */
        ComparePokersRsp.prototype.errMsg = "";

        /**
         * ComparePokersRsp winnerPlayerId.
         * @member {number} winnerPlayerId
         * @memberof BullBullGame.ComparePokersRsp
         * @instance
         */
        ComparePokersRsp.prototype.winnerPlayerId = 0;

        /**
         * ComparePokersRsp betScore.
         * @member {number} betScore
         * @memberof BullBullGame.ComparePokersRsp
         * @instance
         */
        ComparePokersRsp.prototype.betScore = 0;

        /**
         * Creates a new ComparePokersRsp instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ComparePokersRsp
         * @static
         * @param {BullBullGame.IComparePokersRsp=} [properties] Properties to set
         * @returns {BullBullGame.ComparePokersRsp} ComparePokersRsp instance
         */
        ComparePokersRsp.create = function create(properties) {
            return new ComparePokersRsp(properties);
        };

        /**
         * Encodes the specified ComparePokersRsp message. Does not implicitly {@link BullBullGame.ComparePokersRsp.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ComparePokersRsp
         * @static
         * @param {BullBullGame.IComparePokersRsp} message ComparePokersRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComparePokersRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errCode);
            if (message.errMsg != null && message.hasOwnProperty("errMsg"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.errMsg);
            if (message.winnerPlayerId != null && message.hasOwnProperty("winnerPlayerId"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.winnerPlayerId);
            if (message.betScore != null && message.hasOwnProperty("betScore"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.betScore);
            return writer;
        };

        /**
         * Encodes the specified ComparePokersRsp message, length delimited. Does not implicitly {@link BullBullGame.ComparePokersRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ComparePokersRsp
         * @static
         * @param {BullBullGame.IComparePokersRsp} message ComparePokersRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComparePokersRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ComparePokersRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ComparePokersRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ComparePokersRsp} ComparePokersRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComparePokersRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ComparePokersRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errCode = reader.int32();
                    break;
                case 2:
                    message.errMsg = reader.string();
                    break;
                case 3:
                    message.winnerPlayerId = reader.int32();
                    break;
                case 4:
                    message.betScore = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("errCode"))
                throw $util.ProtocolError("missing required 'errCode'", { instance: message });
            return message;
        };

        /**
         * Decodes a ComparePokersRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ComparePokersRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ComparePokersRsp} ComparePokersRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComparePokersRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ComparePokersRsp message.
         * @function verify
         * @memberof BullBullGame.ComparePokersRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ComparePokersRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.errCode))
                return "errCode: integer expected";
            if (message.errMsg != null && message.hasOwnProperty("errMsg"))
                if (!$util.isString(message.errMsg))
                    return "errMsg: string expected";
            if (message.winnerPlayerId != null && message.hasOwnProperty("winnerPlayerId"))
                if (!$util.isInteger(message.winnerPlayerId))
                    return "winnerPlayerId: integer expected";
            if (message.betScore != null && message.hasOwnProperty("betScore"))
                if (!$util.isInteger(message.betScore))
                    return "betScore: integer expected";
            return null;
        };

        /**
         * Creates a ComparePokersRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ComparePokersRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ComparePokersRsp} ComparePokersRsp
         */
        ComparePokersRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ComparePokersRsp)
                return object;
            var message = new $root.BullBullGame.ComparePokersRsp();
            if (object.errCode != null)
                message.errCode = object.errCode | 0;
            if (object.errMsg != null)
                message.errMsg = String(object.errMsg);
            if (object.winnerPlayerId != null)
                message.winnerPlayerId = object.winnerPlayerId | 0;
            if (object.betScore != null)
                message.betScore = object.betScore | 0;
            return message;
        };

        /**
         * Creates a plain object from a ComparePokersRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ComparePokersRsp
         * @static
         * @param {BullBullGame.ComparePokersRsp} message ComparePokersRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComparePokersRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errCode = 0;
                object.errMsg = "";
                object.winnerPlayerId = 0;
                object.betScore = 0;
            }
            if (message.errCode != null && message.hasOwnProperty("errCode"))
                object.errCode = message.errCode;
            if (message.errMsg != null && message.hasOwnProperty("errMsg"))
                object.errMsg = message.errMsg;
            if (message.winnerPlayerId != null && message.hasOwnProperty("winnerPlayerId"))
                object.winnerPlayerId = message.winnerPlayerId;
            if (message.betScore != null && message.hasOwnProperty("betScore"))
                object.betScore = message.betScore;
            return object;
        };

        /**
         * Converts this ComparePokersRsp to JSON.
         * @function toJSON
         * @memberof BullBullGame.ComparePokersRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComparePokersRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComparePokersRsp;
    })();

    BullBullGame.ComparePokersFailBroadcast = (function() {

        /**
         * Properties of a ComparePokersFailBroadcast.
         * @memberof BullBullGame
         * @interface IComparePokersFailBroadcast
         * @property {string} comboType ComparePokersFailBroadcast comboType
         * @property {Array.<BullBullGame.IPoker>|null} [pokers] ComparePokersFailBroadcast pokers
         */

        /**
         * Constructs a new ComparePokersFailBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a ComparePokersFailBroadcast.
         * @implements IComparePokersFailBroadcast
         * @constructor
         * @param {BullBullGame.IComparePokersFailBroadcast=} [properties] Properties to set
         */
        function ComparePokersFailBroadcast(properties) {
            this.pokers = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComparePokersFailBroadcast comboType.
         * @member {string} comboType
         * @memberof BullBullGame.ComparePokersFailBroadcast
         * @instance
         */
        ComparePokersFailBroadcast.prototype.comboType = "";

        /**
         * ComparePokersFailBroadcast pokers.
         * @member {Array.<BullBullGame.IPoker>} pokers
         * @memberof BullBullGame.ComparePokersFailBroadcast
         * @instance
         */
        ComparePokersFailBroadcast.prototype.pokers = $util.emptyArray;

        /**
         * Creates a new ComparePokersFailBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ComparePokersFailBroadcast
         * @static
         * @param {BullBullGame.IComparePokersFailBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.ComparePokersFailBroadcast} ComparePokersFailBroadcast instance
         */
        ComparePokersFailBroadcast.create = function create(properties) {
            return new ComparePokersFailBroadcast(properties);
        };

        /**
         * Encodes the specified ComparePokersFailBroadcast message. Does not implicitly {@link BullBullGame.ComparePokersFailBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ComparePokersFailBroadcast
         * @static
         * @param {BullBullGame.IComparePokersFailBroadcast} message ComparePokersFailBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComparePokersFailBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.comboType);
            if (message.pokers != null && message.pokers.length)
                for (var i = 0; i < message.pokers.length; ++i)
                    $root.BullBullGame.Poker.encode(message.pokers[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ComparePokersFailBroadcast message, length delimited. Does not implicitly {@link BullBullGame.ComparePokersFailBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ComparePokersFailBroadcast
         * @static
         * @param {BullBullGame.IComparePokersFailBroadcast} message ComparePokersFailBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComparePokersFailBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ComparePokersFailBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ComparePokersFailBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ComparePokersFailBroadcast} ComparePokersFailBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComparePokersFailBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ComparePokersFailBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.comboType = reader.string();
                    break;
                case 2:
                    if (!(message.pokers && message.pokers.length))
                        message.pokers = [];
                    message.pokers.push($root.BullBullGame.Poker.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("comboType"))
                throw $util.ProtocolError("missing required 'comboType'", { instance: message });
            return message;
        };

        /**
         * Decodes a ComparePokersFailBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ComparePokersFailBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ComparePokersFailBroadcast} ComparePokersFailBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComparePokersFailBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ComparePokersFailBroadcast message.
         * @function verify
         * @memberof BullBullGame.ComparePokersFailBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ComparePokersFailBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isString(message.comboType))
                return "comboType: string expected";
            if (message.pokers != null && message.hasOwnProperty("pokers")) {
                if (!Array.isArray(message.pokers))
                    return "pokers: array expected";
                for (var i = 0; i < message.pokers.length; ++i) {
                    var error = $root.BullBullGame.Poker.verify(message.pokers[i]);
                    if (error)
                        return "pokers." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ComparePokersFailBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ComparePokersFailBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ComparePokersFailBroadcast} ComparePokersFailBroadcast
         */
        ComparePokersFailBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ComparePokersFailBroadcast)
                return object;
            var message = new $root.BullBullGame.ComparePokersFailBroadcast();
            if (object.comboType != null)
                message.comboType = String(object.comboType);
            if (object.pokers) {
                if (!Array.isArray(object.pokers))
                    throw TypeError(".BullBullGame.ComparePokersFailBroadcast.pokers: array expected");
                message.pokers = [];
                for (var i = 0; i < object.pokers.length; ++i) {
                    if (typeof object.pokers[i] !== "object")
                        throw TypeError(".BullBullGame.ComparePokersFailBroadcast.pokers: object expected");
                    message.pokers[i] = $root.BullBullGame.Poker.fromObject(object.pokers[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ComparePokersFailBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ComparePokersFailBroadcast
         * @static
         * @param {BullBullGame.ComparePokersFailBroadcast} message ComparePokersFailBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComparePokersFailBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.pokers = [];
            if (options.defaults)
                object.comboType = "";
            if (message.comboType != null && message.hasOwnProperty("comboType"))
                object.comboType = message.comboType;
            if (message.pokers && message.pokers.length) {
                object.pokers = [];
                for (var j = 0; j < message.pokers.length; ++j)
                    object.pokers[j] = $root.BullBullGame.Poker.toObject(message.pokers[j], options);
            }
            return object;
        };

        /**
         * Converts this ComparePokersFailBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.ComparePokersFailBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComparePokersFailBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComparePokersFailBroadcast;
    })();

    BullBullGame.ComparePokersBroadcast = (function() {

        /**
         * Properties of a ComparePokersBroadcast.
         * @memberof BullBullGame
         * @interface IComparePokersBroadcast
         * @property {number} srcPlayerId ComparePokersBroadcast srcPlayerId
         * @property {number} dstPlayerId ComparePokersBroadcast dstPlayerId
         * @property {number|null} [winnerPlayerId] ComparePokersBroadcast winnerPlayerId
         * @property {number|null} [betScore] ComparePokersBroadcast betScore
         */

        /**
         * Constructs a new ComparePokersBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a ComparePokersBroadcast.
         * @implements IComparePokersBroadcast
         * @constructor
         * @param {BullBullGame.IComparePokersBroadcast=} [properties] Properties to set
         */
        function ComparePokersBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ComparePokersBroadcast srcPlayerId.
         * @member {number} srcPlayerId
         * @memberof BullBullGame.ComparePokersBroadcast
         * @instance
         */
        ComparePokersBroadcast.prototype.srcPlayerId = 0;

        /**
         * ComparePokersBroadcast dstPlayerId.
         * @member {number} dstPlayerId
         * @memberof BullBullGame.ComparePokersBroadcast
         * @instance
         */
        ComparePokersBroadcast.prototype.dstPlayerId = 0;

        /**
         * ComparePokersBroadcast winnerPlayerId.
         * @member {number} winnerPlayerId
         * @memberof BullBullGame.ComparePokersBroadcast
         * @instance
         */
        ComparePokersBroadcast.prototype.winnerPlayerId = 0;

        /**
         * ComparePokersBroadcast betScore.
         * @member {number} betScore
         * @memberof BullBullGame.ComparePokersBroadcast
         * @instance
         */
        ComparePokersBroadcast.prototype.betScore = 0;

        /**
         * Creates a new ComparePokersBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ComparePokersBroadcast
         * @static
         * @param {BullBullGame.IComparePokersBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.ComparePokersBroadcast} ComparePokersBroadcast instance
         */
        ComparePokersBroadcast.create = function create(properties) {
            return new ComparePokersBroadcast(properties);
        };

        /**
         * Encodes the specified ComparePokersBroadcast message. Does not implicitly {@link BullBullGame.ComparePokersBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ComparePokersBroadcast
         * @static
         * @param {BullBullGame.IComparePokersBroadcast} message ComparePokersBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComparePokersBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.srcPlayerId);
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dstPlayerId);
            if (message.winnerPlayerId != null && message.hasOwnProperty("winnerPlayerId"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.winnerPlayerId);
            if (message.betScore != null && message.hasOwnProperty("betScore"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.betScore);
            return writer;
        };

        /**
         * Encodes the specified ComparePokersBroadcast message, length delimited. Does not implicitly {@link BullBullGame.ComparePokersBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ComparePokersBroadcast
         * @static
         * @param {BullBullGame.IComparePokersBroadcast} message ComparePokersBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ComparePokersBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ComparePokersBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ComparePokersBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ComparePokersBroadcast} ComparePokersBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComparePokersBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ComparePokersBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.srcPlayerId = reader.int32();
                    break;
                case 2:
                    message.dstPlayerId = reader.int32();
                    break;
                case 3:
                    message.winnerPlayerId = reader.int32();
                    break;
                case 4:
                    message.betScore = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("srcPlayerId"))
                throw $util.ProtocolError("missing required 'srcPlayerId'", { instance: message });
            if (!message.hasOwnProperty("dstPlayerId"))
                throw $util.ProtocolError("missing required 'dstPlayerId'", { instance: message });
            return message;
        };

        /**
         * Decodes a ComparePokersBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ComparePokersBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ComparePokersBroadcast} ComparePokersBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ComparePokersBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ComparePokersBroadcast message.
         * @function verify
         * @memberof BullBullGame.ComparePokersBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ComparePokersBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.srcPlayerId))
                return "srcPlayerId: integer expected";
            if (!$util.isInteger(message.dstPlayerId))
                return "dstPlayerId: integer expected";
            if (message.winnerPlayerId != null && message.hasOwnProperty("winnerPlayerId"))
                if (!$util.isInteger(message.winnerPlayerId))
                    return "winnerPlayerId: integer expected";
            if (message.betScore != null && message.hasOwnProperty("betScore"))
                if (!$util.isInteger(message.betScore))
                    return "betScore: integer expected";
            return null;
        };

        /**
         * Creates a ComparePokersBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ComparePokersBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ComparePokersBroadcast} ComparePokersBroadcast
         */
        ComparePokersBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ComparePokersBroadcast)
                return object;
            var message = new $root.BullBullGame.ComparePokersBroadcast();
            if (object.srcPlayerId != null)
                message.srcPlayerId = object.srcPlayerId | 0;
            if (object.dstPlayerId != null)
                message.dstPlayerId = object.dstPlayerId | 0;
            if (object.winnerPlayerId != null)
                message.winnerPlayerId = object.winnerPlayerId | 0;
            if (object.betScore != null)
                message.betScore = object.betScore | 0;
            return message;
        };

        /**
         * Creates a plain object from a ComparePokersBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ComparePokersBroadcast
         * @static
         * @param {BullBullGame.ComparePokersBroadcast} message ComparePokersBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ComparePokersBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.srcPlayerId = 0;
                object.dstPlayerId = 0;
                object.winnerPlayerId = 0;
                object.betScore = 0;
            }
            if (message.srcPlayerId != null && message.hasOwnProperty("srcPlayerId"))
                object.srcPlayerId = message.srcPlayerId;
            if (message.dstPlayerId != null && message.hasOwnProperty("dstPlayerId"))
                object.dstPlayerId = message.dstPlayerId;
            if (message.winnerPlayerId != null && message.hasOwnProperty("winnerPlayerId"))
                object.winnerPlayerId = message.winnerPlayerId;
            if (message.betScore != null && message.hasOwnProperty("betScore"))
                object.betScore = message.betScore;
            return object;
        };

        /**
         * Converts this ComparePokersBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.ComparePokersBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ComparePokersBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ComparePokersBroadcast;
    })();

    BullBullGame.CallBetReq = (function() {

        /**
         * Properties of a CallBetReq.
         * @memberof BullBullGame
         * @interface ICallBetReq
         * @property {number} betScore CallBetReq betScore
         */

        /**
         * Constructs a new CallBetReq.
         * @memberof BullBullGame
         * @classdesc Represents a CallBetReq.
         * @implements ICallBetReq
         * @constructor
         * @param {BullBullGame.ICallBetReq=} [properties] Properties to set
         */
        function CallBetReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CallBetReq betScore.
         * @member {number} betScore
         * @memberof BullBullGame.CallBetReq
         * @instance
         */
        CallBetReq.prototype.betScore = 0;

        /**
         * Creates a new CallBetReq instance using the specified properties.
         * @function create
         * @memberof BullBullGame.CallBetReq
         * @static
         * @param {BullBullGame.ICallBetReq=} [properties] Properties to set
         * @returns {BullBullGame.CallBetReq} CallBetReq instance
         */
        CallBetReq.create = function create(properties) {
            return new CallBetReq(properties);
        };

        /**
         * Encodes the specified CallBetReq message. Does not implicitly {@link BullBullGame.CallBetReq.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.CallBetReq
         * @static
         * @param {BullBullGame.ICallBetReq} message CallBetReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CallBetReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.betScore);
            return writer;
        };

        /**
         * Encodes the specified CallBetReq message, length delimited. Does not implicitly {@link BullBullGame.CallBetReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.CallBetReq
         * @static
         * @param {BullBullGame.ICallBetReq} message CallBetReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CallBetReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CallBetReq message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.CallBetReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.CallBetReq} CallBetReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CallBetReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.CallBetReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.betScore = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("betScore"))
                throw $util.ProtocolError("missing required 'betScore'", { instance: message });
            return message;
        };

        /**
         * Decodes a CallBetReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.CallBetReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.CallBetReq} CallBetReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CallBetReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CallBetReq message.
         * @function verify
         * @memberof BullBullGame.CallBetReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CallBetReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.betScore))
                return "betScore: integer expected";
            return null;
        };

        /**
         * Creates a CallBetReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.CallBetReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.CallBetReq} CallBetReq
         */
        CallBetReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.CallBetReq)
                return object;
            var message = new $root.BullBullGame.CallBetReq();
            if (object.betScore != null)
                message.betScore = object.betScore | 0;
            return message;
        };

        /**
         * Creates a plain object from a CallBetReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.CallBetReq
         * @static
         * @param {BullBullGame.CallBetReq} message CallBetReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CallBetReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.betScore = 0;
            if (message.betScore != null && message.hasOwnProperty("betScore"))
                object.betScore = message.betScore;
            return object;
        };

        /**
         * Converts this CallBetReq to JSON.
         * @function toJSON
         * @memberof BullBullGame.CallBetReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CallBetReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CallBetReq;
    })();

    BullBullGame.CallBetRsp = (function() {

        /**
         * Properties of a CallBetRsp.
         * @memberof BullBullGame
         * @interface ICallBetRsp
         * @property {number} errCode CallBetRsp errCode
         * @property {string|null} [errMsg] CallBetRsp errMsg
         * @property {number|null} [betScore] CallBetRsp betScore
         */

        /**
         * Constructs a new CallBetRsp.
         * @memberof BullBullGame
         * @classdesc Represents a CallBetRsp.
         * @implements ICallBetRsp
         * @constructor
         * @param {BullBullGame.ICallBetRsp=} [properties] Properties to set
         */
        function CallBetRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CallBetRsp errCode.
         * @member {number} errCode
         * @memberof BullBullGame.CallBetRsp
         * @instance
         */
        CallBetRsp.prototype.errCode = 0;

        /**
         * CallBetRsp errMsg.
         * @member {string} errMsg
         * @memberof BullBullGame.CallBetRsp
         * @instance
         */
        CallBetRsp.prototype.errMsg = "";

        /**
         * CallBetRsp betScore.
         * @member {number} betScore
         * @memberof BullBullGame.CallBetRsp
         * @instance
         */
        CallBetRsp.prototype.betScore = 0;

        /**
         * Creates a new CallBetRsp instance using the specified properties.
         * @function create
         * @memberof BullBullGame.CallBetRsp
         * @static
         * @param {BullBullGame.ICallBetRsp=} [properties] Properties to set
         * @returns {BullBullGame.CallBetRsp} CallBetRsp instance
         */
        CallBetRsp.create = function create(properties) {
            return new CallBetRsp(properties);
        };

        /**
         * Encodes the specified CallBetRsp message. Does not implicitly {@link BullBullGame.CallBetRsp.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.CallBetRsp
         * @static
         * @param {BullBullGame.ICallBetRsp} message CallBetRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CallBetRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.errCode);
            if (message.errMsg != null && message.hasOwnProperty("errMsg"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.errMsg);
            if (message.betScore != null && message.hasOwnProperty("betScore"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.betScore);
            return writer;
        };

        /**
         * Encodes the specified CallBetRsp message, length delimited. Does not implicitly {@link BullBullGame.CallBetRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.CallBetRsp
         * @static
         * @param {BullBullGame.ICallBetRsp} message CallBetRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CallBetRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CallBetRsp message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.CallBetRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.CallBetRsp} CallBetRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CallBetRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.CallBetRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errCode = reader.int32();
                    break;
                case 2:
                    message.errMsg = reader.string();
                    break;
                case 3:
                    message.betScore = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("errCode"))
                throw $util.ProtocolError("missing required 'errCode'", { instance: message });
            return message;
        };

        /**
         * Decodes a CallBetRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.CallBetRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.CallBetRsp} CallBetRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CallBetRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CallBetRsp message.
         * @function verify
         * @memberof BullBullGame.CallBetRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CallBetRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.errCode))
                return "errCode: integer expected";
            if (message.errMsg != null && message.hasOwnProperty("errMsg"))
                if (!$util.isString(message.errMsg))
                    return "errMsg: string expected";
            if (message.betScore != null && message.hasOwnProperty("betScore"))
                if (!$util.isInteger(message.betScore))
                    return "betScore: integer expected";
            return null;
        };

        /**
         * Creates a CallBetRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.CallBetRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.CallBetRsp} CallBetRsp
         */
        CallBetRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.CallBetRsp)
                return object;
            var message = new $root.BullBullGame.CallBetRsp();
            if (object.errCode != null)
                message.errCode = object.errCode | 0;
            if (object.errMsg != null)
                message.errMsg = String(object.errMsg);
            if (object.betScore != null)
                message.betScore = object.betScore | 0;
            return message;
        };

        /**
         * Creates a plain object from a CallBetRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.CallBetRsp
         * @static
         * @param {BullBullGame.CallBetRsp} message CallBetRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CallBetRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errCode = 0;
                object.errMsg = "";
                object.betScore = 0;
            }
            if (message.errCode != null && message.hasOwnProperty("errCode"))
                object.errCode = message.errCode;
            if (message.errMsg != null && message.hasOwnProperty("errMsg"))
                object.errMsg = message.errMsg;
            if (message.betScore != null && message.hasOwnProperty("betScore"))
                object.betScore = message.betScore;
            return object;
        };

        /**
         * Converts this CallBetRsp to JSON.
         * @function toJSON
         * @memberof BullBullGame.CallBetRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CallBetRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CallBetRsp;
    })();

    BullBullGame.CallBetBroadcast = (function() {

        /**
         * Properties of a CallBetBroadcast.
         * @memberof BullBullGame
         * @interface ICallBetBroadcast
         * @property {number} betScore CallBetBroadcast betScore
         * @property {number} betType CallBetBroadcast betType
         * @property {number} playerId CallBetBroadcast playerId
         */

        /**
         * Constructs a new CallBetBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a CallBetBroadcast.
         * @implements ICallBetBroadcast
         * @constructor
         * @param {BullBullGame.ICallBetBroadcast=} [properties] Properties to set
         */
        function CallBetBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CallBetBroadcast betScore.
         * @member {number} betScore
         * @memberof BullBullGame.CallBetBroadcast
         * @instance
         */
        CallBetBroadcast.prototype.betScore = 0;

        /**
         * CallBetBroadcast betType.
         * @member {number} betType
         * @memberof BullBullGame.CallBetBroadcast
         * @instance
         */
        CallBetBroadcast.prototype.betType = 0;

        /**
         * CallBetBroadcast playerId.
         * @member {number} playerId
         * @memberof BullBullGame.CallBetBroadcast
         * @instance
         */
        CallBetBroadcast.prototype.playerId = 0;

        /**
         * Creates a new CallBetBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.CallBetBroadcast
         * @static
         * @param {BullBullGame.ICallBetBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.CallBetBroadcast} CallBetBroadcast instance
         */
        CallBetBroadcast.create = function create(properties) {
            return new CallBetBroadcast(properties);
        };

        /**
         * Encodes the specified CallBetBroadcast message. Does not implicitly {@link BullBullGame.CallBetBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.CallBetBroadcast
         * @static
         * @param {BullBullGame.ICallBetBroadcast} message CallBetBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CallBetBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.betScore);
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.betType);
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.playerId);
            return writer;
        };

        /**
         * Encodes the specified CallBetBroadcast message, length delimited. Does not implicitly {@link BullBullGame.CallBetBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.CallBetBroadcast
         * @static
         * @param {BullBullGame.ICallBetBroadcast} message CallBetBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CallBetBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CallBetBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.CallBetBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.CallBetBroadcast} CallBetBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CallBetBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.CallBetBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.betScore = reader.int32();
                    break;
                case 2:
                    message.betType = reader.int32();
                    break;
                case 3:
                    message.playerId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("betScore"))
                throw $util.ProtocolError("missing required 'betScore'", { instance: message });
            if (!message.hasOwnProperty("betType"))
                throw $util.ProtocolError("missing required 'betType'", { instance: message });
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            return message;
        };

        /**
         * Decodes a CallBetBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.CallBetBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.CallBetBroadcast} CallBetBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CallBetBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CallBetBroadcast message.
         * @function verify
         * @memberof BullBullGame.CallBetBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CallBetBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.betScore))
                return "betScore: integer expected";
            if (!$util.isInteger(message.betType))
                return "betType: integer expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            return null;
        };

        /**
         * Creates a CallBetBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.CallBetBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.CallBetBroadcast} CallBetBroadcast
         */
        CallBetBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.CallBetBroadcast)
                return object;
            var message = new $root.BullBullGame.CallBetBroadcast();
            if (object.betScore != null)
                message.betScore = object.betScore | 0;
            if (object.betType != null)
                message.betType = object.betType | 0;
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            return message;
        };

        /**
         * Creates a plain object from a CallBetBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.CallBetBroadcast
         * @static
         * @param {BullBullGame.CallBetBroadcast} message CallBetBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CallBetBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.betScore = 0;
                object.betType = 0;
                object.playerId = 0;
            }
            if (message.betScore != null && message.hasOwnProperty("betScore"))
                object.betScore = message.betScore;
            if (message.betType != null && message.hasOwnProperty("betType"))
                object.betType = message.betType;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            return object;
        };

        /**
         * Converts this CallBetBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.CallBetBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CallBetBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CallBetBroadcast;
    })();

    BullBullGame.ZhaJinNiu_SettleAccountsBroadcast = (function() {

        /**
         * Properties of a ZhaJinNiu_SettleAccountsBroadcast.
         * @memberof BullBullGame
         * @interface IZhaJinNiu_SettleAccountsBroadcast
         * @property {Array.<BullBullGame.IZhaJinNiu_SettleAccounts>|null} [zhaJinNiuSettleAccounts] ZhaJinNiu_SettleAccountsBroadcast zhaJinNiuSettleAccounts
         */

        /**
         * Constructs a new ZhaJinNiu_SettleAccountsBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a ZhaJinNiu_SettleAccountsBroadcast.
         * @implements IZhaJinNiu_SettleAccountsBroadcast
         * @constructor
         * @param {BullBullGame.IZhaJinNiu_SettleAccountsBroadcast=} [properties] Properties to set
         */
        function ZhaJinNiu_SettleAccountsBroadcast(properties) {
            this.zhaJinNiuSettleAccounts = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ZhaJinNiu_SettleAccountsBroadcast zhaJinNiuSettleAccounts.
         * @member {Array.<BullBullGame.IZhaJinNiu_SettleAccounts>} zhaJinNiuSettleAccounts
         * @memberof BullBullGame.ZhaJinNiu_SettleAccountsBroadcast
         * @instance
         */
        ZhaJinNiu_SettleAccountsBroadcast.prototype.zhaJinNiuSettleAccounts = $util.emptyArray;

        /**
         * Creates a new ZhaJinNiu_SettleAccountsBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ZhaJinNiu_SettleAccountsBroadcast
         * @static
         * @param {BullBullGame.IZhaJinNiu_SettleAccountsBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.ZhaJinNiu_SettleAccountsBroadcast} ZhaJinNiu_SettleAccountsBroadcast instance
         */
        ZhaJinNiu_SettleAccountsBroadcast.create = function create(properties) {
            return new ZhaJinNiu_SettleAccountsBroadcast(properties);
        };

        /**
         * Encodes the specified ZhaJinNiu_SettleAccountsBroadcast message. Does not implicitly {@link BullBullGame.ZhaJinNiu_SettleAccountsBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ZhaJinNiu_SettleAccountsBroadcast
         * @static
         * @param {BullBullGame.IZhaJinNiu_SettleAccountsBroadcast} message ZhaJinNiu_SettleAccountsBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ZhaJinNiu_SettleAccountsBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.zhaJinNiuSettleAccounts != null && message.zhaJinNiuSettleAccounts.length)
                for (var i = 0; i < message.zhaJinNiuSettleAccounts.length; ++i)
                    $root.BullBullGame.ZhaJinNiu_SettleAccounts.encode(message.zhaJinNiuSettleAccounts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ZhaJinNiu_SettleAccountsBroadcast message, length delimited. Does not implicitly {@link BullBullGame.ZhaJinNiu_SettleAccountsBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ZhaJinNiu_SettleAccountsBroadcast
         * @static
         * @param {BullBullGame.IZhaJinNiu_SettleAccountsBroadcast} message ZhaJinNiu_SettleAccountsBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ZhaJinNiu_SettleAccountsBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ZhaJinNiu_SettleAccountsBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ZhaJinNiu_SettleAccountsBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ZhaJinNiu_SettleAccountsBroadcast} ZhaJinNiu_SettleAccountsBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ZhaJinNiu_SettleAccountsBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ZhaJinNiu_SettleAccountsBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.zhaJinNiuSettleAccounts && message.zhaJinNiuSettleAccounts.length))
                        message.zhaJinNiuSettleAccounts = [];
                    message.zhaJinNiuSettleAccounts.push($root.BullBullGame.ZhaJinNiu_SettleAccounts.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ZhaJinNiu_SettleAccountsBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ZhaJinNiu_SettleAccountsBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ZhaJinNiu_SettleAccountsBroadcast} ZhaJinNiu_SettleAccountsBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ZhaJinNiu_SettleAccountsBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ZhaJinNiu_SettleAccountsBroadcast message.
         * @function verify
         * @memberof BullBullGame.ZhaJinNiu_SettleAccountsBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ZhaJinNiu_SettleAccountsBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.zhaJinNiuSettleAccounts != null && message.hasOwnProperty("zhaJinNiuSettleAccounts")) {
                if (!Array.isArray(message.zhaJinNiuSettleAccounts))
                    return "zhaJinNiuSettleAccounts: array expected";
                for (var i = 0; i < message.zhaJinNiuSettleAccounts.length; ++i) {
                    var error = $root.BullBullGame.ZhaJinNiu_SettleAccounts.verify(message.zhaJinNiuSettleAccounts[i]);
                    if (error)
                        return "zhaJinNiuSettleAccounts." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ZhaJinNiu_SettleAccountsBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ZhaJinNiu_SettleAccountsBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ZhaJinNiu_SettleAccountsBroadcast} ZhaJinNiu_SettleAccountsBroadcast
         */
        ZhaJinNiu_SettleAccountsBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ZhaJinNiu_SettleAccountsBroadcast)
                return object;
            var message = new $root.BullBullGame.ZhaJinNiu_SettleAccountsBroadcast();
            if (object.zhaJinNiuSettleAccounts) {
                if (!Array.isArray(object.zhaJinNiuSettleAccounts))
                    throw TypeError(".BullBullGame.ZhaJinNiu_SettleAccountsBroadcast.zhaJinNiuSettleAccounts: array expected");
                message.zhaJinNiuSettleAccounts = [];
                for (var i = 0; i < object.zhaJinNiuSettleAccounts.length; ++i) {
                    if (typeof object.zhaJinNiuSettleAccounts[i] !== "object")
                        throw TypeError(".BullBullGame.ZhaJinNiu_SettleAccountsBroadcast.zhaJinNiuSettleAccounts: object expected");
                    message.zhaJinNiuSettleAccounts[i] = $root.BullBullGame.ZhaJinNiu_SettleAccounts.fromObject(object.zhaJinNiuSettleAccounts[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ZhaJinNiu_SettleAccountsBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ZhaJinNiu_SettleAccountsBroadcast
         * @static
         * @param {BullBullGame.ZhaJinNiu_SettleAccountsBroadcast} message ZhaJinNiu_SettleAccountsBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ZhaJinNiu_SettleAccountsBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.zhaJinNiuSettleAccounts = [];
            if (message.zhaJinNiuSettleAccounts && message.zhaJinNiuSettleAccounts.length) {
                object.zhaJinNiuSettleAccounts = [];
                for (var j = 0; j < message.zhaJinNiuSettleAccounts.length; ++j)
                    object.zhaJinNiuSettleAccounts[j] = $root.BullBullGame.ZhaJinNiu_SettleAccounts.toObject(message.zhaJinNiuSettleAccounts[j], options);
            }
            return object;
        };

        /**
         * Converts this ZhaJinNiu_SettleAccountsBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.ZhaJinNiu_SettleAccountsBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ZhaJinNiu_SettleAccountsBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ZhaJinNiu_SettleAccountsBroadcast;
    })();

    BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast = (function() {

        /**
         * Properties of a ZhaJinNiu_AgoSettleAccountsBroadcast.
         * @memberof BullBullGame
         * @interface IZhaJinNiu_AgoSettleAccountsBroadcast
         * @property {Array.<BullBullGame.IZhaJinNiu_SettleAccounts>|null} [zhaJinNiuSettleAccounts] ZhaJinNiu_AgoSettleAccountsBroadcast zhaJinNiuSettleAccounts
         * @property {Array.<number>|null} [curRoundBetScoreList] ZhaJinNiu_AgoSettleAccountsBroadcast curRoundBetScoreList
         * @property {number} curBetRoundNum ZhaJinNiu_AgoSettleAccountsBroadcast curBetRoundNum
         */

        /**
         * Constructs a new ZhaJinNiu_AgoSettleAccountsBroadcast.
         * @memberof BullBullGame
         * @classdesc Represents a ZhaJinNiu_AgoSettleAccountsBroadcast.
         * @implements IZhaJinNiu_AgoSettleAccountsBroadcast
         * @constructor
         * @param {BullBullGame.IZhaJinNiu_AgoSettleAccountsBroadcast=} [properties] Properties to set
         */
        function ZhaJinNiu_AgoSettleAccountsBroadcast(properties) {
            this.zhaJinNiuSettleAccounts = [];
            this.curRoundBetScoreList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ZhaJinNiu_AgoSettleAccountsBroadcast zhaJinNiuSettleAccounts.
         * @member {Array.<BullBullGame.IZhaJinNiu_SettleAccounts>} zhaJinNiuSettleAccounts
         * @memberof BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast
         * @instance
         */
        ZhaJinNiu_AgoSettleAccountsBroadcast.prototype.zhaJinNiuSettleAccounts = $util.emptyArray;

        /**
         * ZhaJinNiu_AgoSettleAccountsBroadcast curRoundBetScoreList.
         * @member {Array.<number>} curRoundBetScoreList
         * @memberof BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast
         * @instance
         */
        ZhaJinNiu_AgoSettleAccountsBroadcast.prototype.curRoundBetScoreList = $util.emptyArray;

        /**
         * ZhaJinNiu_AgoSettleAccountsBroadcast curBetRoundNum.
         * @member {number} curBetRoundNum
         * @memberof BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast
         * @instance
         */
        ZhaJinNiu_AgoSettleAccountsBroadcast.prototype.curBetRoundNum = 0;

        /**
         * Creates a new ZhaJinNiu_AgoSettleAccountsBroadcast instance using the specified properties.
         * @function create
         * @memberof BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast
         * @static
         * @param {BullBullGame.IZhaJinNiu_AgoSettleAccountsBroadcast=} [properties] Properties to set
         * @returns {BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast} ZhaJinNiu_AgoSettleAccountsBroadcast instance
         */
        ZhaJinNiu_AgoSettleAccountsBroadcast.create = function create(properties) {
            return new ZhaJinNiu_AgoSettleAccountsBroadcast(properties);
        };

        /**
         * Encodes the specified ZhaJinNiu_AgoSettleAccountsBroadcast message. Does not implicitly {@link BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast
         * @static
         * @param {BullBullGame.IZhaJinNiu_AgoSettleAccountsBroadcast} message ZhaJinNiu_AgoSettleAccountsBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ZhaJinNiu_AgoSettleAccountsBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.zhaJinNiuSettleAccounts != null && message.zhaJinNiuSettleAccounts.length)
                for (var i = 0; i < message.zhaJinNiuSettleAccounts.length; ++i)
                    $root.BullBullGame.ZhaJinNiu_SettleAccounts.encode(message.zhaJinNiuSettleAccounts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.curRoundBetScoreList != null && message.curRoundBetScoreList.length)
                for (var i = 0; i < message.curRoundBetScoreList.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.curRoundBetScoreList[i]);
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.curBetRoundNum);
            return writer;
        };

        /**
         * Encodes the specified ZhaJinNiu_AgoSettleAccountsBroadcast message, length delimited. Does not implicitly {@link BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast
         * @static
         * @param {BullBullGame.IZhaJinNiu_AgoSettleAccountsBroadcast} message ZhaJinNiu_AgoSettleAccountsBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ZhaJinNiu_AgoSettleAccountsBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ZhaJinNiu_AgoSettleAccountsBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast} ZhaJinNiu_AgoSettleAccountsBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ZhaJinNiu_AgoSettleAccountsBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.zhaJinNiuSettleAccounts && message.zhaJinNiuSettleAccounts.length))
                        message.zhaJinNiuSettleAccounts = [];
                    message.zhaJinNiuSettleAccounts.push($root.BullBullGame.ZhaJinNiu_SettleAccounts.decode(reader, reader.uint32()));
                    break;
                case 2:
                    if (!(message.curRoundBetScoreList && message.curRoundBetScoreList.length))
                        message.curRoundBetScoreList = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.curRoundBetScoreList.push(reader.int32());
                    } else
                        message.curRoundBetScoreList.push(reader.int32());
                    break;
                case 3:
                    message.curBetRoundNum = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("curBetRoundNum"))
                throw $util.ProtocolError("missing required 'curBetRoundNum'", { instance: message });
            return message;
        };

        /**
         * Decodes a ZhaJinNiu_AgoSettleAccountsBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast} ZhaJinNiu_AgoSettleAccountsBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ZhaJinNiu_AgoSettleAccountsBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ZhaJinNiu_AgoSettleAccountsBroadcast message.
         * @function verify
         * @memberof BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ZhaJinNiu_AgoSettleAccountsBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.zhaJinNiuSettleAccounts != null && message.hasOwnProperty("zhaJinNiuSettleAccounts")) {
                if (!Array.isArray(message.zhaJinNiuSettleAccounts))
                    return "zhaJinNiuSettleAccounts: array expected";
                for (var i = 0; i < message.zhaJinNiuSettleAccounts.length; ++i) {
                    var error = $root.BullBullGame.ZhaJinNiu_SettleAccounts.verify(message.zhaJinNiuSettleAccounts[i]);
                    if (error)
                        return "zhaJinNiuSettleAccounts." + error;
                }
            }
            if (message.curRoundBetScoreList != null && message.hasOwnProperty("curRoundBetScoreList")) {
                if (!Array.isArray(message.curRoundBetScoreList))
                    return "curRoundBetScoreList: array expected";
                for (var i = 0; i < message.curRoundBetScoreList.length; ++i)
                    if (!$util.isInteger(message.curRoundBetScoreList[i]))
                        return "curRoundBetScoreList: integer[] expected";
            }
            if (!$util.isInteger(message.curBetRoundNum))
                return "curBetRoundNum: integer expected";
            return null;
        };

        /**
         * Creates a ZhaJinNiu_AgoSettleAccountsBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast} ZhaJinNiu_AgoSettleAccountsBroadcast
         */
        ZhaJinNiu_AgoSettleAccountsBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast)
                return object;
            var message = new $root.BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast();
            if (object.zhaJinNiuSettleAccounts) {
                if (!Array.isArray(object.zhaJinNiuSettleAccounts))
                    throw TypeError(".BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast.zhaJinNiuSettleAccounts: array expected");
                message.zhaJinNiuSettleAccounts = [];
                for (var i = 0; i < object.zhaJinNiuSettleAccounts.length; ++i) {
                    if (typeof object.zhaJinNiuSettleAccounts[i] !== "object")
                        throw TypeError(".BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast.zhaJinNiuSettleAccounts: object expected");
                    message.zhaJinNiuSettleAccounts[i] = $root.BullBullGame.ZhaJinNiu_SettleAccounts.fromObject(object.zhaJinNiuSettleAccounts[i]);
                }
            }
            if (object.curRoundBetScoreList) {
                if (!Array.isArray(object.curRoundBetScoreList))
                    throw TypeError(".BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast.curRoundBetScoreList: array expected");
                message.curRoundBetScoreList = [];
                for (var i = 0; i < object.curRoundBetScoreList.length; ++i)
                    message.curRoundBetScoreList[i] = object.curRoundBetScoreList[i] | 0;
            }
            if (object.curBetRoundNum != null)
                message.curBetRoundNum = object.curBetRoundNum | 0;
            return message;
        };

        /**
         * Creates a plain object from a ZhaJinNiu_AgoSettleAccountsBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast
         * @static
         * @param {BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast} message ZhaJinNiu_AgoSettleAccountsBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ZhaJinNiu_AgoSettleAccountsBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.zhaJinNiuSettleAccounts = [];
                object.curRoundBetScoreList = [];
            }
            if (options.defaults)
                object.curBetRoundNum = 0;
            if (message.zhaJinNiuSettleAccounts && message.zhaJinNiuSettleAccounts.length) {
                object.zhaJinNiuSettleAccounts = [];
                for (var j = 0; j < message.zhaJinNiuSettleAccounts.length; ++j)
                    object.zhaJinNiuSettleAccounts[j] = $root.BullBullGame.ZhaJinNiu_SettleAccounts.toObject(message.zhaJinNiuSettleAccounts[j], options);
            }
            if (message.curRoundBetScoreList && message.curRoundBetScoreList.length) {
                object.curRoundBetScoreList = [];
                for (var j = 0; j < message.curRoundBetScoreList.length; ++j)
                    object.curRoundBetScoreList[j] = message.curRoundBetScoreList[j];
            }
            if (message.curBetRoundNum != null && message.hasOwnProperty("curBetRoundNum"))
                object.curBetRoundNum = message.curBetRoundNum;
            return object;
        };

        /**
         * Converts this ZhaJinNiu_AgoSettleAccountsBroadcast to JSON.
         * @function toJSON
         * @memberof BullBullGame.ZhaJinNiu_AgoSettleAccountsBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ZhaJinNiu_AgoSettleAccountsBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ZhaJinNiu_AgoSettleAccountsBroadcast;
    })();

    BullBullGame.AckReq = (function() {

        /**
         * Properties of an AckReq.
         * @memberof BullBullGame
         * @interface IAckReq
         * @property {number|null} [ackId] AckReq ackId
         */

        /**
         * Constructs a new AckReq.
         * @memberof BullBullGame
         * @classdesc Represents an AckReq.
         * @implements IAckReq
         * @constructor
         * @param {BullBullGame.IAckReq=} [properties] Properties to set
         */
        function AckReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AckReq ackId.
         * @member {number} ackId
         * @memberof BullBullGame.AckReq
         * @instance
         */
        AckReq.prototype.ackId = 0;

        /**
         * Creates a new AckReq instance using the specified properties.
         * @function create
         * @memberof BullBullGame.AckReq
         * @static
         * @param {BullBullGame.IAckReq=} [properties] Properties to set
         * @returns {BullBullGame.AckReq} AckReq instance
         */
        AckReq.create = function create(properties) {
            return new AckReq(properties);
        };

        /**
         * Encodes the specified AckReq message. Does not implicitly {@link BullBullGame.AckReq.verify|verify} messages.
         * @function encode
         * @memberof BullBullGame.AckReq
         * @static
         * @param {BullBullGame.IAckReq} message AckReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AckReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ackId);
            return writer;
        };

        /**
         * Encodes the specified AckReq message, length delimited. Does not implicitly {@link BullBullGame.AckReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof BullBullGame.AckReq
         * @static
         * @param {BullBullGame.IAckReq} message AckReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AckReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AckReq message from the specified reader or buffer.
         * @function decode
         * @memberof BullBullGame.AckReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {BullBullGame.AckReq} AckReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AckReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BullBullGame.AckReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ackId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AckReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof BullBullGame.AckReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {BullBullGame.AckReq} AckReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AckReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AckReq message.
         * @function verify
         * @memberof BullBullGame.AckReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AckReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                if (!$util.isInteger(message.ackId))
                    return "ackId: integer expected";
            return null;
        };

        /**
         * Creates an AckReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof BullBullGame.AckReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {BullBullGame.AckReq} AckReq
         */
        AckReq.fromObject = function fromObject(object) {
            if (object instanceof $root.BullBullGame.AckReq)
                return object;
            var message = new $root.BullBullGame.AckReq();
            if (object.ackId != null)
                message.ackId = object.ackId | 0;
            return message;
        };

        /**
         * Creates a plain object from an AckReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof BullBullGame.AckReq
         * @static
         * @param {BullBullGame.AckReq} message AckReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AckReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.ackId = 0;
            if (message.ackId != null && message.hasOwnProperty("ackId"))
                object.ackId = message.ackId;
            return object;
        };

        /**
         * Converts this AckReq to JSON.
         * @function toJSON
         * @memberof BullBullGame.AckReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AckReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AckReq;
    })();

    return BullBullGame;
})();

module.exports = $root;
